import React from 'react';
import './OldHome.css';

function OldHome() {
  return (
    <div className="page-oldhome">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="123"
            height="38"
            viewBox="0 0 123 38"
            fill="none"
            id="svg816079972_6100"
          >
            <path
              d="M110.492 15.5607C113.029 15.5607 115.074 17.9933 115.104 21.0229C115.104 21.0379 115.104 21.0677 115.104 21.0826C115.104 21.1125 115.104 21.1423 115.104 21.1572C115.074 24.1869 113.029 26.6195 110.492 26.6195C110.358 26.6195 110.224 26.6195 110.074 26.6046L110.059 26.5897C109 26.4703 108.194 25.5748 108.194 24.5003V23.8585H107.269V25.0375V26.6195V28.8992L104.045 31.2311V21.0826V15.5607H107.269V17.1426V18.3216H108.194V17.6799C108.194 16.6054 109 15.695 110.059 15.5756H110.074C110.224 15.5607 110.358 15.5607 110.492 15.5607ZM109.552 23.3959C110.835 23.4108 111.88 22.3661 111.88 21.0826C111.88 19.8141 110.835 18.7694 109.552 18.7843C108.313 18.7992 107.283 19.8141 107.269 21.0677V21.0826C107.269 21.0976 107.269 21.0976 107.269 21.1125C107.283 22.3661 108.313 23.381 109.552 23.3959Z"
              fill="#030319"
            />
            <path
              d="M97.3396 15.5607C100.384 15.5607 102.862 18.0381 102.862 21.0826C102.862 24.1421 100.384 26.6195 97.3396 26.6195C94.2802 26.6195 91.8027 24.1421 91.8027 21.0826C91.8027 18.0381 94.2802 15.5607 97.3396 15.5607ZM97.3396 23.3959C98.6082 23.3959 99.638 22.3661 99.638 21.0826C99.638 19.8141 98.6082 18.7843 97.3396 18.7843C96.0561 18.7843 95.0264 19.8141 95.0264 21.0826C95.0264 22.3661 96.0561 23.3959 97.3396 23.3959Z"
              fill="#030319"
            />
            <path
              d="M82.8242 26.6196V13.2811L86.0479 10.9492V26.6196H82.8242ZM87.4358 26.6196V13.0255L90.6595 10.6936V26.6196H87.4358Z"
              fill="#030319"
            />
            <path
              d="M78.4173 17.1426V15.5607H81.6409V21.0826V26.6195H78.4173V25.0375V23.8585H77.492V24.5003C77.492 25.5748 76.701 26.4703 75.6264 26.5897H75.6115C75.4772 26.6046 75.3279 26.6195 75.1936 26.6195C72.6714 26.6195 70.6119 24.1869 70.582 21.1572C70.582 21.1274 70.582 21.1125 70.582 21.0826C70.582 21.0677 70.582 21.0379 70.582 21.008C70.6119 17.9933 72.6714 15.5607 75.1936 15.5607C75.3279 15.5607 75.4772 15.5607 75.6115 15.5756H75.6264C76.701 15.695 77.492 16.6054 77.492 17.6799V18.3216H78.4173V17.1426ZM78.4173 21.1125C78.4173 21.0976 78.4173 21.0976 78.4173 21.0826V21.0677C78.4023 19.8141 77.3875 18.7992 76.1339 18.7843C74.8504 18.7694 73.8057 19.8141 73.8057 21.0826C73.8057 22.3661 74.8504 23.3959 76.1339 23.3959C77.3875 23.381 78.4023 22.3512 78.4173 21.1125Z"
              fill="#030319"
            />
            <path
              d="M63.9939 18.7843C62.7104 18.7843 61.6807 19.8141 61.6807 21.0826C61.6807 22.3661 62.7104 23.3959 63.9939 23.3959C64.9342 23.3959 65.755 22.8288 66.0983 22.0079H69.4413C69.0085 24.6197 66.7251 26.6195 63.9939 26.6195C60.9345 26.6195 58.457 24.1421 58.457 21.0826C58.457 18.0381 60.9345 15.5607 63.9939 15.5607C66.7251 15.5607 69.0085 17.5456 69.4413 20.1723H66.0983C65.755 19.3514 64.9342 18.7843 63.9939 18.7843Z"
              fill="#030319"
            />
            <path
              d="M51.147 14.2098C48.8849 14.2098 47.9664 14.9538 47.9664 15.9209C47.9664 17.7512 57.289 16.531 57.289 21.6943C57.289 22.4383 56.3019 26.6195 50.7083 26.6195C46.993 26.6195 45.389 24.5066 44.676 23.5692L44.5801 23.4501L47.0286 21.6642C47.0286 21.6642 48.1995 23.4055 50.7083 23.4055C52.9842 23.4055 53.9027 22.6615 53.9027 21.6943C53.9027 19.8194 44.5801 21.114 44.5801 15.9209C44.5801 15.177 45.5672 10.9957 51.147 10.9957C54.8761 10.9957 56.4801 13.1087 57.193 14.0461L57.289 14.1651L54.8405 15.8927C54.8405 15.8927 53.6696 14.2098 51.147 14.2098Z"
              fill="#030319"
            />
            <ellipse
              cx="23"
              cy="19"
              rx="15"
              ry="15"
              fill="url(#svg816079972_6100_paint0_linear_1843_2648)"
            />
            <path
              d="M23.8686 6.20818C25.6572 6.1227 27.786 6.71181 29.3396 7.56256C32.3183 9.18677 34.5145 11.9451 35.43 15.2116C36.3301 18.4187 35.9272 21.8514 34.3083 24.7626C32.7099 27.6981 29.9987 29.8681 26.7842 30.7844C26.6788 30.8142 26.6203 30.8344 26.5266 30.7821C26.515 30.6967 26.853 30.3517 26.9348 30.2556C27.557 29.5253 27.871 28.8496 28.1737 27.9615C28.4236 27.8146 28.6634 27.6511 28.8917 27.4725C31.2565 25.6129 32.7956 22.8986 33.1775 19.915C33.5763 16.8193 32.785 14.006 30.8877 11.547C30.3077 10.8311 29.6398 10.1911 28.8998 9.64197C27.5786 8.66456 26.0608 8.03962 24.4056 7.96902C23.3727 7.92493 22.4276 8.07396 21.7794 8.98746C21.5028 9.3808 21.3376 9.84162 21.3014 10.3211C21.1538 12.0687 22.5229 13.3746 23.6942 14.4706C24.352 15.0823 25.0527 15.6697 25.7162 16.2736C27.3223 17.7354 29.0651 19.3387 29.3925 21.6013C29.5584 22.7478 29.4241 23.8924 29.0227 24.9808C28.957 25.1592 28.8588 25.4866 28.7515 25.6369L28.7163 25.6403C28.6692 25.5381 28.5827 25.0116 28.5401 24.8449C28.4323 24.424 28.2806 23.9998 28.0835 23.6085C26.8632 21.1858 24.5096 19.4897 22.5685 17.6416C20.7234 15.8848 18.8528 14.1626 18.7043 11.4216C18.6336 10.1175 19.0991 8.78923 19.9928 7.84078C21.0344 6.7353 22.3712 6.25394 23.8686 6.20818Z"
              fill="white"
            />
            <path
              d="M22.0298 31.7061C20.2412 31.7916 18.1125 31.2025 16.5589 30.3517C13.5801 28.7275 11.384 25.9692 10.4685 22.7027C9.56834 19.4956 9.97126 16.0629 11.5902 13.1517C13.1885 10.2162 15.8998 8.04624 19.1143 7.12992C19.2197 7.10008 19.2782 7.07996 19.3719 7.13218C19.3834 7.21764 19.0454 7.56265 18.9636 7.65873C18.3415 8.38898 18.0275 9.06475 17.7248 9.9528C17.4749 10.0998 17.235 10.2632 17.0068 10.4418C14.6419 12.3014 13.1028 15.0157 12.7209 17.9994C12.3221 21.095 13.1135 23.9083 15.0107 26.3673C15.5907 27.0832 16.2586 27.7232 16.9986 28.2723C18.3198 29.2497 19.8377 29.8747 21.4928 29.9453C22.5257 29.9894 23.4708 29.8403 24.119 28.9269C24.3957 28.5335 24.5609 28.0727 24.5971 27.5932C24.7447 25.8456 23.3756 24.5397 22.2043 23.4437C21.5465 22.832 20.8457 22.2446 20.1822 21.6407C18.5761 20.1789 16.8334 18.5756 16.506 16.313C16.34 15.1665 16.4743 14.0219 16.8757 12.9335C16.9415 12.7551 17.0396 12.4277 17.1469 12.2774L17.1821 12.274C17.2292 12.3762 17.3157 12.9027 17.3584 13.0694C17.4662 13.4903 17.6178 13.9145 17.8149 14.3058C19.0352 16.7285 21.3889 18.4246 23.3299 20.2727C25.175 22.0295 27.0457 23.7517 27.1942 26.4927C27.2648 27.7968 26.7993 29.1251 25.9057 30.0735C24.8641 31.179 23.5272 31.6604 22.0298 31.7061Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg816079972_6100_paint0_linear_1843_2648"
                x1="23"
                y1="4"
                x2="15.0541"
                y2="31.4582"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg-726352421_1977"
          >
            <rect width="40" height="40" rx="20" fill="#E8E8E8" />
            <path
              d="M29.1681 28.6838C19.0481 33.5 12.7675 29.4704 8.74716 27.0229C8.49838 26.8686 8.07555 27.0589 8.44242 27.4803C9.78181 29.1044 14.1713 33.0188 19.9008 33.0188C25.6343 33.0188 29.0452 29.8903 29.4718 29.3446C29.8956 28.8035 29.5963 28.505 29.168 28.6838H29.1681ZM32.0102 27.1141C31.7385 26.7603 30.3577 26.6943 29.4888 26.801C28.6185 26.9047 27.3122 27.4366 27.4257 27.756C27.484 27.8756 27.603 27.8219 28.2008 27.7682C28.8003 27.7084 30.4798 27.4964 30.8297 27.9539C31.1813 28.4145 30.2941 30.6088 30.132 30.9627C29.9755 31.3166 30.1918 31.4078 30.4859 31.1721C30.7759 30.9365 31.301 30.3264 31.6534 29.4629C32.0033 28.5947 32.2168 27.3836 32.0102 27.1141Z"
              fill="#FF9900"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.3635 18.8562C22.3635 20.1199 22.3955 21.1738 21.7567 22.2961C21.2412 23.2086 20.4246 23.7697 19.5121 23.7697C18.2666 23.7697 17.5412 22.8207 17.5412 21.4202C17.5412 18.6554 20.0184 18.1537 22.3635 18.1537V18.8562ZM25.6346 26.7626C25.4201 26.9541 25.1099 26.9679 24.8682 26.8401C23.7915 25.9459 23.5998 25.5308 23.0068 24.6776C21.2275 26.4934 19.9683 27.0362 17.6599 27.0362C14.9317 27.0362 12.8057 25.3528 12.8057 21.9813C12.8057 19.349 14.2337 17.556 16.2638 16.6801C18.0248 15.9044 20.4839 15.7676 22.3635 15.5532V15.1335C22.3635 14.3624 22.4228 13.45 21.9712 12.784C21.5742 12.1863 20.8169 11.9399 20.1508 11.9399C18.9145 11.9399 17.8104 12.574 17.5412 13.888C17.4864 14.18 17.2721 14.4674 16.9801 14.4811L13.8321 14.1436C13.5676 14.0841 13.2756 13.8698 13.3486 13.4637C14.074 9.64975 17.5183 8.5 20.6024 8.5C22.1809 8.5 24.243 8.91976 25.4885 10.1151C27.0671 11.5886 26.9165 13.5549 26.9165 15.6946V20.7495C26.9165 22.2688 27.5461 22.9348 28.1391 23.7561C28.349 24.048 28.3946 24.3994 28.13 24.6183C27.4685 25.1703 26.2914 26.1968 25.6436 26.7717L25.6346 26.7626Z"
              fill="black"
            />
          </svg>
          <svg
            width="52"
            height="56"
            viewBox="0 0 52 56"
            fill="none"
            id="svg764373717_1237"
          >
            <path
              d="M4.1178 43.9966C6.70645 44.1861 9.19117 44.3576 11.6734 44.5383C12.1685 44.5721 12.5179 44.5965 13.1315 44.7412C13.5884 44.8438 14.5526 45.0824 14.3386 45.549C14.1216 45.9159 13.9208 46.1488 13.0542 46.1736C10.8158 46.2263 8.58772 45.9456 6.37559 45.6791C4.42238 45.4424 2.9366 45.2321 1.2209 44.9207C0.419624 44.7752 0.20983 44.3038 0.494828 43.6091C0.750833 42.9857 1.00256 42.3414 1.37105 41.7778C2.68853 39.7385 4.05394 37.7418 5.40585 35.7216C5.57222 35.4696 5.68687 35.2631 5.9277 34.9915C6.22271 34.6653 6.41922 34.4115 6.78617 34.6284C7.13714 34.8312 6.97041 35.3797 6.83171 35.6391C5.72009 37.8323 3.35158 42.3184 3.27991 42.5858C4.69575 42.1348 6.01556 41.7471 7.31578 41.2848C16.3552 38.0228 25.0854 34.1441 32.7865 28.24C38.8826 23.5665 44.3202 18.2519 48.9332 12.1036C49.208 11.7422 49.5172 11.4 49.8214 11.0762C50.2273 10.6314 50.5172 10.4718 50.7617 10.6659C51.1715 11.092 50.973 11.4639 50.8404 11.7743C50.5844 12.3977 50.1925 12.9748 49.8148 13.5359C44.6841 20.9889 38.103 26.9559 30.7091 32.0823C23.1207 37.3445 14.6704 40.6952 5.9054 43.3388C5.43779 43.4606 4.30986 43.8701 4.1178 43.9966Z"
              fill="black"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="-1 -1 14 14"
            fill="none"
            id="svg-738554790_445"
          >
            <path
              d="M0.461426 11.5386H11.5383M1.07681 4.76936V11.5386M10.923 4.76936V11.5386M3.53835 7.2309V9.07705M5.99989 7.2309V9.07705M8.46143 7.2309V9.07705M5.99989 2.92321H6.00604M0.461426 4.76936H11.5383V2.92321L5.99989 0.46167L0.461426 2.92321V4.76936Z"
              stroke="#2563EB"
              strokeWidth={1.22948}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="14"
            height="7"
            viewBox="-1 -1 14 7"
            fill="none"
            id="svg95803052_220"
          >
            <path
              opacity="0.12"
              d="M11.5383 2.92321L5.99989 0.46167L0.461426 2.92321V4.76936H11.5383V2.92321Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="59"
            height="61"
            viewBox="0 0 59 61"
            fill="none"
            id="svg147118731_1233"
          >
            <path
              d="M33.2756 3.78131C31.3111 5.47779 29.4329 7.11348 27.5499 8.74089C27.1759 9.06708 26.9116 9.29684 26.3754 9.62848C25.9797 9.87896 25.1293 10.392 24.9507 9.91078C24.8446 9.49791 24.8219 9.19126 25.4172 8.56089C26.9627 6.9409 28.7367 5.56386 30.4894 4.18811C32.0379 2.97434 33.2372 2.07243 34.6706 1.07947C35.34 0.615768 35.8217 0.800754 36.1114 1.49351C36.3712 2.11533 36.6488 2.74891 36.7867 3.408C37.2971 5.78157 37.7436 8.15898 38.2161 10.5434C38.2766 10.8392 38.3416 11.0663 38.3633 11.4286C38.3854 11.8679 38.4259 12.1864 38.013 12.2924C37.6215 12.3972 37.3516 11.8915 37.2662 11.61C36.5014 9.27309 35.0041 4.4262 34.8656 4.18639C34.1834 5.50645 33.5243 6.71389 32.9318 7.96012C28.8465 16.6586 25.416 25.5744 24.1454 35.1948C23.1394 42.81 23.0524 50.4129 24.138 58.0224C24.1993 58.4722 24.2226 58.9328 24.2365 59.3769C24.264 59.9784 24.1719 60.2962 23.8617 60.3319C23.2707 60.3204 23.1481 59.917 23.0223 59.6037C22.7625 58.9819 22.6316 58.2968 22.5019 57.6329C20.8598 48.7349 21.294 39.862 22.8973 31.0088C24.5423 21.9221 28.1482 13.5776 32.4767 5.5105C32.7212 5.09369 33.2292 4.00655 33.2756 3.78131Z"
              fill="black"
            />
          </svg>
          <svg
            width="14"
            height="11"
            viewBox="-1 -1 14 11"
            fill="none"
            id="svg-212988539_408"
          >
            <path
              opacity="0.12"
              d="M1.69171 8.53839H10.3071C10.9868 8.53839 11.5379 7.99421 11.5379 7.32293V1.24561C11.5379 0.574333 10.9868 0.0301514 10.3071 0.0301514H1.69171C1.01197 0.0301514 0.460938 0.574333 0.460938 1.24561V3.06881V7.32293C0.460938 7.99421 1.01197 8.53839 1.69171 8.53839Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="-1 -1 14 14"
            fill="none"
            id="svg-1448888000_2617"
          >
            <path
              d="M1.3025 2.75332L1.11028 2.16941H1.11028L1.3025 2.75332ZM8.07174 0.524975L8.26395 1.10889L8.07174 0.524975ZM8.76863 6.66973C8.42912 6.66973 8.15389 6.94496 8.15389 7.28448C8.15389 7.62399 8.42912 7.89922 8.76863 7.89922V6.66973ZM8.77478 7.89922C9.1143 7.89922 9.38953 7.62399 9.38953 7.28448C9.38953 6.94496 9.1143 6.66973 8.77478 6.66973V7.89922ZM10.3071 11.5386V10.9239H1.69171V11.5386V12.1533H10.3071V11.5386ZM0.460938 10.3231H1.07568V6.06901H0.460938H-0.153804V10.3231H0.460938ZM0.460938 6.06901H1.07568V4.24582H0.460938H-0.153804V6.06901H0.460938ZM1.69171 11.5386V10.9239C1.34421 10.9239 1.07568 10.6477 1.07568 10.3231H0.460938H-0.153804C-0.153804 11.3412 0.679735 12.1533 1.69171 12.1533V11.5386ZM1.69171 3.03036V2.41561C0.679735 2.41561 -0.153804 3.22779 -0.153804 4.24582H0.460938H1.07568C1.07568 3.92128 1.34421 3.6451 1.69171 3.6451V3.03036ZM10.3071 11.5386V12.1533C11.3191 12.1533 12.1526 11.3412 12.1526 10.3231H11.5379H10.9231C10.9231 10.6477 10.6546 10.9239 10.3071 10.9239V11.5386ZM11.5379 4.24582H12.1526C12.1526 3.2278 11.3191 2.41561 10.3071 2.41561V3.03036V3.6451C10.6546 3.6451 10.9231 3.92128 10.9231 4.24582H11.5379ZM9.69171 1.67806H9.07697V2.78204H9.69171H10.3064V1.67806H9.69171ZM0.460938 6.06901H1.07568V3.90641H0.460938H-0.153804V6.06901H0.460938ZM1.3025 2.75332L1.49472 3.33724L8.26395 1.10889L8.07174 0.524975L7.87952 -0.058942L1.11028 2.16941L1.3025 2.75332ZM0.460938 3.90641H1.07568C1.07568 3.65281 1.24035 3.42098 1.49472 3.33724L1.3025 2.75332L1.11028 2.16941C0.359503 2.41655 -0.153804 3.11367 -0.153804 3.90641H0.460938ZM9.69171 1.67806H10.3064C10.3064 0.418947 9.06374 -0.448774 7.87952 -0.058942L8.07174 0.524975L8.26395 1.10889C8.67365 0.974025 9.07697 1.27794 9.07697 1.67806H9.69171ZM8.76863 7.28448V7.89922H8.77478V7.28448V6.66973H8.76863V7.28448ZM9.07632 7.28448H8.46158C8.46158 7.10555 8.60633 6.9736 8.76863 6.9736V7.58834V8.20308C9.2708 8.20308 9.69106 7.79904 9.69106 7.28448H9.07632ZM8.76863 7.58834V6.9736C8.93093 6.9736 9.07568 7.10555 9.07568 7.28448H8.46094H7.8462C7.8462 7.79904 8.26646 8.20308 8.76863 8.20308V7.58834ZM8.46094 7.28448H9.07568C9.07568 7.4634 8.93093 7.59535 8.76863 7.59535V6.98061V6.36587C8.26646 6.36587 7.8462 6.76991 7.8462 7.28448H8.46094ZM8.76863 6.98061V7.59535C8.60633 7.59535 8.46158 7.4634 8.46158 7.28448H9.07632H9.69106C9.69106 6.76991 9.2708 6.36587 8.76863 6.36587V6.98061ZM11.5379 10.3231H12.1526V4.24582H11.5379H10.9231V10.3231H11.5379ZM10.3071 3.03036V2.41561H1.69171V3.03036V3.6451H10.3071V3.03036Z"
              fill="#2563EB"
            />
          </svg>
          <svg viewBox="0 0 180 60" overflow="visible" id="svg1322499166_10645">
            <g>
              <path d="M 0 60 L 0 0 L 180 0 L 180 60 Z" fill="transparent" />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 122.291 28.802 L 122.291 32.239 L 120.137 32.239 L 120.137 34.492 L 122.291 34.492 L 122.291 42.15 C 122.291 44.764 123.474 45.81 126.449 45.81 C 126.972 45.81 127.471 45.748 127.906 45.673 L 127.906 43.445 C 127.533 43.482 127.296 43.507 126.885 43.507 C 125.553 43.507 124.968 42.884 124.968 41.465 L 124.968 34.492 L 127.906 34.492 L 127.906 32.239 L 124.968 32.239 L 124.968 28.802 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 135.486 45.997 C 139.445 45.997 141.873 43.345 141.873 38.95 C 141.873 34.579 139.433 31.915 135.486 31.915 C 131.526 31.915 129.086 34.579 129.086 38.95 C 129.086 43.345 131.514 45.997 135.486 45.997 Z M 135.486 43.619 C 133.158 43.619 131.85 41.913 131.85 38.95 C 131.85 36.011 133.158 34.293 135.486 34.293 C 137.802 34.293 139.122 36.011 139.122 38.95 C 139.122 41.901 137.802 43.619 135.486 43.619 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.949 45.736 L 146.626 45.736 L 146.626 37.73 C 146.626 35.825 148.058 34.542 150.088 34.542 C 150.56 34.542 151.358 34.629 151.582 34.704 L 151.582 32.064 C 151.295 31.989 150.785 31.952 150.386 31.952 C 148.618 31.952 147.112 32.923 146.726 34.256 L 146.527 34.256 L 146.527 32.176 L 143.949 32.176 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 158.229 34.193 C 160.209 34.193 161.504 35.575 161.567 37.705 L 154.718 37.705 C 154.868 35.588 156.249 34.193 158.229 34.193 Z M 161.555 42.075 C 161.057 43.133 159.948 43.719 158.33 43.719 C 156.188 43.719 154.806 42.212 154.718 39.834 L 154.718 39.684 L 164.294 39.684 L 164.294 38.751 C 164.294 34.492 162.015 31.915 158.243 31.915 C 154.419 31.915 151.992 34.666 151.992 39 C 151.992 43.333 154.37 45.997 158.255 45.997 C 161.355 45.997 163.521 44.503 164.132 42.075 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 104.734 40.728 C 104.941 44.058 107.716 46.187 111.845 46.187 C 116.259 46.187 119.021 43.955 119.021 40.393 C 119.021 37.592 117.446 36.044 113.626 35.153 L 111.574 34.65 C 109.148 34.082 108.167 33.321 108.167 31.992 C 108.167 30.314 109.69 29.217 111.974 29.217 C 114.142 29.217 115.639 30.288 115.91 32.005 L 118.724 32.005 C 118.556 28.868 115.794 26.662 112.013 26.662 C 107.948 26.662 105.238 28.868 105.238 32.185 C 105.238 34.921 106.773 36.547 110.142 37.334 L 112.542 37.915 C 115.007 38.496 116.091 39.348 116.091 40.767 C 116.091 42.419 114.388 43.619 112.065 43.619 C 109.574 43.619 107.845 42.496 107.599 40.728 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 77.004 31.952 C 75.161 31.952 73.567 32.873 72.745 34.417 L 72.546 34.417 L 72.546 32.176 L 69.969 32.176 L 69.969 50.243 L 72.646 50.243 L 72.646 43.681 L 72.857 43.681 C 73.567 45.113 75.099 45.96 77.028 45.96 C 80.453 45.96 82.632 43.258 82.632 38.95 C 82.632 34.642 80.453 31.952 77.004 31.952 Z M 76.244 43.557 C 74.003 43.557 72.596 41.789 72.596 38.962 C 72.596 36.123 74.003 34.355 76.257 34.355 C 78.523 34.355 79.88 36.086 79.88 38.95 C 79.88 41.826 78.523 43.557 76.244 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 91.996 31.952 C 90.153 31.952 88.559 32.873 87.737 34.417 L 87.538 34.417 L 87.538 32.176 L 84.961 32.176 L 84.961 50.243 L 87.638 50.243 L 87.638 43.681 L 87.85 43.681 C 88.559 45.113 90.091 45.96 92.021 45.96 C 95.445 45.96 97.624 43.258 97.624 38.95 C 97.624 34.642 95.445 31.952 91.996 31.952 Z M 91.236 43.557 C 88.995 43.557 87.588 41.789 87.588 38.962 C 87.588 36.123 88.995 34.355 91.249 34.355 C 93.515 34.355 94.872 36.086 94.872 38.95 C 94.872 41.826 93.515 43.557 91.236 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.166 45.736 L 68.237 45.736 L 61.514 27.113 L 58.403 27.113 L 51.68 45.736 L 54.648 45.736 L 56.364 40.793 L 63.462 40.793 Z M 59.81 30.495 L 60.029 30.495 L 62.727 38.367 L 57.1 38.367 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 53.477 13.066 L 53.477 22.05 L 56.72 22.05 C 59.397 22.05 60.947 20.4 60.947 17.53 C 60.947 14.703 59.385 13.066 56.72 13.066 Z M 54.871 14.336 L 56.565 14.336 C 58.426 14.336 59.528 15.519 59.528 17.548 C 59.528 19.609 58.445 20.779 56.565 20.779 L 54.871 20.779 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.696 22.18 C 67.676 22.18 68.89 20.854 68.89 18.657 C 68.89 16.471 67.67 15.139 65.696 15.139 C 63.716 15.139 62.496 16.471 62.496 18.657 C 62.496 20.854 63.71 22.18 65.696 22.18 Z M 65.696 20.991 C 64.532 20.991 63.878 20.138 63.878 18.657 C 63.878 17.188 64.532 16.328 65.696 16.328 C 66.854 16.328 67.514 17.188 67.514 18.657 C 67.514 20.132 66.854 20.991 65.696 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 79.227 15.27 L 77.888 15.27 L 76.68 20.443 L 76.574 20.443 L 75.18 15.27 L 73.897 15.27 L 72.503 20.443 L 72.403 20.443 L 71.189 15.27 L 69.832 15.27 L 71.7 22.049 L 73.076 22.049 L 74.47 17.057 L 74.576 17.057 L 75.977 22.049 L 77.365 22.049 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 80.769 22.05 L 82.108 22.05 L 82.108 18.084 C 82.108 17.026 82.737 16.366 83.727 16.366 C 84.717 16.366 85.19 16.907 85.19 17.997 L 85.19 22.05 L 86.528 22.05 L 86.528 17.661 C 86.528 16.048 85.694 15.139 84.181 15.139 C 83.16 15.139 82.488 15.594 82.158 16.347 L 82.058 16.347 L 82.058 15.27 L 80.769 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 88.637 22.049 L 89.975 22.049 L 89.975 12.624 L 88.637 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 95.008 22.18 C 96.988 22.18 98.202 20.854 98.202 18.657 C 98.202 16.471 96.982 15.139 95.008 15.139 C 93.029 15.139 91.809 16.471 91.809 18.657 C 91.809 20.854 93.022 22.18 95.008 22.18 Z M 95.008 20.991 C 93.844 20.991 93.191 20.138 93.191 18.657 C 93.191 17.188 93.844 16.328 95.008 16.328 C 96.166 16.328 96.826 17.188 96.826 18.657 C 96.826 20.132 96.166 20.991 95.008 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 102.188 21.035 C 101.46 21.035 100.931 20.68 100.931 20.07 C 100.931 19.472 101.354 19.155 102.288 19.092 L 103.944 18.987 L 103.944 19.553 C 103.944 20.394 103.197 21.035 102.188 21.035 Z M 101.846 22.162 C 102.736 22.162 103.477 21.776 103.882 21.097 L 103.987 21.097 L 103.987 22.05 L 105.276 22.05 L 105.276 17.418 C 105.276 15.986 104.317 15.139 102.618 15.139 C 101.08 15.139 99.984 15.886 99.847 17.05 L 101.142 17.05 C 101.292 16.571 101.808 16.297 102.555 16.297 C 103.471 16.297 103.944 16.702 103.944 17.418 L 103.944 18.003 L 102.107 18.109 C 100.495 18.208 99.586 18.912 99.586 20.132 C 99.586 21.371 100.538 22.162 101.846 22.162 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 109.818 22.162 C 110.752 22.162 111.542 21.72 111.947 20.979 L 112.053 20.979 L 112.053 22.049 L 113.335 22.049 L 113.335 12.624 L 111.997 12.624 L 111.997 16.347 L 111.897 16.347 C 111.53 15.6 110.746 15.158 109.818 15.158 C 108.106 15.158 107.004 16.515 107.004 18.657 C 107.004 20.804 108.093 22.162 109.818 22.162 Z M 110.198 16.359 C 111.318 16.359 112.022 17.25 112.022 18.663 C 112.022 20.082 111.325 20.96 110.198 20.96 C 109.065 20.96 108.386 20.095 108.386 18.657 C 108.386 17.231 109.071 16.359 110.198 16.359 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 122.016 22.18 C 123.996 22.18 125.21 20.854 125.21 18.657 C 125.21 16.471 123.99 15.139 122.016 15.139 C 120.037 15.139 118.816 16.471 118.816 18.657 C 118.816 20.854 120.031 22.18 122.016 22.18 Z M 122.016 20.991 C 120.852 20.991 120.199 20.138 120.199 18.657 C 120.199 17.188 120.852 16.328 122.016 16.328 C 123.174 16.328 123.834 17.188 123.834 18.657 C 123.834 20.132 123.174 20.991 122.016 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 126.98 22.05 L 128.319 22.05 L 128.319 18.084 C 128.319 17.026 128.948 16.366 129.938 16.366 C 130.927 16.366 131.401 16.907 131.401 17.997 L 131.401 22.05 L 132.739 22.05 L 132.739 17.661 C 132.739 16.048 131.905 15.139 130.392 15.139 C 129.371 15.139 128.699 15.594 128.369 16.347 L 128.269 16.347 L 128.269 15.27 L 126.98 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 138.905 13.583 L 138.905 15.301 L 137.828 15.301 L 137.828 16.428 L 138.905 16.428 L 138.905 20.257 C 138.905 21.564 139.497 22.087 140.984 22.087 C 141.246 22.087 141.495 22.056 141.713 22.018 L 141.713 20.904 C 141.526 20.923 141.408 20.935 141.202 20.935 C 140.536 20.935 140.244 20.624 140.244 19.914 L 140.244 16.428 L 141.713 16.428 L 141.713 15.301 L 140.244 15.301 L 140.244 13.583 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.512 22.049 L 144.85 22.049 L 144.85 18.09 C 144.85 17.063 145.46 16.372 146.556 16.372 C 147.502 16.372 148.007 16.92 148.007 18.003 L 148.007 22.049 L 149.345 22.049 L 149.345 17.673 C 149.345 16.061 148.455 15.145 147.011 15.145 C 145.99 15.145 145.274 15.6 144.944 16.359 L 144.838 16.359 L 144.838 12.624 L 143.512 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 154.173 16.278 C 155.163 16.278 155.811 16.969 155.843 18.034 L 152.418 18.034 C 152.493 16.976 153.183 16.278 154.173 16.278 Z M 155.835 20.219 C 155.586 20.748 155.033 21.041 154.223 21.041 C 153.153 21.041 152.462 20.288 152.418 19.099 L 152.418 19.024 L 157.205 19.024 L 157.205 18.557 C 157.205 16.428 156.066 15.139 154.179 15.139 C 152.268 15.139 151.055 16.515 151.055 18.681 C 151.055 20.848 152.244 22.18 154.185 22.18 C 155.736 22.18 156.819 21.433 157.124 20.219 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 37.153 30.452 C 37.185 27.93 38.54 25.544 40.688 24.224 C 39.333 22.288 37.063 21.061 34.701 20.987 C 32.182 20.723 29.74 22.494 28.457 22.494 C 27.148 22.494 25.172 21.013 23.044 21.057 C 20.27 21.147 17.684 22.724 16.335 25.149 C 13.434 30.172 15.598 37.553 18.376 41.613 C 19.767 43.601 21.392 45.822 23.518 45.743 C 25.599 45.657 26.375 44.416 28.887 44.416 C 31.375 44.416 32.104 45.743 34.273 45.693 C 36.506 45.657 37.913 43.696 39.254 41.689 C 40.253 40.273 41.022 38.707 41.532 37.05 C 38.908 35.941 37.156 33.3 37.153 30.452 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 33.057 18.317 C 34.274 16.856 34.874 14.977 34.729 13.081 C 32.869 13.276 31.151 14.165 29.917 15.57 C 28.711 16.943 28.083 18.789 28.202 20.613 C 30.062 20.632 31.891 19.767 33.057 18.317 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg viewBox="0 0 132 44" overflow="visible" id="svg1886773647_10415">
            <g>
              <path d="M 0 44 L 0 0 L 132 0 L 132 44 Z" fill="transparent" />
              <path
                d="M 124.3 0.55 L 7.7 0.55 C 3.751 0.55 0.55 3.751 0.55 7.7 L 0.55 36.3 C 0.55 40.249 3.751 43.45 7.7 43.45 L 124.3 43.45 C 128.249 43.45 131.45 40.249 131.45 36.3 L 131.45 7.7 C 131.45 3.751 128.249 0.55 124.3 0.55 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 124.3 0.55 L 7.7 0.55 C 3.751 0.55 0.55 3.751 0.55 7.7 L 0.55 36.3 C 0.55 40.249 3.751 43.45 7.7 43.45 L 124.3 43.45 C 128.249 43.45 131.45 40.249 131.45 36.3 L 131.45 7.7 C 131.45 3.751 128.249 0.55 124.3 0.55 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 89.68 21.121 L 89.68 23.642 L 88.1 23.642 L 88.1 25.294 L 89.68 25.294 L 89.68 30.91 C 89.68 32.827 90.548 33.594 92.729 33.594 C 93.113 33.594 93.479 33.549 93.798 33.494 L 93.798 31.859 C 93.524 31.887 93.35 31.905 93.049 31.905 C 92.072 31.905 91.643 31.448 91.643 30.408 L 91.643 25.294 L 93.798 25.294 L 93.798 23.642 L 91.643 23.642 L 91.643 21.121 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 99.356 33.731 C 102.26 33.731 104.04 31.786 104.04 28.563 C 104.04 25.358 102.251 23.404 99.356 23.404 C 96.452 23.404 94.663 25.358 94.663 28.563 C 94.663 31.786 96.444 33.731 99.356 33.731 Z M 99.356 31.987 C 97.649 31.987 96.69 30.736 96.69 28.563 C 96.69 26.408 97.649 25.148 99.356 25.148 C 101.055 25.148 102.023 26.408 102.023 28.563 C 102.023 30.727 101.055 31.987 99.356 31.987 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 105.563 33.539 L 107.526 33.539 L 107.526 27.668 C 107.526 26.271 108.576 25.331 110.065 25.331 C 110.411 25.331 110.996 25.395 111.16 25.449 L 111.16 23.514 C 110.95 23.459 110.576 23.432 110.283 23.432 C 108.987 23.432 107.882 24.144 107.599 25.121 L 107.453 25.121 L 107.453 23.596 L 105.563 23.596 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 116.035 25.075 C 117.487 25.075 118.436 26.089 118.482 27.65 L 113.46 27.65 C 113.57 26.098 114.583 25.075 116.035 25.075 Z M 118.474 30.855 C 118.108 31.631 117.295 32.06 116.109 32.06 C 114.538 32.06 113.524 30.955 113.46 29.211 L 113.46 29.102 L 120.482 29.102 L 120.482 28.417 C 120.482 25.294 118.811 23.404 116.045 23.404 C 113.241 23.404 111.461 25.422 111.461 28.6 C 111.461 31.777 113.205 33.731 116.054 33.731 C 118.327 33.731 119.915 32.635 120.363 30.855 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 76.805 29.867 C 76.957 32.309 78.992 33.871 82.02 33.871 C 85.257 33.871 87.282 32.233 87.282 29.621 C 87.282 27.568 86.127 26.432 83.326 25.779 L 81.821 25.41 C 80.042 24.994 79.322 24.435 79.322 23.461 C 79.322 22.23 80.439 21.426 82.114 21.426 C 83.704 21.426 84.802 22.211 85.001 23.47 L 87.064 23.47 C 86.941 21.17 84.916 19.552 82.143 19.552 C 79.162 19.552 77.175 21.17 77.175 23.602 C 77.175 25.609 78.3 26.801 80.771 27.378 L 82.531 27.804 C 84.338 28.23 85.133 28.855 85.133 29.896 C 85.133 31.107 83.885 31.987 82.181 31.987 C 80.354 31.987 79.086 31.164 78.906 29.867 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 56.469 23.432 C 55.118 23.432 53.949 24.107 53.347 25.24 L 53.2 25.24 L 53.2 23.596 L 51.31 23.596 L 51.31 36.845 L 53.273 36.845 L 53.273 32.033 L 53.429 32.033 C 53.949 33.083 55.072 33.704 56.488 33.704 C 58.999 33.704 60.597 31.722 60.597 28.563 C 60.597 25.404 58.999 23.432 56.469 23.432 Z M 55.912 31.942 C 54.269 31.942 53.237 30.645 53.237 28.572 C 53.237 26.49 54.269 25.194 55.922 25.194 C 57.583 25.194 58.579 26.463 58.579 28.563 C 58.579 30.672 57.583 31.942 55.912 31.942 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 67.464 23.432 C 66.112 23.432 64.943 24.107 64.341 25.24 L 64.195 25.24 L 64.195 23.596 L 62.305 23.596 L 62.305 36.845 L 64.268 36.845 L 64.268 32.033 L 64.423 32.033 C 64.943 33.083 66.067 33.704 67.482 33.704 C 69.993 33.704 71.591 31.722 71.591 28.563 C 71.591 25.404 69.993 23.432 67.464 23.432 Z M 66.907 31.942 C 65.263 31.942 64.231 30.645 64.231 28.572 C 64.231 26.49 65.263 25.194 66.916 25.194 C 68.578 25.194 69.573 26.463 69.573 28.563 C 69.573 30.672 68.578 31.942 66.907 31.942 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 47.788 33.539 L 50.041 33.539 L 45.11 19.883 L 42.829 19.883 L 37.898 33.539 L 40.075 33.539 L 41.334 29.915 L 46.539 29.915 Z M 43.861 22.363 L 44.022 22.363 L 46 28.136 L 41.873 28.136 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 39.216 9.582 L 39.216 16.17 L 41.595 16.17 C 43.558 16.17 44.695 14.96 44.695 12.855 C 44.695 10.782 43.549 9.582 41.595 9.582 Z M 40.239 10.513 L 41.481 10.513 C 42.846 10.513 43.654 11.381 43.654 12.869 C 43.654 14.38 42.859 15.238 41.481 15.238 L 40.239 15.238 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 48.177 16.266 C 49.629 16.266 50.519 15.293 50.519 13.682 C 50.519 12.079 49.624 11.102 48.177 11.102 C 46.725 11.102 45.83 12.079 45.83 13.682 C 45.83 15.293 46.721 16.266 48.177 16.266 Z M 48.177 15.394 C 47.323 15.394 46.844 14.768 46.844 13.682 C 46.844 12.604 47.323 11.974 48.177 11.974 C 49.026 11.974 49.51 12.604 49.51 13.682 C 49.51 14.764 49.026 15.394 48.177 15.394 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 58.099 11.198 L 57.118 11.198 L 56.232 14.992 L 56.155 14.992 L 55.132 11.198 L 54.191 11.198 L 53.169 14.992 L 53.096 14.992 L 52.205 11.198 L 51.21 11.198 L 52.58 16.17 L 53.589 16.17 L 54.611 12.508 L 54.689 12.508 L 55.716 16.17 L 56.734 16.17 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 59.231 16.17 L 60.213 16.17 L 60.213 13.262 C 60.213 12.485 60.674 12.001 61.4 12.001 C 62.126 12.001 62.472 12.399 62.472 13.198 L 62.472 16.17 L 63.454 16.17 L 63.454 12.951 C 63.454 11.769 62.842 11.102 61.733 11.102 C 60.984 11.102 60.491 11.435 60.249 11.988 L 60.176 11.988 L 60.176 11.198 L 59.231 11.198 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65 16.17 L 65.982 16.17 L 65.982 9.258 L 65 9.258 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 69.673 16.266 C 71.125 16.266 72.015 15.293 72.015 13.682 C 72.015 12.079 71.12 11.102 69.673 11.102 C 68.221 11.102 67.326 12.079 67.326 13.682 C 67.326 15.293 68.216 16.266 69.673 16.266 Z M 69.673 15.394 C 68.819 15.394 68.34 14.768 68.34 13.682 C 68.34 12.604 68.819 11.974 69.673 11.974 C 70.522 11.974 71.006 12.604 71.006 13.682 C 71.006 14.764 70.522 15.394 69.673 15.394 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 74.938 15.426 C 74.404 15.426 74.016 15.165 74.016 14.718 C 74.016 14.28 74.326 14.047 75.011 14.001 L 76.226 13.924 L 76.226 14.339 C 76.226 14.955 75.678 15.426 74.938 15.426 Z M 74.687 16.252 C 75.34 16.252 75.883 15.969 76.18 15.471 L 76.257 15.471 L 76.257 16.17 L 77.202 16.17 L 77.202 12.773 C 77.202 11.723 76.499 11.102 75.253 11.102 C 74.125 11.102 73.322 11.65 73.221 12.504 L 74.171 12.504 C 74.281 12.152 74.659 11.951 75.207 11.951 C 75.879 11.951 76.226 12.248 76.226 12.773 L 76.226 13.202 L 74.878 13.28 C 73.696 13.353 73.03 13.869 73.03 14.764 C 73.03 15.672 73.728 16.252 74.687 16.252 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 80.533 16.252 C 81.218 16.252 81.797 15.928 82.094 15.384 L 82.172 15.384 L 82.172 16.17 L 83.112 16.17 L 83.112 9.258 L 82.131 9.258 L 82.131 11.988 L 82.058 11.988 C 81.789 11.44 81.214 11.116 80.533 11.116 C 79.278 11.116 78.47 12.111 78.47 13.681 C 78.47 15.257 79.268 16.252 80.533 16.252 Z M 80.812 11.997 C 81.633 11.997 82.149 12.65 82.149 13.686 C 82.149 14.727 81.638 15.371 80.812 15.371 C 79.981 15.371 79.483 14.736 79.483 13.681 C 79.483 12.636 79.985 11.997 80.812 11.997 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 89.478 16.266 C 90.93 16.266 91.821 15.293 91.821 13.682 C 91.821 12.079 90.926 11.102 89.478 11.102 C 88.027 11.102 87.132 12.079 87.132 13.682 C 87.132 15.293 88.023 16.266 89.478 16.266 Z M 89.478 15.394 C 88.625 15.394 88.146 14.768 88.146 13.682 C 88.146 12.604 88.625 11.974 89.478 11.974 C 90.328 11.974 90.812 12.604 90.812 13.682 C 90.812 14.764 90.328 15.394 89.478 15.394 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 93.119 16.17 L 94.101 16.17 L 94.101 13.262 C 94.101 12.485 94.562 12.001 95.288 12.001 C 96.013 12.001 96.361 12.399 96.361 13.198 L 96.361 16.17 L 97.342 16.17 L 97.342 12.951 C 97.342 11.769 96.73 11.102 95.621 11.102 C 94.872 11.102 94.379 11.435 94.137 11.988 L 94.064 11.988 L 94.064 11.198 L 93.119 11.198 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 101.864 9.961 L 101.864 11.221 L 101.074 11.221 L 101.074 12.047 L 101.864 12.047 L 101.864 14.855 C 101.864 15.814 102.298 16.197 103.388 16.197 C 103.58 16.197 103.763 16.174 103.923 16.147 L 103.923 15.33 C 103.786 15.343 103.699 15.352 103.548 15.352 C 103.06 15.352 102.846 15.124 102.846 14.604 L 102.846 12.047 L 103.923 12.047 L 103.923 11.221 L 102.846 11.221 L 102.846 9.961 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 105.242 16.17 L 106.223 16.17 L 106.223 13.266 C 106.223 12.513 106.671 12.006 107.474 12.006 C 108.168 12.006 108.538 12.408 108.538 13.202 L 108.538 16.17 L 109.52 16.17 L 109.52 12.96 C 109.52 11.778 108.867 11.107 107.808 11.107 C 107.059 11.107 106.534 11.44 106.292 11.997 L 106.215 11.997 L 106.215 9.258 L 105.242 9.258 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 113.06 11.938 C 113.786 11.938 114.261 12.444 114.285 13.225 L 111.773 13.225 C 111.828 12.449 112.334 11.938 113.06 11.938 Z M 114.279 14.827 C 114.096 15.216 113.691 15.43 113.097 15.43 C 112.312 15.43 111.805 14.878 111.773 14.006 L 111.773 13.951 L 115.284 13.951 L 115.284 13.608 C 115.284 12.047 114.448 11.102 113.065 11.102 C 111.663 11.102 110.774 12.111 110.774 13.7 C 110.774 15.289 111.646 16.266 113.069 16.266 C 114.206 16.266 115.001 15.718 115.224 14.827 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 27.246 22.331 C 27.269 20.482 28.262 18.732 29.838 17.764 C 28.844 16.345 27.179 15.445 25.447 15.39 C 23.6 15.197 21.81 16.496 20.868 16.496 C 19.909 16.496 18.459 15.41 16.899 15.442 C 14.865 15.508 12.968 16.664 11.979 18.443 C 9.851 22.126 11.438 27.539 13.476 30.516 C 14.496 31.974 15.687 33.603 17.246 33.545 C 18.772 33.482 19.342 32.572 21.184 32.572 C 23.008 32.572 23.543 33.545 25.134 33.508 C 26.771 33.482 27.803 32.044 28.786 30.572 C 29.519 29.533 30.083 28.385 30.457 27.17 C 28.533 26.356 27.248 24.42 27.246 22.331 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 24.242 13.432 C 25.134 12.361 25.574 10.983 25.468 9.593 C 24.104 9.736 22.844 10.388 21.939 11.418 C 21.055 12.425 20.594 13.778 20.681 15.116 C 22.046 15.13 23.387 14.496 24.242 13.432 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg
            viewBox="0 0 201 58.5"
            overflow="visible"
            id="svg-412316951_7924"
          >
            <g>
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 159.651 44.25 L 162.45 44.25 L 162.45 25.498 L 159.651 25.498 Z M 184.862 32.253 L 181.654 40.383 L 181.558 40.383 L 178.228 32.253 L 175.213 32.253 L 180.208 43.616 L 177.359 49.937 L 180.278 49.937 L 187.975 32.253 Z M 168.988 42.12 C 168.073 42.12 166.793 41.661 166.793 40.528 C 166.793 39.08 168.386 38.525 169.76 38.525 C 170.99 38.525 171.571 38.79 172.318 39.152 C 172.1 40.89 170.605 42.12 168.988 42.12 Z M 169.326 31.843 C 167.3 31.843 165.201 32.736 164.333 34.714 L 166.817 35.751 C 167.348 34.714 168.336 34.376 169.374 34.376 C 170.822 34.376 172.293 35.244 172.317 36.789 L 172.317 36.981 C 171.81 36.692 170.724 36.258 169.398 36.258 C 166.719 36.258 163.994 37.729 163.994 40.479 C 163.994 42.989 166.19 44.605 168.65 44.605 C 170.531 44.605 171.57 43.761 172.22 42.771 L 172.317 42.771 L 172.317 44.22 L 175.02 44.22 L 175.02 37.029 C 175.02 33.7 172.533 31.843 169.326 31.843 Z M 152.029 34.536 L 148.047 34.536 L 148.047 28.108 L 152.029 28.108 C 154.121 28.108 155.309 29.84 155.309 31.322 C 155.309 32.775 154.121 34.536 152.029 34.536 Z M 151.957 25.498 L 145.249 25.498 L 145.249 44.25 L 148.047 44.25 L 148.047 37.146 L 151.957 37.146 C 155.059 37.146 158.108 34.9 158.108 31.322 C 158.108 27.744 155.059 25.498 151.957 25.498 Z M 115.384 42.124 C 113.45 42.124 111.832 40.504 111.832 38.282 C 111.832 36.033 113.45 34.391 115.384 34.391 C 117.293 34.391 118.791 36.033 118.791 38.282 C 118.791 40.504 117.293 42.124 115.384 42.124 Z M 118.598 33.303 L 118.501 33.303 C 117.873 32.554 116.664 31.877 115.142 31.877 C 111.952 31.877 109.028 34.681 109.028 38.282 C 109.028 41.858 111.952 44.637 115.142 44.637 C 116.664 44.637 117.873 43.96 118.501 43.187 L 118.598 43.187 L 118.598 44.105 C 118.598 46.546 117.293 47.851 115.19 47.851 C 113.475 47.851 112.412 46.618 111.977 45.579 L 109.536 46.594 C 110.236 48.285 112.097 50.364 115.19 50.364 C 118.478 50.364 121.257 48.431 121.257 43.718 L 121.257 32.264 L 118.598 32.264 Z M 123.19 44.25 L 125.992 44.25 L 125.992 25.498 L 123.19 25.498 Z M 130.125 38.064 C 130.053 35.599 132.035 34.342 133.46 34.342 C 134.572 34.342 135.514 34.898 135.829 35.695 Z M 138.824 35.937 C 138.293 34.512 136.674 31.877 133.363 31.877 C 130.076 31.877 127.346 34.463 127.346 38.257 C 127.346 41.834 130.053 44.637 133.677 44.637 C 136.601 44.637 138.293 42.849 138.994 41.81 L 136.819 40.359 C 136.094 41.423 135.104 42.124 133.677 42.124 C 132.252 42.124 131.236 41.471 130.585 40.19 L 139.114 36.662 Z M 70.863 33.835 L 70.863 36.541 L 77.339 36.541 C 77.146 38.064 76.638 39.175 75.865 39.949 C 74.922 40.891 73.448 41.93 70.863 41.93 C 66.875 41.93 63.758 38.716 63.758 34.729 C 63.758 30.742 66.875 27.527 70.863 27.527 C 73.013 27.527 74.584 28.373 75.744 29.461 L 77.654 27.551 C 76.034 26.005 73.884 24.821 70.863 24.821 C 65.4 24.821 60.809 29.268 60.809 34.729 C 60.809 40.19 65.4 44.637 70.863 44.637 C 73.81 44.637 76.034 43.67 77.774 41.858 C 79.562 40.069 80.118 37.556 80.118 35.526 C 80.118 34.898 80.069 34.318 79.973 33.835 Z M 87.481 42.124 C 85.547 42.124 83.88 40.529 83.88 38.257 C 83.88 35.961 85.547 34.391 87.481 34.391 C 89.414 34.391 91.081 35.961 91.081 38.257 C 91.081 40.529 89.414 42.124 87.481 42.124 Z M 87.481 31.877 C 83.952 31.877 81.077 34.56 81.077 38.257 C 81.077 41.93 83.952 44.637 87.481 44.637 C 91.009 44.637 93.885 41.93 93.885 38.257 C 93.885 34.56 91.009 31.877 87.481 31.877 Z M 101.45 42.124 C 99.518 42.124 97.85 40.529 97.85 38.257 C 97.85 35.961 99.518 34.391 101.45 34.391 C 103.384 34.391 105.051 35.961 105.051 38.257 C 105.051 40.529 103.384 42.124 101.45 42.124 Z M 101.45 31.877 C 97.922 31.877 95.047 34.56 95.047 38.257 C 95.047 41.93 97.922 44.637 101.45 44.637 C 104.979 44.637 107.855 41.93 107.855 38.257 C 107.855 34.56 104.979 31.877 101.45 31.877 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.965 19.102 C 64.62 19.102 63.463 18.628 62.531 17.696 C 61.598 16.763 61.125 15.594 61.125 14.236 C 61.125 12.877 61.598 11.711 62.531 10.776 C 63.463 9.843 64.62 9.37 65.965 9.37 C 66.65 9.37 67.289 9.489 67.9 9.735 C 68.512 9.981 69.012 10.324 69.406 10.771 L 69.498 10.877 L 68.449 11.926 L 68.345 11.797 C 68.083 11.476 67.751 11.227 67.33 11.046 C 66.911 10.865 66.452 10.781 65.965 10.781 C 65.018 10.781 64.232 11.103 63.575 11.757 C 62.933 12.424 62.611 13.236 62.611 14.236 C 62.611 15.236 62.934 16.049 63.576 16.716 C 64.232 17.37 65.018 17.693 65.965 17.693 C 66.832 17.693 67.549 17.451 68.113 16.972 C 68.638 16.526 68.953 15.923 69.064 15.155 L 65.815 15.155 L 65.815 13.772 L 70.469 13.772 L 70.489 13.898 C 70.527 14.142 70.554 14.376 70.554 14.602 C 70.554 15.892 70.16 16.945 69.389 17.72 C 68.517 18.644 67.372 19.102 65.965 19.102 Z M 106.377 19.102 C 105.031 19.102 103.887 18.628 102.967 17.696 C 102.967 17.696 102.966 17.696 102.966 17.695 C 102.044 16.773 101.587 15.605 101.587 14.236 C 101.587 12.867 102.044 11.699 102.966 10.777 C 102.966 10.776 102.966 10.776 102.966 10.776 C 103.886 9.844 105.031 9.37 106.377 9.37 C 107.722 9.37 108.865 9.844 109.786 10.79 C 110.708 11.712 111.166 12.878 111.166 14.236 C 111.166 15.605 110.708 16.773 109.786 17.695 C 108.865 18.628 107.711 19.102 106.377 19.102 Z M 71.886 18.9 L 71.886 9.572 L 72.036 9.572 L 77.457 9.572 L 77.457 10.983 L 73.346 10.983 L 73.346 13.545 L 77.054 13.545 L 77.054 14.927 L 73.346 14.927 L 73.346 17.491 L 77.457 17.491 L 77.457 18.9 Z M 80.866 18.9 L 80.866 10.983 L 78.344 10.983 L 78.344 9.572 L 84.848 9.572 L 84.848 10.983 L 84.698 10.983 L 82.326 10.983 L 82.326 18.9 Z M 89.005 18.9 L 89.005 9.572 L 90.465 9.572 L 90.465 9.722 L 90.465 18.9 Z M 94.141 18.9 L 94.141 10.983 L 91.619 10.983 L 91.619 9.572 L 98.123 9.572 L 98.123 10.983 L 97.973 10.983 L 95.601 10.983 L 95.601 18.9 Z M 112.462 18.9 L 112.462 9.572 L 114.108 9.572 L 118.299 16.28 L 118.263 15.007 L 118.263 9.572 L 119.723 9.572 L 119.723 18.9 L 118.278 18.9 L 113.886 11.853 L 113.922 13.125 L 113.922 13.127 L 113.922 18.9 Z M 106.377 17.693 C 107.325 17.693 108.098 17.37 108.728 16.717 L 108.729 16.716 L 108.73 16.715 C 109.369 16.076 109.682 15.252 109.682 14.236 C 109.682 13.222 109.369 12.396 108.73 11.757 L 108.729 11.756 L 108.728 11.755 C 108.098 11.102 107.325 10.781 106.377 10.781 C 105.428 10.781 104.655 11.102 104.013 11.754 L 104.013 11.755 C 103.385 12.41 103.073 13.222 103.073 14.236 C 103.073 15.252 103.385 16.062 104.013 16.717 C 104.655 17.37 105.429 17.693 106.377 17.693 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 30.322 28.385 L 14.352 45.335 C 14.353 45.338 14.354 45.341 14.354 45.345 C 14.844 47.185 16.525 48.541 18.52 48.541 C 19.318 48.541 20.067 48.325 20.709 47.946 L 20.76 47.916 L 38.736 37.544 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 46.48 25.499 L 46.465 25.489 L 38.704 20.99 L 29.961 28.77 L 38.735 37.542 L 46.455 33.088 C 47.808 32.358 48.727 30.931 48.727 29.285 C 48.727 27.652 47.82 26.232 46.48 25.499 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 14.349 13.165 C 14.253 13.519 14.203 13.89 14.203 14.275 L 14.203 44.226 C 14.203 44.611 14.253 44.983 14.35 45.335 L 30.869 28.819 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 30.441 29.25 L 38.706 20.987 L 20.751 10.576 C 20.098 10.185 19.336 9.96 18.521 9.96 C 16.526 9.96 14.843 11.317 14.353 13.16 C 14.352 13.162 14.352 13.163 14.352 13.165 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg viewBox="0 0 149 43" overflow="visible" id="svg1224668562_7717">
            <g>
              <path
                d="M 5.004 43 C 2.24 43 0 40.779 0 38.038 L 0 4.962 C 0 2.221 2.24 0 5.004 0 L 143.996 0 C 146.76 0 149 2.221 149 4.962 L 149 38.038 C 149 40.779 146.76 43 143.996 43 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 5.004 43 C 2.24 43 0 40.779 0 38.038 L 0 4.962 C 0 2.221 2.24 0 5.004 0 L 143.996 0 C 146.76 0 149 2.221 149 4.962 L 149 38.038 C 149 40.779 146.76 43 143.996 43 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 118.348 32.526 L 120.423 32.526 L 120.423 18.742 L 118.348 18.742 Z M 137.037 23.707 L 134.659 29.683 L 134.588 29.683 L 132.119 23.707 L 129.884 23.707 L 133.587 32.06 L 131.475 36.706 L 133.639 36.706 L 139.345 23.707 Z M 125.27 30.96 C 124.591 30.96 123.643 30.623 123.643 29.79 C 123.643 28.725 124.823 28.318 125.842 28.318 C 126.754 28.318 127.184 28.512 127.738 28.778 C 127.577 30.056 126.468 30.96 125.27 30.96 Z M 125.52 23.406 C 124.018 23.406 122.462 24.062 121.819 25.516 L 123.66 26.279 C 124.054 25.516 124.786 25.268 125.556 25.268 C 126.629 25.268 127.72 25.906 127.737 27.041 L 127.737 27.183 C 127.362 26.97 126.557 26.651 125.574 26.651 C 123.588 26.651 121.568 27.732 121.568 29.754 C 121.568 31.599 123.196 32.787 125.019 32.787 C 126.414 32.787 127.184 32.166 127.666 31.439 L 127.737 31.439 L 127.737 32.504 L 129.741 32.504 L 129.741 27.218 C 129.741 24.771 127.898 23.406 125.52 23.406 Z M 112.698 25.385 L 109.746 25.385 L 109.746 20.661 L 112.698 20.661 C 114.249 20.661 115.13 21.934 115.13 23.023 C 115.13 24.091 114.249 25.385 112.698 25.385 Z M 112.645 18.742 L 107.672 18.742 L 107.672 32.526 L 109.746 32.526 L 109.746 27.304 L 112.645 27.304 C 114.944 27.304 117.204 25.653 117.204 23.023 C 117.204 20.393 114.944 18.742 112.645 18.742 Z M 85.533 30.963 C 84.1 30.963 82.9 29.772 82.9 28.139 C 82.9 26.486 84.1 25.279 85.533 25.279 C 86.949 25.279 88.059 26.486 88.059 28.139 C 88.059 29.772 86.949 30.963 85.533 30.963 Z M 87.916 24.479 L 87.844 24.479 C 87.378 23.929 86.482 23.431 85.354 23.431 C 82.989 23.431 80.822 25.492 80.822 28.139 C 80.822 30.767 82.989 32.81 85.354 32.81 C 86.482 32.81 87.378 32.312 87.844 31.744 L 87.916 31.744 L 87.916 32.419 C 87.916 34.213 86.949 35.173 85.39 35.173 C 84.118 35.173 83.33 34.266 83.008 33.503 L 81.198 34.249 C 81.717 35.492 83.097 37.02 85.39 37.02 C 87.827 37.02 89.887 35.599 89.887 32.135 L 89.887 23.715 L 87.916 23.715 Z M 91.32 32.526 L 93.397 32.526 L 93.397 18.742 L 91.32 18.742 Z M 96.461 27.979 C 96.407 26.167 97.877 25.243 98.933 25.243 C 99.757 25.243 100.456 25.652 100.689 26.237 Z M 102.909 26.415 C 102.516 25.368 101.316 23.431 98.861 23.431 C 96.425 23.431 94.401 25.332 94.401 28.121 C 94.401 30.75 96.407 32.81 99.094 32.81 C 101.261 32.81 102.516 31.496 103.035 30.732 L 101.423 29.666 C 100.886 30.448 100.152 30.963 99.094 30.963 C 98.038 30.963 97.284 30.483 96.802 29.541 L 103.124 26.948 Z M 52.53 24.87 L 52.53 26.859 L 57.331 26.859 C 57.188 27.979 56.811 28.795 56.238 29.364 C 55.539 30.057 54.447 30.82 52.53 30.82 C 49.574 30.82 47.263 28.458 47.263 25.527 C 47.263 22.597 49.574 20.234 52.53 20.234 C 54.124 20.234 55.289 20.855 56.149 21.655 L 57.564 20.251 C 56.364 19.115 54.77 18.244 52.53 18.244 C 48.481 18.244 45.077 21.513 45.077 25.527 C 45.077 29.541 48.481 32.81 52.53 32.81 C 54.715 32.81 56.364 32.099 57.653 30.767 C 58.979 29.452 59.391 27.605 59.391 26.113 C 59.391 25.652 59.355 25.225 59.283 24.87 Z M 64.849 30.963 C 63.415 30.963 62.18 29.791 62.18 28.121 C 62.18 26.433 63.415 25.279 64.849 25.279 C 66.282 25.279 67.518 26.433 67.518 28.121 C 67.518 29.791 66.282 30.963 64.849 30.963 Z M 64.849 23.431 C 62.233 23.431 60.102 25.403 60.102 28.121 C 60.102 30.82 62.233 32.81 64.849 32.81 C 67.464 32.81 69.596 30.82 69.596 28.121 C 69.596 25.403 67.464 23.431 64.849 23.431 Z M 75.204 30.963 C 73.772 30.963 72.536 29.791 72.536 28.121 C 72.536 26.433 73.772 25.279 75.204 25.279 C 76.638 25.279 77.874 26.433 77.874 28.121 C 77.874 29.791 76.638 30.963 75.204 30.963 Z M 75.204 23.431 C 72.589 23.431 70.458 25.403 70.458 28.121 C 70.458 30.82 72.589 32.81 75.204 32.81 C 77.82 32.81 79.952 30.82 79.952 28.121 C 79.952 25.403 77.82 23.431 75.204 23.431 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 48.899 14.041 C 47.902 14.041 47.045 13.692 46.354 13.007 C 45.662 12.322 45.312 11.462 45.312 10.464 C 45.312 9.465 45.662 8.608 46.354 7.921 C 47.045 7.235 47.902 6.887 48.899 6.887 C 49.407 6.887 49.881 6.975 50.334 7.156 C 50.788 7.336 51.158 7.589 51.45 7.917 L 51.518 7.995 L 50.741 8.766 L 50.664 8.671 C 50.469 8.435 50.223 8.252 49.911 8.119 C 49.601 7.986 49.26 7.924 48.899 7.924 C 48.197 7.924 47.615 8.161 47.128 8.642 C 46.652 9.132 46.413 9.729 46.413 10.464 C 46.413 11.199 46.653 11.797 47.128 12.287 C 47.615 12.768 48.197 13.005 48.899 13.005 C 49.542 13.005 50.074 12.827 50.492 12.475 C 50.881 12.147 51.114 11.704 51.197 11.14 L 48.788 11.14 L 48.788 10.123 L 52.238 10.123 L 52.253 10.216 C 52.281 10.395 52.301 10.567 52.301 10.733 C 52.301 11.681 52.009 12.455 51.438 13.025 C 50.791 13.704 49.942 14.041 48.899 14.041 Z M 78.857 14.041 C 77.859 14.041 77.011 13.692 76.329 13.007 C 76.329 13.007 76.328 13.007 76.328 13.007 C 75.645 12.329 75.306 11.47 75.306 10.464 C 75.306 9.458 75.645 8.599 76.328 7.922 C 76.328 7.921 76.328 7.921 76.328 7.921 C 77.01 7.236 77.859 6.887 78.857 6.887 C 79.854 6.887 80.701 7.236 81.384 7.931 C 82.067 8.609 82.407 9.466 82.407 10.464 C 82.407 11.47 82.067 12.329 81.384 13.007 C 80.701 13.692 79.845 14.041 78.857 14.041 Z M 53.289 13.892 L 53.289 7.036 L 53.4 7.036 L 57.418 7.036 L 57.418 8.073 L 54.371 8.073 L 54.371 9.956 L 57.12 9.956 L 57.12 10.972 L 54.371 10.972 L 54.371 12.857 L 57.418 12.857 L 57.418 13.892 Z M 59.945 13.892 L 59.945 8.073 L 58.076 8.073 L 58.076 7.036 L 62.897 7.036 L 62.897 8.073 L 62.786 8.073 L 61.028 8.073 L 61.028 13.892 Z M 65.979 13.892 L 65.979 7.036 L 67.061 7.036 L 67.061 7.146 L 67.061 13.892 Z M 69.786 13.892 L 69.786 8.073 L 67.917 8.073 L 67.917 7.036 L 72.738 7.036 L 72.738 8.073 L 72.627 8.073 L 70.868 8.073 L 70.868 13.892 Z M 83.367 13.892 L 83.367 7.036 L 84.588 7.036 L 87.694 11.966 L 87.668 11.031 L 87.668 7.036 L 88.75 7.036 L 88.75 13.892 L 87.679 13.892 L 84.423 8.712 L 84.45 9.647 L 84.45 9.649 L 84.45 13.892 Z M 78.857 13.005 C 79.559 13.005 80.132 12.768 80.599 12.288 L 80.6 12.287 L 80.601 12.286 C 81.075 11.817 81.307 11.211 81.307 10.464 C 81.307 9.719 81.075 9.112 80.601 8.642 L 80.6 8.641 L 80.599 8.64 C 80.132 8.16 79.559 7.924 78.857 7.924 C 78.153 7.924 77.58 8.16 77.104 8.64 L 77.104 8.64 C 76.639 9.122 76.407 9.719 76.407 10.464 C 76.407 11.211 76.639 11.806 77.104 12.288 C 77.58 12.768 78.154 13.005 78.857 13.005 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 22.478 20.864 L 10.639 33.323 C 10.64 33.325 10.641 33.328 10.641 33.331 C 11.004 34.683 12.25 35.68 13.729 35.68 C 14.32 35.68 14.876 35.521 15.351 35.242 L 15.389 35.22 L 28.715 27.596 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 34.455 18.743 L 34.444 18.736 L 28.691 15.429 L 22.21 21.147 L 28.714 27.595 L 34.437 24.321 C 35.44 23.785 36.121 22.736 36.121 21.526 C 36.121 20.325 35.449 19.282 34.455 18.743 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 10.637 9.677 C 10.566 9.937 10.529 10.21 10.529 10.493 L 10.529 32.508 C 10.529 32.791 10.566 33.064 10.638 33.323 L 22.883 21.183 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 22.566 21.5 L 28.693 15.426 L 15.383 7.774 C 14.899 7.486 14.334 7.321 13.729 7.321 C 12.251 7.321 11.003 8.318 10.64 9.673 C 10.639 9.675 10.639 9.675 10.639 9.677 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg
            width="340"
            height="215"
            viewBox="0 0 340 215"
            fill="none"
            id="svg-262421025_24617"
          >
            <rect
              width="340"
              height="215"
              rx="12"
              fill="url(#svg-262421025_24617_paint0_linear_1846_3275)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M101.857 80.3707C107.714 86.2287 107.714 95.7267 101.857 101.584C101.788 101.653 101.705 101.709 101.614 101.746C101.523 101.784 101.425 101.804 101.327 101.804C101.228 101.804 101.131 101.784 101.04 101.746C100.949 101.709 100.866 101.653 100.796 101.584L100.266 101.054C100.126 100.913 100.047 100.722 100.047 100.524C100.047 100.325 100.126 100.134 100.266 99.9937C105.245 95.0137 105.245 86.9407 100.266 81.9617C100.126 81.8211 100.047 81.6304 100.047 81.4317C100.047 81.2329 100.126 81.0423 100.266 80.9017L100.796 80.3717C100.937 80.2312 101.127 80.1523 101.326 80.1523C101.525 80.1523 101.716 80.2312 101.856 80.3717L101.857 80.3707ZM98.6752 83.5527C102.775 87.6527 102.775 94.3017 98.6752 98.4027C98.6056 98.4724 98.5229 98.5277 98.4319 98.5654C98.3408 98.6031 98.2433 98.6225 98.1447 98.6225C98.0462 98.6225 97.9487 98.6031 97.8576 98.5654C97.7666 98.5277 97.6839 98.4724 97.6142 98.4027L97.0842 97.8727C97.0144 97.803 96.959 97.7203 96.9212 97.6291C96.8834 97.538 96.8639 97.4403 96.8639 97.3417C96.8639 97.243 96.8834 97.1454 96.9212 97.0542C96.959 96.9631 97.0144 96.8804 97.0842 96.8107C98.6313 95.2635 99.5005 93.1652 99.5005 90.9772C99.5005 88.7892 98.6313 86.6908 97.0842 85.1437C96.9438 85.0031 96.8649 84.8124 96.8649 84.6137C96.8649 84.4149 96.9438 84.2243 97.0842 84.0837L97.6143 83.5537C97.7549 83.4132 97.9455 83.3343 98.1442 83.3343C98.343 83.3343 98.5336 83.4132 98.6742 83.5537L98.6752 83.5527ZM95.4932 86.7567C96.0505 87.3138 96.4926 87.9753 96.7941 88.7033C97.0957 89.4314 97.251 90.2117 97.251 90.9997C97.251 91.7877 97.0957 92.568 96.7941 93.296C96.4926 94.024 96.0505 94.6855 95.4932 95.2427C95.4236 95.3124 95.3409 95.3677 95.2499 95.4054C95.1588 95.4431 95.0613 95.4625 94.9627 95.4625C94.8642 95.4625 94.7667 95.4431 94.6756 95.4054C94.5846 95.3677 94.5019 95.3124 94.4322 95.2427L93.9022 94.7127C93.8326 94.643 93.7773 94.5603 93.7395 94.4693C93.7018 94.3783 93.6824 94.2807 93.6824 94.1822C93.6824 94.0837 93.7018 93.9861 93.7395 93.8951C93.7773 93.804 93.8326 93.7213 93.9022 93.6517C94.2506 93.3035 94.5269 92.89 94.7154 92.435C94.9039 91.9799 95.0009 91.4922 95.0009 90.9997C95.0009 90.5071 94.9039 90.0194 94.7154 89.5644C94.5269 89.1094 94.2506 88.6959 93.9022 88.3477C93.7618 88.2071 93.6829 88.0164 93.6829 87.8177C93.6829 87.6189 93.7618 87.4283 93.9022 87.2877L94.4322 86.7577C94.5729 86.6172 94.7635 86.5383 94.9622 86.5383C95.161 86.5383 95.3516 86.6172 95.4922 86.7577L95.4932 86.7567Z"
              fill="white"
            />
            <path
              d="M296 24C307.046 24 316 32.9543 316 44C316 55.0457 307.046 64 296 64C284.954 64 276 55.0457 276 44C276 32.9543 284.954 24 296 24ZM291.164 28.1758C291.04 28.1065 290.961 28.1332 290.821 28.1729C286.535 29.3946 282.92 32.2883 280.789 36.2021C278.631 40.0837 278.093 44.6605 279.293 48.9365C280.514 53.2919 283.442 56.9701 287.414 59.1357C289.485 60.2699 292.323 61.0553 294.708 60.9414C296.705 60.8804 298.487 60.2386 299.876 58.7646C301.068 57.5001 301.688 55.729 301.594 53.9902C301.396 50.3356 298.902 48.0396 296.441 45.6973C293.853 43.2332 290.716 40.9714 289.089 37.7412C288.826 37.2195 288.623 36.654 288.479 36.0928C288.423 35.8708 288.308 35.1693 288.245 35.0322L288.197 35.0361C288.054 35.2366 287.924 35.6733 287.836 35.9111C287.301 37.3622 287.122 38.8885 287.343 40.417C287.779 43.4338 290.104 45.5714 292.245 47.5205C293.13 48.3256 294.063 49.1092 294.94 49.9248C296.502 51.3861 298.328 53.1279 298.131 55.458C298.083 56.097 297.863 56.7111 297.494 57.2354C296.63 58.4533 295.369 58.6525 293.992 58.5938C291.785 58.4996 289.762 57.6664 288 56.3633C287.013 55.6312 286.123 54.7777 285.35 53.8232C282.82 50.5446 281.765 46.7934 282.297 42.666C282.806 38.6878 284.858 35.0683 288.011 32.5889C288.315 32.3509 288.635 32.1334 288.968 31.9375C289.371 30.7534 289.791 29.8516 290.62 28.8779C290.73 28.7494 291.179 28.2896 291.164 28.1758ZM297.16 26.9443C295.164 27.0054 293.382 27.6474 291.993 29.1211C290.802 30.3857 290.18 32.1568 290.274 33.8955C290.472 37.55 292.967 39.8462 295.427 42.1885C298.015 44.6525 301.153 46.9143 302.78 50.1445C303.043 50.6662 303.245 51.2318 303.389 51.793C303.446 52.015 303.561 52.7168 303.624 52.8535L303.671 52.8496C303.814 52.6492 303.945 52.2125 304.032 51.9746C304.567 50.5235 304.747 48.9973 304.525 47.4688C304.089 44.452 301.765 42.3143 299.624 40.3652C298.739 39.56 297.805 38.7766 296.928 37.9609C295.366 36.4998 293.541 34.7586 293.737 32.4287C293.786 31.7894 294.006 31.1748 294.375 30.6504C295.239 29.4324 296.5 29.2332 297.877 29.292C300.084 29.3862 302.108 30.2193 303.869 31.5225C304.856 32.2546 305.746 33.108 306.52 34.0625C309.049 37.3411 310.104 41.0923 309.572 45.2197C309.063 49.1979 307.011 52.8175 303.857 55.2969C303.553 55.5349 303.233 55.7524 302.9 55.9482C302.497 57.1323 302.079 58.0341 301.249 59.0078C301.14 59.136 300.689 59.596 300.704 59.71C300.829 59.7796 300.907 59.7527 301.048 59.7129C305.334 58.4911 308.949 55.5976 311.08 51.6836C313.239 47.802 313.775 43.2253 312.575 38.9492C311.355 34.5939 308.427 30.9156 304.455 28.75C302.384 27.6157 299.545 26.8304 297.16 26.9443Z"
              fill="#FAFAFA"
            />
            <path
              d="M38 80.3895C38 77.4129 40.2649 75 43.0588 75H75.9412C78.7351 75 81 77.4129 81 80.3895V101.611C81 104.587 78.7351 107 75.9412 107H43.0588C40.2649 107 38 104.587 38 101.611V80.3895Z"
              fill="url(#svg-262421025_24617_paint1_linear_1846_3275)"
            />
            <path
              d="M38 80.3895C38 77.4129 40.2649 75 43.0588 75H75.9412C78.7351 75 81 77.4129 81 80.3895V101.611C81 104.587 78.7351 107 75.9412 107H43.0588C40.2649 107 38 104.587 38 101.611V80.3895Z"
              fill="url(#svg-262421025_24617_paint2_linear_1846_3275)"
            />
            <path
              d="M43.0586 75.25H75.9414C78.5825 75.2501 80.75 77.5361 80.75 80.3896V101.61C80.75 104.464 78.5825 106.75 75.9414 106.75H43.0586C40.4175 106.75 38.25 104.464 38.25 101.61V80.3896C38.25 77.5361 40.4175 75.2501 43.0586 75.25ZM43.0586 75.4238C40.4613 75.424 38.3828 77.6623 38.3828 80.3896V101.61C38.3828 104.338 40.4613 106.576 43.0586 106.576H75.9414C78.5387 106.576 80.6172 104.338 80.6172 101.61V80.3896C80.6172 77.6623 78.5387 75.424 75.9414 75.4238H43.0586Z"
              stroke="#54585B"
              strokeWidth={0.5}
            />
            <rect
              x="42.5078"
              y="78.425"
              width="15.2525"
              height="6.75713"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="42.5078"
              y="87.4961"
              width="15.2525"
              height="6.75712"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="42.5078"
              y="96.5664"
              width="15.2525"
              height="6.75714"
              rx="3.37857"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="60.8145"
              y="78.425"
              width="15.2525"
              height="6.75713"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="60.8145"
              y="87.4961"
              width="15.2525"
              height="6.75712"
              rx="3.37856"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <rect
              x="60.8145"
              y="96.5664"
              width="15.2525"
              height="6.75714"
              rx="3.37857"
              stroke="#6C6C6C"
              strokeWidth={0.5}
            />
            <path
              d="M40.94 145H42.94V159H40.64V147.46L37.82 148.26L37.26 146.3L40.94 145ZM45.0614 159V157.2L49.9414 152.22C51.1281 151.033 51.7214 150.007 51.7214 149.14C51.7214 148.46 51.5147 147.933 51.1014 147.56C50.7014 147.173 50.1881 146.98 49.5614 146.98C48.3881 146.98 47.5214 147.56 46.9614 148.72L45.0214 147.58C45.4614 146.647 46.0814 145.94 46.8814 145.46C47.6814 144.98 48.5681 144.74 49.5414 144.74C50.7681 144.74 51.8214 145.127 52.7014 145.9C53.5814 146.673 54.0214 147.727 54.0214 149.06C54.0214 150.487 53.2281 152.007 51.6414 153.62L48.4814 156.78H54.2814V159H45.0614ZM61.512 150.72C62.5254 150.96 63.3454 151.433 63.972 152.14C64.612 152.833 64.932 153.707 64.932 154.76C64.932 156.16 64.4587 157.26 63.512 158.06C62.5654 158.86 61.4054 159.26 60.032 159.26C58.9654 159.26 58.0054 159.013 57.152 158.52C56.312 158.027 55.7054 157.307 55.332 156.36L57.292 155.22C57.7054 156.42 58.6187 157.02 60.032 157.02C60.832 157.02 61.4654 156.82 61.932 156.42C62.3987 156.007 62.632 155.453 62.632 154.76C62.632 154.067 62.3987 153.52 61.932 153.12C61.4654 152.72 60.832 152.52 60.032 152.52H59.512L58.592 151.14L61.612 147.16H55.752V145H64.352V146.96L61.512 150.72ZM77.2834 154.34V156.48H75.6834V159H73.3634V156.48H66.4834V154.34L71.3034 145H73.8034L68.9834 154.34H73.3634V150.7H75.6834V154.34H77.2834Z"
              fill="white"
            />
            <path
              d="M92.68 150.72C93.6933 150.96 94.5133 151.433 95.14 152.14C95.78 152.833 96.1 153.707 96.1 154.76C96.1 156.16 95.6267 157.26 94.68 158.06C93.7333 158.86 92.5733 159.26 91.2 159.26C90.1333 159.26 89.1733 159.013 88.32 158.52C87.48 158.027 86.8733 157.307 86.5 156.36L88.46 155.22C88.8733 156.42 89.7867 157.02 91.2 157.02C92 157.02 92.6333 156.82 93.1 156.42C93.5667 156.007 93.8 155.453 93.8 154.76C93.8 154.067 93.5667 153.52 93.1 153.12C92.6333 152.72 92 152.52 91.2 152.52H90.68L89.76 151.14L92.78 147.16H86.92V145H95.52V146.96L92.68 150.72ZM108.451 154.34V156.48H106.851V159H104.531V156.48H97.6514V154.34L102.471 145H104.971L100.151 154.34H104.531V150.7H106.851V154.34H108.451ZM109.413 159V157.2L114.293 152.22C115.48 151.033 116.073 150.007 116.073 149.14C116.073 148.46 115.866 147.933 115.453 147.56C115.053 147.173 114.54 146.98 113.913 146.98C112.74 146.98 111.873 147.56 111.313 148.72L109.373 147.58C109.813 146.647 110.433 145.94 111.233 145.46C112.033 144.98 112.92 144.74 113.893 144.74C115.12 144.74 116.173 145.127 117.053 145.9C117.933 146.673 118.373 147.727 118.373 149.06C118.373 150.487 117.58 152.007 115.993 153.62L112.833 156.78H118.633V159H109.413ZM123.124 145H125.124V159H122.824V147.46L120.004 148.26L119.444 146.3L123.124 145Z"
              fill="white"
            />
            <path
              d="M138.94 145H140.94V159H138.64V147.46L135.82 148.26L135.26 146.3L138.94 145ZM152.841 149.52C152.841 150.587 152.561 151.527 152.001 152.34L147.581 159H144.941L148.141 154.3H147.901C146.448 154.3 145.255 153.86 144.321 152.98C143.401 152.087 142.941 150.933 142.941 149.52C142.941 148.107 143.401 146.96 144.321 146.08C145.255 145.187 146.448 144.74 147.901 144.74C149.355 144.74 150.541 145.187 151.461 146.08C152.381 146.96 152.841 148.107 152.841 149.52ZM145.241 149.52C145.241 150.293 145.488 150.92 145.981 151.4C146.488 151.88 147.128 152.12 147.901 152.12C148.675 152.12 149.308 151.887 149.801 151.42C150.295 150.94 150.541 150.307 150.541 149.52C150.541 148.733 150.295 148.107 149.801 147.64C149.308 147.16 148.675 146.92 147.901 146.92C147.128 146.92 146.488 147.16 145.981 147.64C145.488 148.107 145.241 148.733 145.241 149.52ZM163.819 154.34V156.48H162.219V159H159.899V156.48H153.019V154.34L157.839 145H160.339L155.519 154.34H159.899V150.7H162.219V154.34H163.819ZM174.17 149.52C174.17 150.587 173.89 151.527 173.33 152.34L168.91 159H166.27L169.47 154.3H169.23C167.776 154.3 166.583 153.86 165.65 152.98C164.73 152.087 164.27 150.933 164.27 149.52C164.27 148.107 164.73 146.96 165.65 146.08C166.583 145.187 167.776 144.74 169.23 144.74C170.683 144.74 171.87 145.187 172.79 146.08C173.71 146.96 174.17 148.107 174.17 149.52ZM166.57 149.52C166.57 150.293 166.816 150.92 167.31 151.4C167.816 151.88 168.456 152.12 169.23 152.12C170.003 152.12 170.636 151.887 171.13 151.42C171.623 150.94 171.87 150.307 171.87 149.52C171.87 148.733 171.623 148.107 171.13 147.64C170.636 147.16 170.003 146.92 169.23 146.92C168.456 146.92 167.816 147.16 167.31 147.64C166.816 148.107 166.57 148.733 166.57 149.52Z"
              fill="white"
            />
            <path
              d="M188.5 150.28C189.833 150.28 190.96 150.68 191.88 151.48C192.8 152.267 193.26 153.36 193.26 154.76C193.26 156.16 192.787 157.26 191.84 158.06C190.893 158.86 189.733 159.26 188.36 159.26C187.253 159.26 186.273 159.007 185.42 158.5C184.567 157.98 183.96 157.233 183.6 156.26L185.58 155.12C185.953 156.387 186.88 157.02 188.36 157.02C189.147 157.02 189.773 156.82 190.24 156.42C190.72 156.007 190.96 155.453 190.96 154.76C190.96 154.067 190.727 153.52 190.26 153.12C189.793 152.72 189.173 152.52 188.4 152.52H184.32L184.86 145H192.66V147.16H186.98L186.74 150.28H188.5ZM199.358 149.7C200.812 149.7 201.998 150.147 202.918 151.04C203.838 151.92 204.298 153.067 204.298 154.48C204.298 155.893 203.838 157.047 202.918 157.94C201.998 158.82 200.812 159.26 199.358 159.26C197.892 159.26 196.698 158.82 195.778 157.94C194.858 157.047 194.398 155.893 194.398 154.48C194.398 153.413 194.678 152.473 195.238 151.66L199.678 145H202.298L199.098 149.7H199.358ZM199.358 157.08C200.132 157.08 200.765 156.847 201.258 156.38C201.752 155.9 201.998 155.267 201.998 154.48C201.998 153.693 201.752 153.067 201.258 152.6C200.765 152.12 200.132 151.88 199.358 151.88C198.572 151.88 197.932 152.12 197.438 152.6C196.945 153.067 196.698 153.693 196.698 154.48C196.698 155.267 196.945 155.9 197.438 156.38C197.932 156.847 198.572 157.08 199.358 157.08ZM203.886 145H212.786V147L207.866 159H205.446L210.286 147.2H203.886V145ZM221.069 151.72C222.443 152.48 223.129 153.613 223.129 155.12C223.129 156.4 222.683 157.413 221.789 158.16C220.896 158.893 219.709 159.26 218.229 159.26C216.749 159.26 215.556 158.893 214.649 158.16C213.756 157.413 213.309 156.4 213.309 155.12C213.309 154.4 213.489 153.747 213.849 153.16C214.209 152.56 214.716 152.08 215.369 151.72C214.316 151.027 213.789 150.04 213.789 148.76C213.789 147.48 214.216 146.493 215.069 145.8C215.923 145.093 216.976 144.74 218.229 144.74C219.469 144.74 220.516 145.093 221.369 145.8C222.236 146.493 222.669 147.48 222.669 148.76C222.669 150.04 222.136 151.027 221.069 151.72ZM218.229 146.92C217.603 146.92 217.089 147.087 216.689 147.42C216.289 147.753 216.089 148.233 216.089 148.86C216.089 149.46 216.289 149.933 216.689 150.28C217.103 150.627 217.616 150.8 218.229 150.8C218.829 150.8 219.336 150.627 219.749 150.28C220.163 149.933 220.369 149.46 220.369 148.86C220.369 148.233 220.163 147.753 219.749 147.42C219.349 147.087 218.843 146.92 218.229 146.92ZM218.229 157.08C219.003 157.08 219.629 156.893 220.109 156.52C220.589 156.133 220.829 155.593 220.829 154.9C220.829 154.207 220.589 153.673 220.109 153.3C219.629 152.913 219.003 152.72 218.229 152.72C217.443 152.72 216.809 152.913 216.329 153.3C215.849 153.673 215.609 154.207 215.609 154.9C215.609 155.593 215.849 156.133 216.329 156.52C216.809 156.893 217.443 157.08 218.229 157.08Z"
              fill="white"
            />
            <path
              d="M41.848 194.208C40.7707 194.208 39.8533 193.963 39.096 193.472C38.3493 192.981 37.8267 192.309 37.528 191.456L39.112 190.528C39.56 191.787 40.488 192.416 41.896 192.416C42.5893 192.416 43.1067 192.283 43.448 192.016C43.8 191.739 43.976 191.381 43.976 190.944C43.976 190.485 43.7893 190.139 43.416 189.904C43.0427 189.659 42.3813 189.392 41.432 189.104C40.8987 188.944 40.4667 188.795 40.136 188.656C39.8053 188.517 39.4533 188.325 39.08 188.08C38.7173 187.824 38.4453 187.509 38.264 187.136C38.0827 186.763 37.992 186.325 37.992 185.824C37.992 184.832 38.344 184.048 39.048 183.472C39.752 182.885 40.6 182.592 41.592 182.592C42.488 182.592 43.272 182.811 43.944 183.248C44.616 183.685 45.1333 184.288 45.496 185.056L43.944 185.952C43.4747 184.907 42.6907 184.384 41.592 184.384C41.0587 184.384 40.632 184.512 40.312 184.768C39.992 185.013 39.832 185.349 39.832 185.776C39.832 186.192 39.992 186.523 40.312 186.768C40.6427 187.003 41.2347 187.253 42.088 187.52C42.5147 187.659 42.824 187.765 43.016 187.84C43.2187 187.904 43.496 188.011 43.848 188.16C44.2107 188.309 44.4827 188.459 44.664 188.608C44.8453 188.757 45.0373 188.944 45.24 189.168C45.4533 189.392 45.6027 189.648 45.688 189.936C45.7733 190.224 45.816 190.549 45.816 190.912C45.816 191.925 45.448 192.731 44.712 193.328C43.9867 193.915 43.032 194.208 41.848 194.208ZM54.275 182.8V184.56H51.123V194H49.283V184.56H46.115V182.8H54.275ZM62.1348 194L61.3508 191.744H56.5828L55.7988 194H53.7988L57.8628 182.8H60.0708L64.1188 194H62.1348ZM57.1908 190.016H60.7428L58.9668 184.96L57.1908 190.016ZM70.1973 194.208C68.5119 194.208 67.1146 193.653 66.0053 192.544C64.8959 191.424 64.3413 190.043 64.3413 188.4C64.3413 186.757 64.8959 185.381 66.0053 184.272C67.1146 183.152 68.5119 182.592 70.1973 182.592C71.2106 182.592 72.1439 182.832 72.9973 183.312C73.8613 183.792 74.5333 184.443 75.0133 185.264L73.4133 186.192C73.1146 185.637 72.6773 185.2 72.1013 184.88C71.5359 184.549 70.9013 184.384 70.1973 184.384C69.0026 184.384 68.0319 184.763 67.2853 185.52C66.5493 186.277 66.1813 187.237 66.1813 188.4C66.1813 189.563 66.5493 190.523 67.2853 191.28C68.0319 192.037 69.0026 192.416 70.1973 192.416C70.9013 192.416 71.5413 192.256 72.1173 191.936C72.6933 191.605 73.1253 191.163 73.4133 190.608L75.0133 191.52C74.5439 192.341 73.8773 192.997 73.0133 193.488C72.1599 193.968 71.2213 194.208 70.1973 194.208ZM84.8843 182.8L80.9803 189.552V194H79.1403V189.552L75.2363 182.8H77.3323L80.0683 187.76L82.7883 182.8H84.8843ZM93.8168 194.208C92.7394 194.208 91.8221 193.963 91.0648 193.472C90.3181 192.981 89.7954 192.309 89.4967 191.456L91.0807 190.528C91.5288 191.787 92.4568 192.416 93.8648 192.416C94.5581 192.416 95.0754 192.283 95.4168 192.016C95.7688 191.739 95.9448 191.381 95.9448 190.944C95.9448 190.485 95.7581 190.139 95.3848 189.904C95.0114 189.659 94.3501 189.392 93.4008 189.104C92.8674 188.944 92.4354 188.795 92.1048 188.656C91.7741 188.517 91.4221 188.325 91.0488 188.08C90.6861 187.824 90.4141 187.509 90.2328 187.136C90.0514 186.763 89.9608 186.325 89.9608 185.824C89.9608 184.832 90.3128 184.048 91.0168 183.472C91.7208 182.885 92.5688 182.592 93.5608 182.592C94.4568 182.592 95.2408 182.811 95.9128 183.248C96.5848 183.685 97.1021 184.288 97.4648 185.056L95.9128 185.952C95.4434 184.907 94.6594 184.384 93.5608 184.384C93.0274 184.384 92.6008 184.512 92.2808 184.768C91.9608 185.013 91.8008 185.349 91.8008 185.776C91.8008 186.192 91.9608 186.523 92.2808 186.768C92.6114 187.003 93.2034 187.253 94.0568 187.52C94.4834 187.659 94.7928 187.765 94.9848 187.84C95.1874 187.904 95.4648 188.011 95.8168 188.16C96.1794 188.309 96.4514 188.459 96.6328 188.608C96.8141 188.757 97.0061 188.944 97.2088 189.168C97.4221 189.392 97.5714 189.648 97.6568 189.936C97.7421 190.224 97.7847 190.549 97.7847 190.912C97.7847 191.925 97.4168 192.731 96.6808 193.328C95.9554 193.915 95.0008 194.208 93.8168 194.208ZM110.012 182.8V194H108.172V186.016L104.764 191.648H104.54L101.132 186V194H99.2919V182.8H101.276L104.652 188.4L108.044 182.8H110.012ZM112.245 182.8H114.085V194H112.245V182.8ZM123.603 182.8V184.56H120.451V194H118.611V184.56H115.443V182.8H123.603ZM131.604 182.8H133.444V194H131.604V189.152H126.804V194H124.964V182.8H126.804V187.392H131.604V182.8Z"
              fill="white"
            />
            <path
              d="M273.881 174V166.727H278.27V167.509H274.761V169.966H278.043V170.747H274.761V173.219H278.327V174H273.881ZM280.283 166.727L282.158 169.753H282.215L284.09 166.727H285.127L282.84 170.364L285.127 174H284.09L282.215 171.031H282.158L280.283 174H279.246L281.59 170.364L279.246 166.727H280.283ZM286.273 174V166.727H288.731C289.301 166.727 289.768 166.83 290.13 167.036C290.494 167.24 290.764 167.516 290.939 167.864C291.115 168.212 291.202 168.6 291.202 169.028C291.202 169.457 291.115 169.846 290.939 170.197C290.767 170.547 290.499 170.826 290.137 171.035C289.775 171.241 289.311 171.344 288.745 171.344H286.983V170.562H288.716C289.107 170.562 289.421 170.495 289.657 170.36C289.894 170.225 290.066 170.043 290.172 169.813C290.281 169.581 290.336 169.32 290.336 169.028C290.336 168.737 290.281 168.477 290.172 168.247C290.066 168.018 289.893 167.838 289.654 167.707C289.415 167.575 289.098 167.509 288.702 167.509H287.154V174H286.273ZM293.502 166.727V174H292.621V166.727H293.502ZM295.267 174V166.727H297.725C298.293 166.727 298.759 166.824 299.124 167.018C299.489 167.21 299.758 167.474 299.934 167.81C300.109 168.147 300.196 168.529 300.196 168.957C300.196 169.386 300.109 169.766 299.934 170.097C299.758 170.429 299.49 170.689 299.127 170.879C298.765 171.066 298.302 171.159 297.739 171.159H295.75V170.364H297.711C298.099 170.364 298.411 170.307 298.648 170.193C298.887 170.08 299.06 169.919 299.167 169.71C299.275 169.5 299.33 169.249 299.33 168.957C299.33 168.666 299.275 168.412 299.167 168.194C299.058 167.976 298.884 167.808 298.645 167.69C298.405 167.569 298.089 167.509 297.696 167.509H296.148V174H295.267ZM298.691 170.733L300.48 174H299.458L297.696 170.733H298.691ZM300.795 166.727H301.803L303.82 170.122H303.906L305.923 166.727H306.931L304.303 171.003V174H303.423V171.003L300.795 166.727Z"
              fill="white"
            />
            <path
              d="M276.78 189.168C275.732 189.168 274.908 188.772 274.308 187.98C273.716 187.18 273.42 186.12 273.42 184.8C273.42 183.48 273.716 182.424 274.308 181.632C274.908 180.832 275.732 180.432 276.78 180.432C277.836 180.432 278.66 180.832 279.252 181.632C279.844 182.424 280.14 183.48 280.14 184.8C280.14 186.12 279.844 187.18 279.252 187.98C278.66 188.772 277.836 189.168 276.78 189.168ZM275.508 186.852C275.796 187.316 276.22 187.548 276.78 187.548C277.34 187.548 277.764 187.312 278.052 186.84C278.348 186.368 278.496 185.688 278.496 184.8C278.496 183.904 278.348 183.22 278.052 182.748C277.764 182.276 277.34 182.04 276.78 182.04C276.22 182.04 275.796 182.276 275.508 182.748C275.22 183.22 275.076 183.904 275.076 184.8C275.076 185.696 275.22 186.38 275.508 186.852ZM284.455 184.008C285.023 184.176 285.483 184.472 285.835 184.896C286.195 185.312 286.375 185.816 286.375 186.408C286.375 187.272 286.083 187.948 285.499 188.436C284.923 188.924 284.215 189.168 283.375 189.168C282.719 189.168 282.131 189.02 281.611 188.724C281.099 188.42 280.727 187.976 280.495 187.392L281.911 186.576C282.119 187.224 282.607 187.548 283.375 187.548C283.799 187.548 284.127 187.448 284.359 187.248C284.599 187.04 284.719 186.76 284.719 186.408C284.719 186.064 284.599 185.788 284.359 185.58C284.127 185.372 283.799 185.268 283.375 185.268H283.015L282.379 184.308L284.035 182.148H280.747V180.6H286.027V181.968L284.455 184.008ZM287.838 190.2H287.154L291.954 179.4H292.638L287.838 190.2ZM293.363 189V187.764L296.231 184.812C296.871 184.14 297.191 183.58 297.191 183.132C297.191 182.804 297.087 182.54 296.879 182.34C296.679 182.14 296.419 182.04 296.099 182.04C295.467 182.04 294.999 182.368 294.695 183.024L293.303 182.208C293.567 181.632 293.947 181.192 294.443 180.888C294.939 180.584 295.483 180.432 296.075 180.432C296.835 180.432 297.487 180.672 298.031 181.152C298.575 181.624 298.847 182.264 298.847 183.072C298.847 183.944 298.387 184.84 297.467 185.76L295.823 187.404H298.979V189H293.363ZM304.611 184.632C305.387 185.096 305.775 185.772 305.775 186.66C305.775 187.436 305.503 188.048 304.959 188.496C304.423 188.944 303.691 189.168 302.763 189.168C301.827 189.168 301.091 188.944 300.555 188.496C300.019 188.048 299.751 187.436 299.751 186.66C299.751 185.772 300.135 185.096 300.903 184.632C300.319 184.208 300.027 183.628 300.027 182.892C300.027 182.116 300.287 181.512 300.807 181.08C301.335 180.648 301.987 180.432 302.763 180.432C303.539 180.432 304.187 180.648 304.707 181.08C305.227 181.512 305.487 182.116 305.487 182.892C305.487 183.636 305.195 184.216 304.611 184.632ZM303.543 182.256C303.343 182.08 303.083 181.992 302.763 181.992C302.443 181.992 302.183 182.08 301.983 182.256C301.783 182.432 301.683 182.672 301.683 182.976C301.683 183.28 301.783 183.524 301.983 183.708C302.183 183.884 302.443 183.972 302.763 183.972C303.083 183.972 303.343 183.884 303.543 183.708C303.743 183.524 303.843 183.28 303.843 182.976C303.843 182.672 303.743 182.432 303.543 182.256ZM301.767 187.308C302.023 187.508 302.355 187.608 302.763 187.608C303.171 187.608 303.499 187.508 303.747 187.308C304.003 187.1 304.131 186.812 304.131 186.444C304.131 186.084 304.003 185.804 303.747 185.604C303.499 185.396 303.171 185.292 302.763 185.292C302.355 185.292 302.023 185.396 301.767 185.604C301.519 185.804 301.395 186.084 301.395 186.444C301.395 186.812 301.519 187.1 301.767 187.308Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-262421025_24617_paint0_linear_1846_3275"
                x1="20"
                y1="-104.5"
                x2="340"
                y2="240.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868787" />
                <stop offset="0.5" stopColor="#E5E5E5" />
                <stop offset="1" stopColor="#BFC3C3" />
              </linearGradient>
              <linearGradient
                id="svg-262421025_24617_paint1_linear_1846_3275"
                x1="46.6"
                y1="71.2519"
                x2="103.296"
                y2="101.534"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#A4A4A4" stopOpacity="0.56" />
                <stop offset="0.229167" stopColor="white" stopOpacity="0.72" />
                <stop
                  offset="0.479167"
                  stopColor="#C5C5C5"
                  stopOpacity="0.484186"
                />
                <stop offset="0.729167" stopColor="white" stopOpacity="0.99" />
                <stop offset="1" stopColor="#C5C5C5" stopOpacity="0.74" />
              </linearGradient>
              <linearGradient
                id="svg-262421025_24617_paint2_linear_1846_3275"
                x1="46.6"
                y1="71.2519"
                x2="103.296"
                y2="101.534"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#A4A4A4" stopOpacity="0.56" />
                <stop offset="0.229167" stopColor="white" stopOpacity="0.72" />
                <stop
                  offset="0.479167"
                  stopColor="#C5C5C5"
                  stopOpacity="0.484186"
                />
                <stop offset="0.729167" stopColor="white" stopOpacity="0.99" />
                <stop offset="1" stopColor="#C5C5C5" stopOpacity="0.74" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="40"
            height="43"
            viewBox="0 0 40 43"
            fill="none"
            id="svg-1649909847_1240"
          >
            <path
              d="M36.1859 8.97437C34.2091 8.82968 32.3117 8.69871 30.4161 8.5607C30.0381 8.53488 29.7713 8.51625 29.3027 8.40578C28.9538 8.32739 28.2175 8.1452 28.3809 7.7889C28.5466 7.50869 28.6999 7.33086 29.3618 7.31192C31.071 7.27169 32.7725 7.48603 34.4617 7.68956C35.9533 7.8703 37.0879 8.03088 38.3981 8.26871C39.0099 8.37982 39.1702 8.7398 38.9525 9.2703C38.757 9.74634 38.5648 10.2384 38.2834 10.6687C37.2773 12.226 36.2346 13.7508 35.2023 15.2934C35.0752 15.4859 34.9877 15.6436 34.8038 15.851C34.5785 16.1001 34.4284 16.2939 34.1482 16.1282C33.8802 15.9734 34.0075 15.5546 34.1134 15.3565C34.9623 13.6816 36.771 10.2559 36.8257 10.0517C35.7445 10.3961 34.7367 10.6922 33.7438 11.0452C26.8409 13.5362 20.1743 16.4981 14.2934 21.0067C9.6382 24.5755 5.48591 28.6339 1.96319 33.329C1.75337 33.605 1.51727 33.8663 1.28495 34.1136C0.975009 34.4533 0.753635 34.5751 0.566872 34.4269C0.253973 34.1015 0.405556 33.8175 0.506825 33.5805C0.70232 33.1044 1.00157 32.6637 1.29001 32.2352C5.208 26.5439 10.2336 21.9873 15.8798 18.0725C21.6746 14.0542 28.1275 11.4955 34.8208 9.47672C35.1779 9.38368 36.0392 9.07095 36.1859 8.97437Z"
              fill="black"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg86067174_1236"
          >
            <path
              d="M26.2558 44.7319C27.3695 43.0923 28.4316 41.5146 29.4989 39.942C29.7103 39.6275 29.8598 39.4058 30.1898 39.0552C30.4321 38.7922 30.958 38.2457 31.1849 38.5654C31.3447 38.8489 31.4221 39.0706 31.1076 39.6533C30.2878 41.1537 29.2514 42.52 28.2305 43.8812C27.3282 45.0825 26.6219 45.9848 25.7608 47.0006C25.3586 47.4749 24.9668 47.4337 24.6162 46.9799C24.3017 46.5726 23.9717 46.1601 23.7397 45.7012C22.8941 44.0513 22.0949 42.3859 21.2751 40.7206C21.172 40.5143 21.0792 40.3596 20.9915 40.0967C20.8884 39.777 20.7956 39.5502 21.0792 39.3903C21.3473 39.2356 21.6463 39.5553 21.7649 39.7461C22.791 41.3187 24.8534 44.5979 25.0029 44.7474C25.2452 43.6388 25.4927 42.618 25.6835 41.5816C26.9776 34.3581 27.7459 27.1036 26.7817 19.7563C26.0186 13.9404 24.5801 8.31518 22.2754 2.91686C22.1413 2.59719 22.033 2.26205 21.9351 1.93723C21.7959 1.49897 21.801 1.24632 22.0227 1.15867C22.461 1.0504 22.6311 1.32366 22.7858 1.5299C23.1003 1.93723 23.3323 2.41673 23.5592 2.88077C26.529 9.11952 27.9624 15.7501 28.5296 22.5973C29.1122 29.6249 28.1016 36.4927 26.5033 43.2986C26.4053 43.6543 26.2455 44.5566 26.2558 44.7319Z"
              fill="black"
            />
          </svg>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            id="svg-484590915_1528"
          >
            <mask
              id="svg-484590915_1528_mask0_214_14103"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="16"
              height="16"
            >
              <path
                d="M15.2411 7.77411C15.2411 11.8651 11.9247 15.1815 7.83366 15.1815C3.74266 15.1815 0.426254 11.8651 0.426254 7.77411C0.426254 3.68311 3.74266 0.366699 7.83366 0.366699C11.9247 0.366699 15.2411 3.68311 15.2411 7.77411Z"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#svg-484590915_1528_mask0_214_14103)"></g>
            <path
              d="M10.8485 5.03449C10.7968 4.91005 10.6979 4.81117 10.5735 4.75949C10.5122 4.7334 10.4465 4.71955 10.3799 4.71875H5.28734C5.15228 4.71875 5.02275 4.7724 4.92724 4.86791C4.83174 4.96341 4.77808 5.09295 4.77808 5.22801C4.77808 5.36307 4.83174 5.49261 4.92724 5.58811C5.02275 5.68361 5.15228 5.73727 5.28734 5.73727H9.15262L4.92577 9.95903C4.87804 10.0064 4.84015 10.0627 4.8143 10.1248C4.78844 10.1868 4.77513 10.2534 4.77513 10.3206C4.77513 10.3878 4.78844 10.4544 4.8143 10.5165C4.84015 10.5785 4.87804 10.6348 4.92577 10.6822C4.97311 10.7299 5.02944 10.7678 5.09149 10.7936C5.15355 10.8195 5.22012 10.8328 5.28734 10.8328C5.35457 10.8328 5.42113 10.8195 5.48319 10.7936C5.54525 10.7678 5.60158 10.7299 5.64892 10.6822L9.87068 6.45532V10.3206C9.87068 10.4557 9.92433 10.5852 10.0198 10.6807C10.1153 10.7762 10.2449 10.8299 10.3799 10.8299C10.515 10.8299 10.6445 10.7762 10.74 10.6807C10.8355 10.5852 10.8892 10.4557 10.8892 10.3206V5.22801C10.8884 5.16146 10.8745 5.09571 10.8485 5.03449V5.03449Z"
              fill="#FF6E66"
            />
          </svg>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            id="svg-134609349_447"
          >
            <path
              d="M12.2194 5.21967C12.5122 4.92678 12.987 4.92678 13.2799 5.21967C13.5728 5.51256 13.5728 5.98732 13.2799 6.28022L8.10998 11.4501C7.84392 11.7162 7.42225 11.7435 7.12365 11.5146L4.29357 9.34467C3.96489 9.09263 3.90288 8.62259 4.1549 8.29389C4.40694 7.96521 4.87698 7.90319 5.20568 8.15522L7.5133 9.92475L12.2194 5.21967Z"
              fill="black"
            />
          </svg>
          <svg
            width="196"
            height="196"
            viewBox="0 0 196 196"
            fill="none"
            id="svg829552244_2744"
          >
            <path
              d="M97.8955 0C151.962 0 195.791 43.8294 195.791 97.8955C195.791 151.962 151.962 195.791 97.8955 195.791C43.8293 195.791 7.01047e-05 151.962 0 97.8955C0 43.8294 43.8293 9.07232e-05 97.8955 0ZM74.2256 20.4414C73.6144 20.1009 73.2324 20.2321 72.5449 20.4268C51.566 26.407 33.8709 40.5696 23.4395 59.7275C12.874 78.7275 10.2446 101.13 16.1191 122.061C22.0941 143.379 36.4269 161.381 55.8672 171.981C66.0066 177.534 79.9001 181.378 91.5732 180.82C101.346 180.522 110.07 177.38 116.868 170.165C122.7 163.975 125.738 155.306 125.277 146.796C124.308 128.907 112.099 117.666 100.058 106.201C87.3897 94.14 72.0285 83.0712 64.0645 67.2598C62.778 64.7058 61.7885 61.9377 61.085 59.1904C60.8065 58.103 60.2419 54.666 59.9346 53.999L59.7051 54.0215C59.0049 55.0027 58.3648 57.1395 57.9355 58.3037C55.316 65.4067 54.4393 72.8772 55.5225 80.3594C57.6592 95.1261 69.0327 105.589 79.5146 115.13C83.8448 119.071 88.4182 122.904 92.7109 126.896C100.355 134.049 109.29 142.572 108.327 153.978C108.091 157.107 107.013 160.115 105.207 162.682C100.977 168.643 94.8094 169.616 88.0684 169.328C77.2665 168.867 67.3603 164.789 58.7373 158.41C53.908 154.827 49.5487 150.65 45.7637 145.978C33.3815 129.929 28.2164 111.568 30.8193 91.3652C33.3117 71.8932 43.3565 54.178 58.79 42.042C60.2796 40.8763 61.8457 39.8097 63.4766 38.8506C65.4522 33.0548 67.5013 28.6438 71.5615 23.8779C72.0962 23.2504 74.3011 20.9991 74.2256 20.4414ZM139.281 23.251C129.142 17.6987 115.248 13.8542 103.575 14.4121C93.8029 14.7108 85.0781 17.8517 78.2803 25.0664C72.4479 31.2563 69.4101 39.9258 69.8711 48.4365C70.8403 66.3252 83.0491 77.5651 95.0908 89.0303C107.759 101.091 123.12 112.161 131.084 127.973C132.37 130.527 133.36 133.295 134.063 136.042C134.342 137.13 134.907 140.565 135.214 141.232L135.443 141.211C136.144 140.23 136.784 138.093 137.213 136.929C139.832 129.826 140.709 122.355 139.626 114.873C137.489 100.106 126.116 89.6422 115.634 80.1016C111.304 76.1605 106.73 72.3274 102.438 68.335C94.7932 61.1825 85.858 52.6593 86.8213 41.2539C87.0576 38.1245 88.1357 35.1168 89.9414 32.5498C94.1714 26.5885 100.339 25.6157 107.08 25.9033C117.882 26.3641 127.788 30.4425 136.411 36.8213C141.241 40.405 145.6 44.5827 149.385 49.2549C161.767 65.3032 166.932 83.6642 164.329 103.867C161.837 123.339 151.791 141.054 136.357 153.19C134.868 154.356 133.303 155.423 131.672 156.382C129.696 162.177 127.647 166.588 123.587 171.354C123.053 171.981 120.847 174.232 120.923 174.79C121.534 175.131 121.916 174.999 122.604 174.805C143.582 168.824 161.278 154.663 171.709 135.505C182.275 116.505 184.904 94.1016 179.029 73.1709C173.054 51.8526 158.721 33.8511 139.281 23.251Z"
              fill="black"
            />
          </svg>
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            id="svg-215374271_2109"
          >
            <path
              d="M12.2258 5.89922C12.3132 5.98632 12.3825 6.08981 12.4298 6.20376C12.4772 6.31772 12.5015 6.43989 12.5015 6.56328C12.5015 6.68667 12.4772 6.80884 12.4298 6.9228C12.3825 7.03675 12.3132 7.14025 12.2258 7.22734L7.85078 11.6023C7.76369 11.6897 7.66019 11.7591 7.54624 11.8064C7.43228 11.8537 7.31011 11.8781 7.18672 11.8781C7.06333 11.8781 6.94116 11.8537 6.8272 11.8064C6.71325 11.7591 6.60976 11.6897 6.52266 11.6023L4.64766 9.72734C4.56045 9.64014 4.49128 9.53661 4.44408 9.42267C4.39689 9.30873 4.3726 9.18661 4.3726 9.06328C4.3726 8.93995 4.39689 8.81783 4.44408 8.70389C4.49128 8.58995 4.56045 8.48642 4.64766 8.39922C4.73487 8.31201 4.83839 8.24284 4.95233 8.19564C5.06627 8.14845 5.18839 8.12415 5.31172 8.12415C5.43505 8.12415 5.55717 8.14845 5.67111 8.19564C5.78505 8.24284 5.88858 8.31201 5.97578 8.39922L7.1875 9.60938L10.8992 5.89688C10.9864 5.80986 11.09 5.7409 11.2039 5.69392C11.3178 5.64694 11.4398 5.62287 11.563 5.62309C11.6862 5.62331 11.8081 5.64781 11.9219 5.69519C12.0356 5.74257 12.1389 5.8119 12.2258 5.89922ZM16.875 8.4375C16.875 10.1063 16.3802 11.7376 15.453 13.1251C14.5259 14.5127 13.2081 15.5941 11.6664 16.2327C10.1246 16.8713 8.42814 17.0384 6.79143 16.7129C5.15471 16.3873 3.6513 15.5837 2.47129 14.4037C1.29129 13.2237 0.487691 11.7203 0.162128 10.0836C-0.163435 8.44686 0.00365585 6.75036 0.64227 5.20861C1.28088 3.66686 2.36234 2.3491 3.74988 1.42198C5.13742 0.494851 6.76872 0 8.4375 0C10.6745 0.00248142 12.8192 0.892227 14.401 2.47403C15.9828 4.05583 16.8725 6.2005 16.875 8.4375ZM15 8.4375C15 7.13956 14.6151 5.87077 13.894 4.79157C13.1729 3.71237 12.148 2.87124 10.9489 2.37454C9.74972 1.87784 8.43022 1.74788 7.15722 2.0011C5.88422 2.25431 4.7149 2.87933 3.79712 3.79711C2.87933 4.71489 2.25432 5.88422 2.0011 7.15722C1.74788 8.43022 1.87784 9.74972 2.37454 10.9489C2.87124 12.148 3.71238 13.1729 4.79157 13.894C5.87077 14.6151 7.13956 15 8.4375 15C10.1774 14.9981 11.8455 14.3061 13.0758 13.0758C14.3061 11.8455 14.9981 10.1774 15 8.4375Z"
              fill="#22C55E"
            />
          </svg>
          <svg
            width="48"
            height="47"
            viewBox="0 0 48 47"
            fill="none"
            id="svg-705979310_561"
          >
            <path
              d="M47.9382 23.3454C47.9382 36.4095 37.037 47 23.9682 47C10.8994 47 0 36.4077 0 23.3454C0 10.283 10.9012 0 23.97 0C37.0389 0 47.94 10.2813 47.94 23.3454H47.9382Z"
              fill="url(#svg-705979310_561_paint0_linear_1441_10670)"
            />
            <defs>
              <linearGradient
                id="svg-705979310_561_paint0_linear_1441_10670"
                x1="45.0436"
                y1="3.13334"
                x2="-2.2064"
                y2="10.7229"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.48255" stopColor="#1C6BF5" />
                <stop offset="1" stopColor="#1E45B4" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="24"
            viewBox="0 0 20 24"
            fill="none"
            id="svg-583340053_1609"
          >
            <path
              d="M18.802 19.7673H17.4382C17.1321 19.7673 16.8827 20.0157 16.8827 20.3224V20.4981C16.8827 20.8049 16.6332 21.0532 16.3273 21.0532H3.41402C2.92055 21.0532 2.67293 20.4555 3.02133 20.1061L8.46609 14.6627H17.1675C17.2223 14.6627 17.2684 14.5404 17.2684 14.3896V12.7614C17.2684 12.6107 17.2241 12.4883 17.1675 12.4883H10.6419L11.6909 11.44C11.9085 11.2236 11.9085 10.8725 11.6909 10.6543L10.626 9.59012H17.1657C17.2206 9.59012 17.2665 9.4678 17.2665 9.31693V7.68873C17.2665 7.53798 17.2223 7.41566 17.1657 7.41566H8.45027L7.73555 6.70079L6.84937 5.81402L4.45594 3.42137C4.10578 3.07192 4.3534 2.4742 4.84863 2.4742H16.3255C16.6315 2.4742 16.881 2.72259 16.881 3.02939V3.20493C16.881 3.51184 17.1304 3.76188 17.4364 3.76188H18.8003C19.1063 3.76188 19.3557 3.5136 19.3557 3.20681V0.555187C19.3557 0.248277 19.1063 0 18.8003 0H0.557226C0.249491 0 0.00175685 0.248277 0.00175685 0.555187V2.47067L0.00539012 2.4742L3.34687 5.81402L4.23305 6.70079L4.94777 7.41566H2.19C2.13516 7.41566 2.0891 7.53798 2.0891 7.68873V9.31693C2.0891 9.4678 2.1334 9.59012 2.19 9.59012H7.12172L8.1866 10.6543C8.40422 10.8707 8.40422 11.2218 8.1866 11.44L7.13766 12.4883H2.19C2.13516 12.4883 2.0891 12.6107 2.0891 12.7614V14.3896C2.0891 14.5404 2.1334 14.6627 2.19 14.6627H4.96371L0.162773 19.4622C0.0583591 19.5669 0 19.707 0 19.8542V22.9723C0 23.2791 0.249492 23.5275 0.555469 23.5275H18.8003C19.1063 23.5275 19.3557 23.2791 19.3557 22.9723V20.3207C19.3557 20.0139 19.1063 19.7655 18.8003 19.7655L18.802 19.7673Z"
              fill="white"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-615147730_250"
          >
            <path
              d="M0 0H0.952739V3.52559L4.46836 0H5.81954L2.81836 2.91506L5.90274 7.23342H4.63125L2.10704 3.60443L0.952739 4.71234V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-145844853_1010"
          >
            <path
              d="M3.23555 3.31385C3.69375 3.31385 4.05586 3.22197 4.32071 3.03808C4.58907 2.85431 4.72383 2.52273 4.72383 2.04344C4.72383 1.52809 4.5375 1.17688 4.16367 0.989703C3.96445 0.891238 3.69727 0.842005 3.36328 0.842005H0.976172V3.31385H3.23555ZM0 0H3.33868C3.88829 0 4.3418 0.0804881 4.69922 0.241346C5.37657 0.549901 5.71524 1.11942 5.71524 1.94991C5.71524 2.38325 5.62618 2.73775 5.44571 3.01352C5.26875 3.2893 5.02031 3.51078 4.69922 3.67822C4.98047 3.79314 5.19141 3.94412 5.33321 4.1313C5.47617 4.31836 5.55704 4.62198 5.57344 5.04216L5.60743 6.01224C5.61797 6.28801 5.64024 6.49317 5.67656 6.62771C5.73516 6.85754 5.84063 7.00523 5.99063 7.07091V7.23342H4.79297C4.76016 7.17103 4.73321 7.09054 4.71446 6.99208C4.69453 6.89361 4.67813 6.70326 4.66524 6.4209L4.60547 5.21453C4.5832 4.74183 4.40742 4.42505 4.08047 4.26419C3.89414 4.1756 3.60117 4.1313 3.20157 4.1313H0.976172V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            id="svg-1278467936_878"
          >
            <path
              d="M3.4868 0C4.76028 0 5.70316 0.410309 6.31547 1.23105C6.79347 1.87119 7.03242 2.69016 7.03242 3.68809C7.03242 4.76815 6.75902 5.66585 6.21234 6.38154C5.57063 7.2219 4.65551 7.64208 3.46711 7.64208C2.35723 7.64208 1.48476 7.27443 0.849608 6.53911C0.28324 5.83 0 4.93382 0 3.85059C0 2.8724 0.242345 2.03534 0.726798 1.33938C1.34883 0.4465 2.26887 0 3.4868 0ZM3.585 6.76565C4.44597 6.76565 5.068 6.45698 5.45109 5.83987C5.83746 5.21947 6.03059 4.50718 6.03059 3.70289C6.03059 2.85266 5.80793 2.16823 5.36274 1.64958C4.92071 1.13094 4.31508 0.871615 3.54575 0.871615C2.79926 0.871615 2.19023 1.12929 1.71879 1.64465C1.24734 2.15671 1.01168 2.91341 1.01168 3.91463C1.01168 4.71563 1.21301 5.39184 1.61566 5.94327C2.02172 6.49152 2.67808 6.76565 3.585 6.76565Z"
              fill="black"
            />
          </svg>
          <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            id="svg-1222474147_282"
          >
            <path
              d="M1.06066 0L2.42098 5.88417L4.05141 0H5.11219L6.74262 5.88417L8.10293 0H9.17356L7.27793 7.23342H6.25149L4.58672 1.23598L2.91211 7.23342H1.88578L0 0H1.06066Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-185008150_190"
          >
            <path
              d="M5.85375 0V0.861745H3.42281V7.23342H2.43082V0.861745H0V0H5.85375Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg493993136_215"
          >
            <path
              d="M0 0H5.25961V0.886304H0.952734V3.0825H4.93547V3.91957H0.952734V6.37167H5.3332V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-1085139225_208"
          >
            <path
              d="M0 0H1.15407L4.79789 5.85961V0H5.72602V7.23342H4.6309L0.933047 1.37875V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 18"
            fill="none"
            id="svg-1767852044_607"
          >
            <path
              d="M6.42188 9.32868L9.02579 0H12.532L8.20431 12.4382C7.3711 14.8361 6.71133 16.3212 6.225 16.8937C5.73985 17.4738 4.76719 17.7639 3.30938 17.7639C3.01641 17.7639 2.78086 17.76 2.60391 17.7523C2.42578 17.7523 2.15977 17.7406 1.80469 17.7175V15.072L2.22188 15.0952C2.54532 15.1107 2.85469 15.0991 3.14766 15.0604C3.44063 15.0217 3.68789 14.9327 3.88828 14.7935C4.08047 14.662 4.2586 14.3874 4.42032 13.9697C4.59024 13.5521 4.65938 13.2968 4.62891 13.2039L0 0H3.66797L6.42188 9.32868Z"
              fill="black"
            />
          </svg>
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            id="svg1825421648_1004"
          >
            <path
              d="M11.7914 9.27063C11.707 10.0209 11.3168 10.7829 10.623 11.5564C9.54258 12.7862 8.03086 13.4012 6.08672 13.4012C4.48242 13.4012 3.0668 12.8829 1.83984 11.8465C0.61289 10.8099 0 9.12364 0 6.78762C0 4.5986 0.551956 2.91999 1.65469 1.75204C2.76563 0.583975 4.20469 0 5.9707 0C7.0207 0 7.96523 0.197283 8.80664 0.59173C9.64687 0.986178 10.3418 1.60893 10.8891 2.45974C11.3824 3.2101 11.7035 4.0803 11.85 5.07036C11.9344 5.65057 11.9695 6.486 11.9531 7.57663H3.32109C3.3668 8.84516 3.76407 9.73476 4.5129 10.2453C4.96758 10.5624 5.51602 10.7209 6.15587 10.7209C6.83555 10.7209 7.38633 10.5275 7.81055 10.1408C8.04258 9.93192 8.24649 9.64193 8.42461 9.27063H11.7914ZM8.52891 5.39525C8.47383 4.52117 8.20781 3.85988 7.72969 3.41126C7.25977 2.95489 6.67266 2.72659 5.9707 2.72659C5.20781 2.72659 4.61368 2.96641 4.18946 3.44604C3.77227 3.92556 3.50977 4.57533 3.40195 5.39525H8.52891Z"
              fill="black"
            />
          </svg>
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            id="svg-1693400435_567"
          >
            <path
              d="M5.91316 2.74985C4.79461 2.74985 4.02702 3.22549 3.61042 4.17701C3.39433 4.67979 3.2864 5.32181 3.2864 6.10307V12.9486H0V0.32477H3.18223V2.16964C3.60656 1.51986 4.00769 1.05198 4.38573 0.765747C5.0646 0.25521 5.92476 0 6.96621 0C8.27015 0 9.33421 0.344158 10.1604 1.03259C10.9936 1.71327 11.4096 2.84655 11.4096 4.43222V12.9486H8.03109V5.25601C8.03109 4.59072 7.94203 4.0803 7.76508 3.7244C7.44047 3.07474 6.82359 2.74985 5.91316 2.74985Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            id="svg2087326323_897"
          >
            <path
              d="M11.2942 2.00725C12.3588 3.34546 12.8911 4.92736 12.8911 6.75284C12.8911 8.60923 12.3588 10.1989 11.2942 11.5216C10.2295 12.8365 8.61341 13.4941 6.44555 13.4941C4.2777 13.4941 2.66156 12.8365 1.59692 11.5216C0.532267 10.1989 0 8.60923 0 6.75284C0 4.92736 0.532267 3.34546 1.59692 2.00725C2.66156 0.669163 4.2777 0 6.44555 0C8.61341 0 10.2295 0.669163 11.2942 2.00725ZM6.43395 2.79627C5.46961 2.79627 4.72524 3.14054 4.20059 3.82897C3.68368 4.50965 3.42528 5.48431 3.42528 6.75284C3.42528 8.02137 3.68368 8.99991 4.20059 9.68834C4.72524 10.3768 5.46961 10.7209 6.43395 10.7209C7.39828 10.7209 8.13891 10.3768 8.65583 9.68834C9.17274 8.99991 9.43114 8.02137 9.43114 6.75284C9.43114 5.48431 9.17274 4.50965 8.65583 3.82897C8.13891 3.14054 7.39828 2.79627 6.43395 2.79627Z"
              fill="black"
            />
          </svg>
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            id="svg466797663_450"
          >
            <path
              d="M3.32109 17.1025H0V0H5.18425L8.2855 13.4476L11.3636 0H16.4899V17.1025H13.1688V5.53458C13.1688 5.20194 13.1727 4.73781 13.1804 4.1422C13.1882 3.53884 13.192 3.07474 13.192 2.74986L9.9634 17.1025H6.50344L3.29801 2.74986C3.29801 3.07474 3.30188 3.53884 3.30961 4.1422C3.31723 4.73781 3.32109 5.20194 3.32109 5.53458V17.1025Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 18"
            fill="none"
            id="svg1460150476_230"
          >
            <path
              d="M11.7686 9.63028H3.48317V14.0277H12.9258V17.1025H0V0H12.5092V3.02833H3.48317V6.65999H11.7686V9.63028Z"
              fill="black"
            />
          </svg>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-iuc74 framer-rcOGl framer-Tt9kv framer-tx7Wz framer-5xTxc framer-SZeNn framer-7KstD framer-bpXEc framer-72rtr7 oldhome-s1"
        >
          <div className="framer-182vxlj-container">
            <div className="ssr-variant hidden-1r1r0ia">
              <nav
                className="framer-pQZYz framer-p1fggq framer-v-p1fggq oldhome-s2"
                data-border="true"
                data-framer-name="Desktop"
              >
                <div
                  className="framer-en2lv8"
                  data-framer-name="Navbar Container"
                >
                  <div className="framer-a3r2j6" data-framer-name="Navbar Left">
                    <div
                      className="framer-1ijpz5y"
                      data-framer-name="Navbar Toggle"
                    >
                      <div className="framer-izqq4v">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="scallp-new"
                          href="/old-home"
                          data-framer-page-link-current="true"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-5qwus8 framer-j3dpbz oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 123 38" className="oldhome-s5">
                              <use href="#svg816079972_6100" />
                            </svg>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-wnc1j3">
                      <div className="framer-o47kkw-container">
                        <div
                          className="framer-F05dl framer-FwhD1 framer-eyfe5u framer-v-1gph3yx"
                          data-framer-name="For Light"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-1e0tr57 oldhome-s6 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s7">
                              {/*$*/}
                              <a
                                className="framer-text framer-styles-preset-yvcldu"
                                data-styles-preset="SwZnUH4Zn"
                                href="/accounts"
                              >
                                Accounts
                              </a>
                              {/*/$*/}
                            </p>
                          </div>
                          <div
                            className="framer-fjokeb oldhome-s6 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s7">
                              {/*$*/}
                              <a
                                className="framer-text framer-styles-preset-yvcldu"
                                data-styles-preset="SwZnUH4Zn"
                                href="/scallop-pay"
                              >
                                Scallop Pay
                              </a>
                              {/*/$*/}
                            </p>
                          </div>
                          <div
                            className="framer-ch6rkz oldhome-s6 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s7">
                              {/*$*/}
                              <a
                                className="framer-text framer-styles-preset-yvcldu"
                                data-styles-preset="SwZnUH4Zn"
                                href="/cards"
                              >
                                Cards
                              </a>
                              {/*/$*/}
                            </p>
                          </div>
                          <div
                            className="framer-1x5isgd oldhome-s6 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s7">
                              {/*$*/}
                              <a
                                className="framer-text framer-styles-preset-yvcldu"
                                data-styles-preset="SwZnUH4Zn"
                                href="/helpcenter"
                              >
                                FAQs
                              </a>
                              {/*/$*/}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-srqt09"
                    data-framer-name="Navbar Right"
                  >
                    <div className="framer-15mp411-container">
                      <div
                        className="framer-wWHmH framer-ly6l8a framer-v-18roq29 oldhome-s8"
                        data-border="true"
                        data-framer-name="Variant 2"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-1ebu3nm oldhome-s9 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s10">
                            SDK Live Demo
                          </p>
                        </div>
                        <div
                          className="framer-1u4w7ze oldhome-s11 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s12">Coming soon</p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1pw58vg-container">
                      {/*$*/}
                      <a
                        className="framer-9PalM framer-6q7a9y framer-v-1p4gr52 framer-12rwjxo oldhome-s13"
                        data-border="true"
                        data-framer-name="Primary / Medium"
                        data-highlight="true"
                        href="http://www.scallopx.com/waitlist"
                        target="_blank"
                        rel="noopener"
                        tabIndex={0}
                      >
                        <div
                          className="framer-1bw53x4 oldhome-s14 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s15">Install App</p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </nav>
            </div>
            <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
              <nav
                className="framer-pQZYz framer-p1fggq framer-v-1nwqq31 oldhome-s2"
                data-border="true"
                data-framer-name="Phone"
              >
                <div
                  className="framer-en2lv8"
                  data-framer-name="Navbar Container"
                >
                  <div className="framer-a3r2j6" data-framer-name="Navbar Left">
                    <div
                      className="framer-1ijpz5y"
                      data-framer-name="Navbar Toggle"
                    >
                      <div
                        className="framer-s1gvhd"
                        data-framer-name="Navbar Icon Toggle"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-3go1oe oldhome-s16"
                          data-framer-name="Line"
                        />
                        <div
                          className="framer-1bf5lxo oldhome-s17"
                          data-framer-name="Line"
                        />
                        <div
                          className="framer-uorrz2 oldhome-s16"
                          data-framer-name="Line"
                        />
                      </div>
                      <div className="framer-izqq4v">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="scallp-new"
                          href="/old-home"
                          data-framer-page-link-current="true"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-5qwus8 framer-j3dpbz oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 123 38" className="oldhome-s5">
                              <use href="#svg816079972_6100" />
                            </svg>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-wnc1j3" />
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="framer-c85g5p">
            <div
              className="framer-1nz7gwu"
              data-framer-name="Hero Main"
              id="accounts"
            >
              <div
                className="framer-j070ew"
                data-framer-name="Hero"
                id="j070ew"
              >
                <div className="framer-18yyfs6" data-framer-name="Hero Text">
                  <div className="framer-gpu4dc" data-framer-name="Text">
                    <div className="framer-1pvlsd3">
                      <div
                        className="framer-1cvr3kg reveal"
                        data-framer-appear-id="1cvr3kg"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1
                          className="framer-text framer-styles-preset-18sajzf oldhome-s18"
                          data-styles-preset="nXmNeSqma"
                          dir="auto"
                        >
                          One account.
                        </h1>
                      </div>
                      <div className="ssr-variant hidden-cfxrig">
                        <div
                          className="framer-1ll8vs7 reveal"
                          data-framer-appear-id="1ll8vs7"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h1
                            className="framer-text framer-styles-preset-18sajzf oldhome-s19"
                            data-styles-preset="nXmNeSqma"
                            dir="auto"
                          >
                            Any currency. Anywhere.
                          </h1>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-1ll8vs7 reveal"
                          data-framer-appear-id="1ll8vs7"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h1
                            className="framer-text framer-styles-preset-18sajzf oldhome-s19"
                            data-styles-preset="nXmNeSqma"
                            dir="auto"
                          >
                            Any currency. <br className="framer-text" />
                            Anywhere.
                          </h1>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1pcz79q reveal"
                      data-framer-appear-id="1pcz79q"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s20">
                        Move money across 52+ fiat currencies, digital assets,
                        and stablecoins in one unified balance, available in
                        120+ countries.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-i0maog framer-lux5qc oldhome-s21"
                      data-border="true"
                      data-framer-appear-id="i0maog"
                      data-framer-name="Badge"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                    >
                      <div className="framer-6d9wy6 oldhome-s22" />
                      <div className="framer-15ls3v4" data-framer-name="Badge">
                        <div
                          className="framer-1cgo63n"
                          data-framer-name="_Badge base"
                        >
                          <div
                            className="framer-tyzbwf oldhome-s23 reveal"
                            data-framer-name="Text"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s24">
                              Now live
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-bd0oug" data-framer-name="Content">
                        <div
                          className="framer-73xe6z oldhome-s23 reveal"
                          data-framer-name="Message"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s25">
                            Create your account &#127881;
                          </p>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="arrow-right"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1a0rc39 oldhome-s26"
                          aria-hidden="true"
                        />
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                </div>
                <div
                  className="framer-1m40tdx"
                  data-framer-name="iPhone 16 Pro mockup black titanium bottom"
                >
                  <div className="ssr-variant">
                    <div className="framer-17rqyxf" data-framer-name="main">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="oldhome-s27"
                      >
                        <img
                          decoding="async"
                          width="1572"
                          height="2048"
                          sizes="(min-width: 1440px) 605px, (min-width: 810px) and (max-width: 1439.98px) 497px, (max-width: 809.98px) 275px"
                          srcSet="/framerusercontent.com/images/jwD9OZUhFM1jb1RRdXwuygrrQWk.png 785w,/framerusercontent.com/images/jwD9OZUhFM1jb1RRdXwuygrrQWk.png 1572w"
                          src="/framerusercontent.com/images/jwD9OZUhFM1jb1RRdXwuygrrQWk.png"
                          alt=""
                          className="oldhome-s28"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-a87zkz"
                      data-framer-name="iPhone 16 Pro mockup black titanium bottom label"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="oldhome-s27"
                      >
                        <img
                          decoding="async"
                          width="2964"
                          height="3797"
                          sizes="(min-width: 1440px) 570.3626px, (min-width: 810px) and (max-width: 1439.98px) 468px, (max-width: 809.98px) 259px"
                          srcSet="/framerusercontent.com/images/DZFXh2BpY0wpc5PhymK7s56DA.png 799w,/framerusercontent.com/images/DZFXh2BpY0wpc5PhymK7s56DA.png 1598w,/framerusercontent.com/images/DZFXh2BpY0wpc5PhymK7s56DA.png 2964w"
                          src="/framerusercontent.com/images/DZFXh2BpY0wpc5PhymK7s56DA.png"
                          alt=""
                          className="oldhome-s28"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-1b9c36p">
                  <div
                    className="framer-1oeudh1 hidden-1r1r0ia"
                    data-framer-appear-id="1oeudh1"
                    data-framer-name="Float_Tag_Amazon"
                  >
                    <div
                      className="framer-7mq1r1"
                      data-framer-name="Rectangle 474"
                    >
                      <div
                        className="framer-ot0jxg"
                        data-framer-name="Currency"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame 1437256546"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1sshtut oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 40 40" className="oldhome-s5">
                              <use href="#svg-726352421_1977" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-18842w7"
                        data-framer-name="Frame 1437256476"
                      >
                        <div className="ssr-variant hidden-cfxrig">
                          <div
                            className="framer-k7yxna oldhome-s23 reveal"
                            data-framer-name="98,269 \xA3"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s29">
                              $50 Sent to Amazon
                            </p>
                          </div>
                        </div>
                        <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                          <div
                            className="framer-k7yxna oldhome-s23 reveal"
                            data-framer-name="98,269 \xA3"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s30">
                              $50 Sent to Amazon
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1mklk10 hidden-1r1r0ia"
                    data-framer-appear-id="1mklk10"
                    data-framer-name="Arrow"
                  >
                    <div className="framer-1jqjf2n" data-framer-name="Arrow">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-l8c42e oldhome-s31"
                        aria-hidden="true"
                      >
                        <div className="svgContainer oldhome-s4">
                          <svg viewBox="0 0 52 56" className="oldhome-s5">
                            <use href="#svg764373717_1237" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig">
                    <div
                      className="framer-16drp28 hidden-1r1r0ia oldhome-s32 reveal"
                      data-framer-name="Shop, Spend,   Swap Smartly!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text oldhome-s33">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">h</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">p</span>
                          <span className="oldhome-s35">,</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">p</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">d</span>
                          <span className="oldhome-s35">,</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p className="framer-text oldhome-s33">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">w</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">p</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">m</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">y</span>
                          <span className="oldhome-s35">!</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                    <div
                      className="framer-16drp28 hidden-1r1r0ia oldhome-s32 reveal"
                      data-framer-name="Shop, Spend,   Swap Smartly!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text oldhome-s36">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">h</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">p</span>
                          <span className="oldhome-s35">,</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">p</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">d</span>
                          <span className="oldhome-s35">,</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p className="framer-text oldhome-s36">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">w</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">p</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">m</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">y</span>
                          <span className="oldhome-s35">!</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-7vqug1"
                    data-framer-appear-id="7vqug1"
                    data-framer-name="Float_Tag_Multipurporpose"
                  >
                    <div
                      className="framer-tero0v"
                      data-framer-name="Rectangle 474"
                    >
                      <div
                        className="framer-1uomhqy"
                        data-framer-name="Currency"
                      >
                        <div className="ssr-variant">
                          <div
                            className="framer-lnj93i oldhome-s37"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                width="885"
                                height="552"
                                sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 36.39px, (max-width: 809.98px) 23.55px"
                                srcSet="/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png 512w,/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png 885w"
                                src="/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="ssr-variant">
                          <div
                            className="framer-15ekuex oldhome-s39"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                width="885"
                                height="552"
                                sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 36.39px, (max-width: 809.98px) max(23.55px, 41.23px)"
                                srcSet="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 512w,/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 885w"
                                src="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="ssr-variant">
                          <div
                            className="framer-erdknb oldhome-s40"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                width="885"
                                height="552"
                                sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 36.39px, (max-width: 809.98px) 23.55px"
                                srcSet="/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png 512w,/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png 885w"
                                src="/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-v1qupc"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                        <div
                          className="framer-1k0vrtc oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s29">
                            Virtual Cards
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-1k0vrtc oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s41">
                            Virtual Cards
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-1k0vrtc oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s42">
                            Virtual Cards
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1qw4uxn"
                    data-framer-appear-id="1qw4uxn"
                    data-framer-name="Arrow"
                  >
                    <div className="framer-uj8b3t" data-framer-name="Arrow">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1uw2w2t oldhome-s31"
                        aria-hidden="true"
                      >
                        <div className="svgContainer oldhome-s4">
                          <svg viewBox="0 0 52 56" className="oldhome-s5">
                            <use href="#svg764373717_1237" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1heq9v7"
                    data-framer-appear-id="1heq9v7"
                    data-framer-name="Float_Tag_GBP"
                  >
                    <div
                      className="framer-lfajg6"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-ocpqj7"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                        <div
                          className="framer-idx2f2 oldhome-s23 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s43">
                            USD Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-idx2f2 oldhome-s23 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s44">
                            USD Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-idx2f2 oldhome-s23 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s45">
                            USD Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                        <div
                          className="framer-1udyjl oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s46">
                            $68,788
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-1udyjl oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s29">
                            $68,788
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-1udyjl oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s42">
                            $68,788
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1wtkbab" data-framer-name="Currency">
                      <div
                        className="framer-1u5suuv"
                        data-framer-name="Ellipse 133"
                      />
                      <div className="framer-1byceky" data-framer-name="Avtar">
                        <div className="ssr-variant">
                          <div
                            className="framer-1pixkta"
                            data-framer-name="Currency"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                width="204"
                                height="204"
                                src="/framerusercontent.com/images/XZ3bQjqJx8pMohQFIkYYkUzei0.png"
                                alt=""
                                className="oldhome-s47"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-wq7nrj"
                      data-framer-name="Group 1437256544"
                    >
                      <div
                        className="framer-1g4xt1n"
                        data-border="true"
                        data-framer-name="Ellipse 14984"
                      >
                        <div className="framer-c5szfs" data-framer-name="bank">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-145trlp oldhome-s3"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 14 14" className="oldhome-s5">
                                <use href="#svg-738554790_445" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1uybhxu oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 14 7" className="oldhome-s5">
                              <use href="#svg95803052_220" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-gfi4b3"
                    data-framer-appear-id="gfi4b3"
                    data-framer-name="Float_Tag_GBP"
                  >
                    <div
                      className="framer-wjkef6"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-e2daww"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                        <div
                          className="framer-1dmcaz oldhome-s23 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s43">
                            EUR Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-1dmcaz oldhome-s23 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s44">
                            EUR Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-1dmcaz oldhome-s23 reveal"
                          data-framer-name="GBP Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s45">
                            EUR Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                        <div
                          className="framer-cwr9vk oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s46">
                            &euro;25,525
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-cwr9vk oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s29">
                            &euro;25,525
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-cwr9vk oldhome-s23 reveal"
                          data-framer-name="98,269 \xA3"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s42">
                            &euro;25,525
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-kx84y4" data-framer-name="Currency">
                      <div
                        className="framer-x2qonr"
                        data-framer-name="Ellipse 133"
                      />
                      <div className="framer-qhxxvn" data-framer-name="Avtar">
                        <div className="ssr-variant">
                          <div
                            className="framer-d5w8ew"
                            data-framer-name="Currency"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                width="146"
                                height="146"
                                src="/framerusercontent.com/images/SDcV6K0w2K9frnnfTnLc7dNm2Q.png"
                                alt=""
                                className="oldhome-s47"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1pqsbr5"
                      data-framer-name="Group 1437256544"
                    >
                      <div
                        className="framer-bv2qyl"
                        data-border="true"
                        data-framer-name="Ellipse 14984"
                      >
                        <div className="framer-htbhz8" data-framer-name="bank">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-hqtb2d oldhome-s3"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 14 14" className="oldhome-s5">
                                <use href="#svg-738554790_445" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-n8lepc oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 14 7" className="oldhome-s5">
                              <use href="#svg95803052_220" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1tv52lj hidden-72rtr7 hidden-cfxrig"
                    data-framer-appear-id="1tv52lj"
                    data-framer-name="Float_Tag_GBP"
                  >
                    <div
                      className="framer-4yh3nb"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-lxqbzj"
                      data-framer-name="Frame 1437256476"
                    >
                      <div
                        className="framer-1oc2zuj oldhome-s23 reveal"
                        data-framer-name="GBP Balance"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text oldhome-s45">
                          USDC Balance
                        </p>
                      </div>
                      <div
                        className="framer-1t1e8s0 oldhome-s23 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text oldhome-s42">
                          &euro;25,525
                        </p>
                      </div>
                    </div>
                    <div className="framer-1cgei0t" data-framer-name="Currency">
                      <div
                        className="framer-ll9pgv"
                        data-framer-name="Ellipse 133"
                      />
                      <div className="framer-i3njsf" data-framer-name="Avtar">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Usdc 1"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-vhcu5r oldhome-s48"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                    <div
                      className="framer-1sbx3r3"
                      data-framer-name="Group 1437256544"
                    >
                      <div
                        className="framer-1u7cj6l"
                        data-border="true"
                        data-framer-name="Ellipse 14984"
                      >
                        <div className="framer-38mb7e" data-framer-name="bank">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Vector"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1u1a8nc oldhome-s3"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 14 14" className="oldhome-s5">
                                <use href="#svg-738554790_445" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-qmw2i4 oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 14 7" className="oldhome-s5">
                              <use href="#svg95803052_220" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-u9zjcg"
                      data-framer-appear-id="u9zjcg"
                      data-framer-name="Arrow"
                    >
                      <div className="framer-28yk45" data-framer-name="Arrow">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Group"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1xxwj03 oldhome-s49"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 59 61" className="oldhome-s5">
                              <use href="#svg147118731_1233" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      className="framer-14hfjcc hidden-cfxrig oldhome-s50 reveal"
                      data-framer-name="Multicarrecy account"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text oldhome-s51">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">M</span>
                          <span className="oldhome-s35">u</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">i</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">u</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">y</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p className="framer-text oldhome-s51">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">u</span>
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-14hfjcc hidden-cfxrig oldhome-s50 reveal"
                      data-framer-name="Multicarrecy account"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text oldhome-s52">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">M</span>
                          <span className="oldhome-s35">u</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">i</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">u</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">y</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p className="framer-text oldhome-s52">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">u</span>
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1j42pp hidden-1r1r0ia"
                    data-framer-appear-id="1j42pp"
                    data-framer-name="Float_Tag_BTC"
                  >
                    <div
                      className="framer-13425f9"
                      data-framer-name="Rectangle 474"
                    />
                    <div
                      className="framer-1j8g2vf"
                      data-framer-name="Frame 1437256476"
                    >
                      <div className="ssr-variant hidden-cfxrig">
                        <div
                          className="framer-13efny9 oldhome-s23 reveal"
                          data-framer-name="BTC Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s43">
                            USDC Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-13efny9 oldhome-s23 reveal"
                          data-framer-name="BTC Balance"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s53">
                            USDC Balance
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig">
                        <div
                          className="framer-1nhrxeo oldhome-s23 reveal"
                          data-framer-name="0.908 BTC"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s46">
                            11,569 USDC
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                        <div
                          className="framer-1nhrxeo oldhome-s23 reveal"
                          data-framer-name="0.908 BTC"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s54">
                            11,569 USDC
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-6wuh72"
                      data-framer-name="Cryptocurrency icon/Bitcoin"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Usdc 1"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-179aekt oldhome-s55"
                        aria-hidden="true"
                      />
                    </div>
                    <div
                      className="framer-b1j2iu"
                      data-border="true"
                      data-framer-name="Ellipse 14984"
                    >
                      <div className="framer-u7yzdz" data-framer-name="bank" />
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-inyupr oldhome-s3"
                        aria-hidden="true"
                      >
                        <div className="svgContainer oldhome-s4">
                          <svg viewBox="0 0 14 7" className="oldhome-s5">
                            <use href="#svg95803052_220" />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="framer-1m8wzz4"
                        data-framer-name="wallet2"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-sla8pj oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 14 11" className="oldhome-s5">
                              <use href="#svg-212988539_408" />
                            </svg>
                          </div>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-aib2y2 oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 14 14" className="oldhome-s5">
                              <use href="#svg-1448888000_2617" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-jt1s0y"
                      data-framer-appear-id="jt1s0y"
                      data-framer-name="Arrow"
                    >
                      <div className="framer-cxjm14" data-framer-name="Arrow">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Group"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-v5ofr4 oldhome-s49"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 59 61" className="oldhome-s5">
                              <use href="#svg147118731_1233" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                    <div
                      className="framer-1os0rdx oldhome-s56 reveal"
                      data-framer-name="Crypto   wallets"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s57">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">b</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">i</span>
                          <span className="oldhome-s35">n</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p dir="auto" className="framer-text oldhome-s57">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">w</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                    <div
                      className="framer-1os0rdx oldhome-s58 reveal"
                      data-framer-name="Crypto   wallets"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s57">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">b</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">i</span>
                          <span className="oldhome-s35">n</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p dir="auto" className="framer-text oldhome-s57">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">w</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-1os0rdx oldhome-s56 reveal"
                      data-framer-name="Crypto   wallets"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s59">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">S</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">b</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">i</span>
                          <span className="oldhome-s35">n</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p dir="auto" className="framer-text oldhome-s59">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">w</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">l</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">t</span>
                          <span className="oldhome-s35">s</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      className="framer-1vxwj4f oldhome-s23 reveal"
                      data-framer-name="A card for every need"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text oldhome-s51">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">A</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">d</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">f</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">r</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p className="framer-text oldhome-s51">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">v</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">y</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">d</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-1vxwj4f oldhome-s60 reveal"
                      data-framer-name="A card for every need"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s61">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">A</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">c</span>
                          <span className="oldhome-s35">a</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">d</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">f</span>
                          <span className="oldhome-s35">o</span>
                          <span className="oldhome-s35">r</span>
                        </span>{' '}
                        <span className="oldhome-s34" />
                      </p>
                      <p dir="auto" className="framer-text oldhome-s61">
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">v</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">r</span>
                          <span className="oldhome-s35">y</span>
                        </span>{' '}
                        <span className="oldhome-s34">
                          <span className="oldhome-s35">n</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">e</span>
                          <span className="oldhome-s35">d</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-j0nakm hidden-72rtr7 hidden-1r1r0ia oldhome-s62 reveal"
                    data-framer-name="Multicarrecy account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text oldhome-s51">
                      <span className="oldhome-s34">
                        <span className="oldhome-s35">M</span>
                        <span className="oldhome-s35">u</span>
                        <span className="oldhome-s35">l</span>
                        <span className="oldhome-s35">t</span>
                        <span className="oldhome-s35">i</span>
                      </span>
                    </p>
                    <p dir="auto" className="framer-text oldhome-s51">
                      <span className="oldhome-s34">
                        <span className="oldhome-s35">c</span>
                        <span className="oldhome-s35">u</span>
                        <span className="oldhome-s35">r</span>
                        <span className="oldhome-s35">r</span>
                        <span className="oldhome-s35">e</span>
                        <span className="oldhome-s35">n</span>
                        <span className="oldhome-s35">c</span>
                        <span className="oldhome-s35">y</span>
                      </span>
                    </p>
                    <p dir="auto" className="framer-text oldhome-s51">
                      <span className="oldhome-s34">
                        <span className="oldhome-s35">a</span>
                        <span className="oldhome-s35">c</span>
                        <span className="oldhome-s35">c</span>
                        <span className="oldhome-s35">o</span>
                        <span className="oldhome-s35">u</span>
                        <span className="oldhome-s35">n</span>
                        <span className="oldhome-s35">t</span>
                        <span className="oldhome-s35">s</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1y7t7eo" data-framer-name="Download Links">
              <div className="framer-7yfdbf" data-framer-appear-id="7yfdbf">
                <div className="framer-1gs2ppy" data-framer-name="Appstore">
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      data-framer-component-type="SVG"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-h4hlt5 oldhome-s63"
                      aria-hidden="true"
                    >
                      <div className="svgContainer oldhome-s4">
                        <svg className="oldhome-s64">
                          <use href="#svg1322499166_10645" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      data-framer-component-type="SVG"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-h4hlt5 oldhome-s63"
                      aria-hidden="true"
                    >
                      <div className="svgContainer oldhome-s4">
                        <svg className="oldhome-s64">
                          <use href="#svg1886773647_10415" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-1puf7d3" data-framer-name="Playstore">
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      data-framer-component-type="SVG"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1nzfv3r oldhome-s63"
                      aria-hidden="true"
                    >
                      <div className="svgContainer oldhome-s4">
                        <svg className="oldhome-s64">
                          <use href="#svg-412316951_7924" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      data-framer-component-type="SVG"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1nzfv3r oldhome-s63"
                      aria-hidden="true"
                    >
                      <div className="svgContainer oldhome-s4">
                        <svg className="oldhome-s64">
                          <use href="#svg1224668562_7717" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="framer-1dn9bga"
              data-framer-name="Cards"
              id="cardsnew"
            >
              <div
                className="framer-15trbfe oldhome-s21"
                data-framer-name="Text"
              >
                <div
                  className="framer-13hbih9 reveal"
                  data-framer-name="All thing finance, Investment right here"
                  data-framer-component-type="RichTextContainer"
                >
                  <h1
                    className="framer-text framer-styles-preset-18sajzf"
                    data-styles-preset="nXmNeSqma"
                  >
                    <span className="framer-text oldhome-s65">
                      Cards for your
                    </span>
                    <br className="framer-text" />
                    <span className="framer-text oldhome-s65">
                      everyday needs
                    </span>
                  </h1>
                </div>
                <div
                  className="framer-11relen reveal"
                  data-framer-appear-id="11relen"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                    data-styles-preset="TONoa3iGK"
                  >
                    Get the card that matches your vibe.{' '}
                  </p>
                </div>
                <div className="ssr-variant">
                  <div className="framer-18vmdq2-container">
                    {/*$*/}
                    <a
                      className="framer-9PalM framer-6q7a9y framer-v-6q7a9y framer-12rwjxo oldhome-s67"
                      data-border="true"
                      data-framer-name="Primary / Large"
                      data-highlight="true"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-1bw53x4 oldhome-s14 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s15">
                          Get your first card free
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                </div>
              </div>
              <div className="framer-hjupml" data-framer-name="card">
                <div className="ssr-variant hidden-1r1r0ia">
                  <div className="framer-1hhqn2h-container oldhome-s68">
                    <div
                      className="framer-2zHUJ framer-9dffb framer-v-9dffb oldhome-s69"
                      data-framer-name="Desktop and Tablet"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="1 silver"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-173gyvi oldhome-s3"
                        aria-hidden="true"
                      >
                        <div className="svgContainer oldhome-s4">
                          <svg viewBox="0 0 340 215" className="oldhome-s5">
                            <use href="#svg-262421025_24617" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div className="framer-1hhqn2h-container oldhome-s68">
                    <div
                      className="framer-2zHUJ framer-9dffb framer-v-9dffb oldhome-s70"
                      data-framer-name="Desktop and Tablet"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="1 silver"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-173gyvi oldhome-s3"
                        aria-hidden="true"
                      >
                        <div className="svgContainer oldhome-s4">
                          <svg viewBox="0 0 340 215" className="oldhome-s5">
                            <use href="#svg-262421025_24617" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-18ea8r6-container oldhome-s68">
                    <div
                      className="framer-oH5tc framer-k3s785 framer-v-mdmyd8 oldhome-s69"
                      data-framer-name="Variant 4"
                    >
                      <div
                        className="framer-1w62ec oldhome-s71"
                        data-framer-name="2"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="oldhome-s27"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="680"
                            height="430"
                            sizes="(min-width: 1440px) calc(546px - 8px), (min-width: 810px) and (max-width: 1439.98px) calc(546px - 8px), (max-width: 809.98px) calc(calc((100vw - 32px) * 0.9) - 8px)"
                            srcSet="/framerusercontent.com/images/oyE5TjcG03FhkI2rYeVXocvXzU.png 512w,/framerusercontent.com/images/oyE5TjcG03FhkI2rYeVXocvXzU.png 680w"
                            src="/framerusercontent.com/images/oyE5TjcG03FhkI2rYeVXocvXzU.png"
                            alt=""
                            className="oldhome-s28"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-16o6mn2-container oldhome-s68">
                    <div
                      className="framer-KM5CQ framer-1smjt6x framer-v-1sq4qag oldhome-s69"
                      data-framer-name="Variant 3"
                    >
                      <div
                        className="framer-10nuxn3"
                        data-framer-name="telegram-cloud-document-5-6336751571212178983 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="oldhome-s27"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="680"
                            height="425"
                            sizes="(min-width: 1440px) calc(546px - 8px), (min-width: 810px) and (max-width: 1439.98px) calc(546px - 8px), (max-width: 809.98px) calc(calc((100vw - 32px) * 0.9) - 8px)"
                            srcSet="/framerusercontent.com/images/N6AlYkYnsbuOJmAPI5pImLN88Q.png 512w,/framerusercontent.com/images/N6AlYkYnsbuOJmAPI5pImLN88Q.png 680w"
                            src="/framerusercontent.com/images/N6AlYkYnsbuOJmAPI5pImLN88Q.png"
                            alt=""
                            className="oldhome-s38"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-ga1b3r-container oldhome-s68">
                    <div
                      className="framer-hOjhU framer-txkpid framer-v-j9mgbf oldhome-s72"
                      data-framer-name="Variant 5"
                    >
                      <div
                        className="framer-1nd56hb"
                        data-framer-name="Group 1437256583"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="oldhome-s27"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="680"
                            height="425"
                            src="/framerusercontent.com/images/Uj6oT8ojoT2lH0jKCi5p2ccRJK4.png"
                            alt=""
                            className="oldhome-s47"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-12oy8o7" id="featuresnew">
              <div
                className="framer-k0lg9a oldhome-s21"
                data-framer-name="Text"
              >
                <div
                  className="framer-qvda40"
                  data-border="true"
                  data-framer-name="Frame 40889"
                >
                  <div
                    className="framer-1khk4r2 oldhome-s23 reveal"
                    data-framer-name="Label"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text oldhome-s73">Cards</p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia">
                  <div
                    className="framer-o8t7u5 reveal"
                    data-framer-name="All thing finance, Investment right here"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf"
                      data-styles-preset="nXmNeSqma"
                    >
                      <span className="framer-text oldhome-s65">
                        Spend Like Fiat{' '}
                      </span>
                      <br className="framer-text" />
                      <span className="framer-text oldhome-s65">
                        Send Like Email
                      </span>
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div
                    className="framer-o8t7u5 oldhome-s74 reveal"
                    data-framer-name="All thing finance, Investment right here"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1 dir="auto" className="framer-text oldhome-s75">
                      Spend Like Fiat{' '}
                      <span className="framer-text oldhome-s76">
                        <br className="framer-text" />
                      </span>
                      Send Like Email
                    </h1>
                  </div>
                </div>
                <div
                  className="framer-1pi7m9i hidden-72rtr7 hidden-cfxrig oldhome-s23 reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Get the card that matches your vibe.{' '}
                  </p>
                </div>
                <div
                  className="framer-1d5101s hidden-1r1r0ia reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                    data-styles-preset="TONoa3iGK"
                  >
                    Get the card that matches your vibe.{' '}
                  </p>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                <div className="framer-urx8gs-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-11n7dea oldhome-s77"
                    data-framer-name="Virtual_Desktop"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa oldhome-s78"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt oldhome-s79 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s80">
                              Virtual Cards
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac"
                            data-styles-preset="cN9teShfm"
                          >
                            Unlimited Virtual Cards
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 oldhome-s82 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1"
                            data-styles-preset="TONoa3iGK"
                          >
                            Single use or Multiuse create unlimited virtual
                            cards and use it wherever and however you want.
                          </p>
                        </div>
                        <div
                          className="framer-hbc9rv"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-zh08o3"
                            data-framer-name="Frame 1707479882"
                          >
                            <div
                              className="framer-hgjj6m"
                              data-framer-name="image 301"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="424"
                                  height="180"
                                  src="/framerusercontent.com/images/8lEaOABNlrC9wZT3Rfd7sGh7t5k.png"
                                  alt=""
                                  className="oldhome-s38"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-5pcsqy"
                              data-framer-name="image 300"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="850"
                                  height="347"
                                  sizes="(min-width: 1440px) 90.6982px, (min-width: 810px) and (max-width: 1439.98px) 90.6982px, (max-width: 809.98px) 77px"
                                  srcSet="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 512w,/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 850w"
                                  src="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1t8vjm6"
                              data-framer-name="image 302"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="2560"
                                  height="901"
                                  sizes="(min-width: 1440px) 105.8514px, (min-width: 810px) and (max-width: 1439.98px) 105.8514px, (max-width: 809.98px) 96px"
                                  srcSet="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 512w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 1024w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2048w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2560w"
                                  src="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-qvu6rc"
                          data-framer-name="Group 1437256480"
                        >
                          <div
                            className="framer-100v0sj oldhome-s85"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 512w,/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 759w"
                                src="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-25exl7 oldhome-s86"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 512w,/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 759w"
                                src="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-19rskbf oldhome-s87"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 512w,/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 759w"
                                src="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-gvrx6 oldhome-s88"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 512w,/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 759w"
                                src="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1d4twyu" data-framer-name="USDT">
                          <div
                            className="framer-qdz16k oldhome-s89"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-qqi32s"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z9u9i9 oldhome-s90 reveal"
                              data-framer-name="10$ onetime purchase"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s91">
                                10$ ONE-TIME PURCHASE
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1fvh94a"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1nucqyc"
                              data-framer-name="Virtual Card"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="208"
                                  height="132"
                                  src="/framerusercontent.com/images/llbpo9vv8BCYjZBV7Bqd9XtghV0.png"
                                  alt=""
                                  className="oldhome-s38"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-s2tf3i oldhome-s90 reveal"
                          data-framer-name="onetime use card for ur aunty\u2019s trip"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s92">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">O</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">e</span>
                              <span className="oldhome-s35">-</span>
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">m</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">s</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">c</span>
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">d</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">y</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">&rsquo;</span>
                              <span className="oldhome-s35">s</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">.</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-5nh4sl oldhome-s93"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-zgk9t5"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9ply1t oldhome-s94"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 40 43" className="oldhome-s5">
                                  <use href="#svg-1649909847_1240" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                <div className="framer-urx8gs-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1pueskr oldhome-s95"
                    data-framer-name="Virtual_Tablet"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa oldhome-s78"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt oldhome-s79 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s80">
                              Virtual Cards
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac oldhome-s66"
                            data-styles-preset="cN9teShfm"
                          >
                            Unlimited Virtual Cards
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 oldhome-s82 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                            data-styles-preset="TONoa3iGK"
                          >
                            Single use or Multiuse create unlimited virtual
                            cards and use it wherever and however you want.
                          </p>
                        </div>
                        <div
                          className="framer-hbc9rv"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-zh08o3"
                            data-framer-name="Frame 1707479882"
                          >
                            <div
                              className="framer-hgjj6m"
                              data-framer-name="image 301"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="424"
                                  height="180"
                                  src="/framerusercontent.com/images/8lEaOABNlrC9wZT3Rfd7sGh7t5k.png"
                                  alt=""
                                  className="oldhome-s38"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-5pcsqy"
                              data-framer-name="image 300"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="850"
                                  height="347"
                                  sizes="(min-width: 1440px) 90.6982px, (min-width: 810px) and (max-width: 1439.98px) 90.6982px, (max-width: 809.98px) 77px"
                                  srcSet="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 512w,/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 850w"
                                  src="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1t8vjm6"
                              data-framer-name="image 302"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="2560"
                                  height="901"
                                  sizes="(min-width: 1440px) 105.8514px, (min-width: 810px) and (max-width: 1439.98px) 105.8514px, (max-width: 809.98px) 96px"
                                  srcSet="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 512w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 1024w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2048w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2560w"
                                  src="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-qvu6rc"
                          data-framer-name="Group 1437256480"
                        >
                          <div
                            className="framer-100v0sj oldhome-s96"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 512w,/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 759w"
                                src="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-25exl7 oldhome-s97"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 512w,/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 759w"
                                src="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-19rskbf oldhome-s98"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 512w,/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 759w"
                                src="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-gvrx6 oldhome-s88"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 512w,/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 759w"
                                src="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1d4twyu" data-framer-name="USDT">
                          <div
                            className="framer-qdz16k oldhome-s89"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-qqi32s"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z9u9i9 oldhome-s90 reveal"
                              data-framer-name="10$ onetime purchase"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s91">
                                10$ ONE-TIME PURCHASE
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1fvh94a"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1nucqyc"
                              data-framer-name="Virtual Card"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="208"
                                  height="132"
                                  src="/framerusercontent.com/images/llbpo9vv8BCYjZBV7Bqd9XtghV0.png"
                                  alt=""
                                  className="oldhome-s38"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-s2tf3i oldhome-s90 reveal"
                          data-framer-name="onetime use card for ur aunty\u2019s trip"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s92">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">O</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">e</span>
                              <span className="oldhome-s35">-</span>
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">m</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">s</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">c</span>
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">d</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">y</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">&rsquo;</span>
                              <span className="oldhome-s35">s</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">.</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-5nh4sl oldhome-s93"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-zgk9t5"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9ply1t oldhome-s94"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 40 43" className="oldhome-s5">
                                  <use href="#svg-1649909847_1240" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                <div className="framer-urx8gs-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1th6ber oldhome-s99"
                    data-framer-name="Virtual_Phone"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-10so73z oldhome-s66"
                            data-styles-preset="LdcDCdIqD"
                          >
                            Unlimited Virtual Cards
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 oldhome-s100 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 oldhome-s101"
                            data-styles-preset="TONoa3iGK"
                          >
                            Single use or Multiuse create unlimited virtual
                            cards and use it wherever and however you want.
                          </p>
                        </div>
                        <div
                          className="framer-hbc9rv"
                          data-framer-name="Container"
                        >
                          <div
                            className="framer-zh08o3"
                            data-framer-name="Frame 1707479882"
                          >
                            <div
                              className="framer-hgjj6m"
                              data-framer-name="image 301"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="424"
                                  height="180"
                                  src="/framerusercontent.com/images/8lEaOABNlrC9wZT3Rfd7sGh7t5k.png"
                                  alt=""
                                  className="oldhome-s38"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-5pcsqy"
                              data-framer-name="image 300"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="850"
                                  height="347"
                                  sizes="(min-width: 1440px) 90.6982px, (min-width: 810px) and (max-width: 1439.98px) 90.6982px, (max-width: 809.98px) 77px"
                                  srcSet="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 512w,/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png 850w"
                                  src="/framerusercontent.com/images/rKIHDiXPOL13DGQmD4G5YHMToJs.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1t8vjm6"
                              data-framer-name="image 302"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="2560"
                                  height="901"
                                  sizes="(min-width: 1440px) 105.8514px, (min-width: 810px) and (max-width: 1439.98px) 105.8514px, (max-width: 809.98px) 96px"
                                  srcSet="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 512w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 1024w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2048w,/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png 2560w"
                                  src="/framerusercontent.com/images/pPF0rymGO8DXBkQapDrrd1NsA.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-qvu6rc"
                          data-framer-name="Group 1437256480"
                        >
                          <div
                            className="framer-100v0sj oldhome-s85"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 512w,/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png 759w"
                                src="/framerusercontent.com/images/MHI9xMJGIaCzql2NW4cn0kTU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-25exl7 oldhome-s86"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 512w,/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png 759w"
                                src="/framerusercontent.com/images/0Kn9oi70rs5qh03z0Kr7dzHRe9A.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-19rskbf oldhome-s87"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 512w,/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png 759w"
                                src="/framerusercontent.com/images/WqjXRzWAH3tTZDcghGO0zmELdzI.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-gvrx6 oldhome-s88"
                            data-framer-name="Virtual Card"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="759"
                                height="474"
                                sizes="(min-width: 1440px) 253px, (min-width: 810px) and (max-width: 1439.98px) 291.42px, (max-width: 809.98px) 152px"
                                srcSet="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 512w,/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png 759w"
                                src="/framerusercontent.com/images/alDz2BAqViEumlSMditgq5mDI4.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="framer-1d4twyu" data-framer-name="USDT">
                          <div
                            className="framer-qdz16k oldhome-s102"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-qqi32s"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z9u9i9 oldhome-s90 reveal"
                              data-framer-name="10$ onetime purchase"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s103">
                                10$ ONE-TIME PURCHASE
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1fvh94a oldhome-s104"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1nucqyc"
                              data-framer-name="Virtual Card"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  width="885"
                                  height="552"
                                  sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 36.39px, (max-width: 809.98px) max(23.55px, 41.23px)"
                                  srcSet="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 512w,/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 885w"
                                  src="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png"
                                  alt=""
                                  className="oldhome-s38"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-s2tf3i oldhome-s90 reveal"
                          data-framer-name="onetime use card for ur aunty\u2019s trip"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s92">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">O</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">e</span>
                              <span className="oldhome-s35">-</span>
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">m</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">s</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">c</span>
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">d</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">y</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">&rsquo;</span>
                              <span className="oldhome-s35">s</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">t</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">.</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-5nh4sl oldhome-s93"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-zgk9t5"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-9ply1t oldhome-s94"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 40 43" className="oldhome-s5">
                                  <use href="#svg-1649909847_1240" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                <div className="framer-1qd8xut-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-4z5m5w oldhome-s77"
                    data-framer-name="PhysicalDebit_Desktop"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa oldhome-s78"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt oldhome-s79 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s80">
                              Debit Card
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac"
                            data-styles-preset="cN9teShfm"
                          >
                            The only debit card you&rsquo;ll ever need
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 oldhome-s82 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1"
                            data-styles-preset="TONoa3iGK"
                          >
                            Pay with Scallop, at your favorite brand across 150+
                            countries
                          </p>
                        </div>
                        <div
                          className="framer-22d8qe"
                          data-framer-name="Card Services"
                        >
                          <div
                            className="framer-15rxhz3 oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-13zf8wk oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                            <div
                              className="framer-1c1hz30 oldhome-s106"
                              data-framer-name="image 285"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="256"
                                  height="256"
                                  src="/framerusercontent.com/images/YEbS9bgrcLMoOBXewv4Mfb4cKMU.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-mlgzcy oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-nyp8ce oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                            <div
                              className="framer-vfwg7s oldhome-s106"
                              data-framer-name="image 286"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="900"
                                  height="900"
                                  sizes="(min-width: 1440px) 80px, (min-width: 810px) and (max-width: 1439.98px) 80px, (max-width: 809.98px) 41.15px"
                                  srcSet="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 512w,/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 900w"
                                  src="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-6tahiw oldhome-s107"
                          data-framer-name="IPhone 17 Pro deep blue front"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              loading="lazy"
                              width="499"
                              height="1024"
                              sizes="(min-width: 1440px) 296px, (min-width: 810px) and (max-width: 1439.98px) 296px, (max-width: 809.98px) 239px"
                              srcSet="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png 499w"
                              src="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-2uhrid oldhome-s108"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-d5w481"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-7f0t3m oldhome-s109"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 48 48" className="oldhome-s5">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1fluswa oldhome-s110 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s92">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">y</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">d</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">&#129316;</span>
                            </span>
                          </p>
                        </div>
                        <div className="framer-yek321" data-framer-name="Macd">
                          <div
                            className="framer-1vicc9g oldhome-s89"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-2259xt"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z27sip oldhome-s90 reveal"
                              data-framer-name="\u20AC24 Sent to macd"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s91">
                                &euro;24 Sent to macd
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zfq5qd"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1tu420o oldhome-s111"
                              data-framer-name="Avatar"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="400"
                                  height="400"
                                  src="/framerusercontent.com/images/eg0vsCZn8Y2W4Fkzfey5deKikeE.png"
                                  alt=""
                                  className="oldhome-s47"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1n5cbj8"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-5ufwym oldhome-s112"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-14inku7 oldhome-s3"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1k01kr6"
                          data-framer-name="Amazon"
                        >
                          <div
                            className="framer-19hucm7 oldhome-s113"
                            data-framer-name="Rectangle 474"
                          >
                            <div
                              className="framer-1xkyxf2 oldhome-s106"
                              data-framer-name="Frame 1437256476"
                            >
                              <div
                                className="framer-nzae5l oldhome-s90 reveal"
                                data-framer-name="98,269 \xA3"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text oldhome-s91">
                                  $969 paid to Amazon
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1chzofe oldhome-s104"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Frame 1437256546"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1nu30nn oldhome-s3"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 40 40" className="oldhome-s5">
                                  <use href="#svg-726352421_1977" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1key5g0"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-1xkf4qi oldhome-s112"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-ddh42s oldhome-s3"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-17tmkid oldhome-s114"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-do9mfq"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-5f7nu3 oldhome-s109"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 48 48" className="oldhome-s5">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ovrbrx oldhome-s115 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s116">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">B</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">g</span>
                              <span className="oldhome-s35">h</span>
                              <span className="oldhome-s35">t</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">y</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">P</span>
                              <span className="oldhome-s35">h</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">1</span>
                              <span className="oldhome-s35">1</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">P</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">o</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">&#127881;</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                <div className="framer-1qd8xut-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1it3f3l oldhome-s95"
                    data-framer-name="PhysicalDebit_tablet"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa oldhome-s78"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt oldhome-s79 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s80">
                              Debit Card
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac oldhome-s66"
                            data-styles-preset="cN9teShfm"
                          >
                            The only debit card you&rsquo;ll ever need
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 oldhome-s82 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                            data-styles-preset="TONoa3iGK"
                          >
                            Pay with Scallop, at your favorite brand across 150+
                            countries
                          </p>
                        </div>
                        <div
                          className="framer-22d8qe"
                          data-framer-name="Card Services"
                        >
                          <div
                            className="framer-15rxhz3 oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-13zf8wk oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                            <div
                              className="framer-1c1hz30 oldhome-s106"
                              data-framer-name="image 285"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="256"
                                  height="256"
                                  src="/framerusercontent.com/images/YEbS9bgrcLMoOBXewv4Mfb4cKMU.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-mlgzcy oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-nyp8ce oldhome-s105"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                            <div
                              className="framer-vfwg7s oldhome-s106"
                              data-framer-name="image 286"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="900"
                                  height="900"
                                  sizes="(min-width: 1440px) 80px, (min-width: 810px) and (max-width: 1439.98px) 80px, (max-width: 809.98px) 41.15px"
                                  srcSet="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 512w,/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 900w"
                                  src="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-6tahiw oldhome-s107"
                          data-framer-name="IPhone 17 Pro deep blue front"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              loading="lazy"
                              width="499"
                              height="1024"
                              sizes="(min-width: 1440px) 296px, (min-width: 810px) and (max-width: 1439.98px) 296px, (max-width: 809.98px) 239px"
                              srcSet="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png 499w"
                              src="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-2uhrid oldhome-s108"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-d5w481"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-7f0t3m oldhome-s109"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 48 48" className="oldhome-s5">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1fluswa oldhome-s110 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s92">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">y</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">d</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">&#129316;</span>
                            </span>
                          </p>
                        </div>
                        <div className="framer-yek321" data-framer-name="Macd">
                          <div
                            className="framer-1vicc9g oldhome-s89"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-2259xt"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z27sip oldhome-s90 reveal"
                              data-framer-name="\u20AC24 Sent to macd"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s91">
                                &euro;24 Sent to macd
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zfq5qd"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1tu420o oldhome-s111"
                              data-framer-name="Avatar"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="400"
                                  height="400"
                                  src="/framerusercontent.com/images/eg0vsCZn8Y2W4Fkzfey5deKikeE.png"
                                  alt=""
                                  className="oldhome-s47"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1n5cbj8"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-5ufwym oldhome-s112"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-14inku7 oldhome-s3"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1k01kr6"
                          data-framer-name="Amazon"
                        >
                          <div
                            className="framer-19hucm7 oldhome-s113"
                            data-framer-name="Rectangle 474"
                          >
                            <div
                              className="framer-1xkyxf2 oldhome-s106"
                              data-framer-name="Frame 1437256476"
                            >
                              <div
                                className="framer-nzae5l oldhome-s90 reveal"
                                data-framer-name="98,269 \xA3"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text oldhome-s91">
                                  $969 paid to Amazon
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1chzofe oldhome-s104"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Frame 1437256546"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1nu30nn oldhome-s3"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 40 40" className="oldhome-s5">
                                  <use href="#svg-726352421_1977" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1key5g0"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-1xkf4qi oldhome-s112"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-ddh42s oldhome-s3"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-17tmkid oldhome-s114"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-do9mfq"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-5f7nu3 oldhome-s109"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 48 48" className="oldhome-s5">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ovrbrx oldhome-s115 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s116">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">B</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">g</span>
                              <span className="oldhome-s35">h</span>
                              <span className="oldhome-s35">t</span>
                            </span>
                          </p>
                          <p className="framer-text oldhome-s116">
                            <span className="oldhome-s34" />{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">y</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">r</span>
                            </span>
                          </p>
                          <p className="framer-text oldhome-s116">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">h</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">1</span>
                              <span className="oldhome-s35">7</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">o</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">&#127881;</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                <div className="framer-1qd8xut-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1v8dclk oldhome-s99"
                    data-framer-name="PhysicalDebit_Phone"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-10so73z oldhome-s66"
                            data-styles-preset="LdcDCdIqD"
                          >
                            The only debit card you&rsquo;ll ever need
                          </h3>
                        </div>
                        <div
                          className="framer-g8xm98 oldhome-s82 reveal"
                          data-framer-appear-id="g8xm98"
                          data-framer-name="Our solution reduces manual effort, minimizes errors, and ensures seamless coordination, allowing you to focus on what truly matters."
                          data-framer-component-type="RichTextContainer"
                        >
                          <p
                            className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                            data-styles-preset="TONoa3iGK"
                          >
                            Pay with scallop at your favorite brand across 120+
                            countries
                          </p>
                        </div>
                        <div
                          className="framer-22d8qe"
                          data-framer-name="Card Services"
                        >
                          <div
                            className="framer-15rxhz3 oldhome-s117"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-13zf8wk oldhome-s117"
                            data-border="true"
                            data-framer-name="Picture \u2192 Amazon Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/YlHsHiLlWM0hCGw1LWox6TDlU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                            <div
                              className="framer-1c1hz30 oldhome-s106"
                              data-framer-name="image 285"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="256"
                                  height="256"
                                  src="/framerusercontent.com/images/YEbS9bgrcLMoOBXewv4Mfb4cKMU.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-mlgzcy oldhome-s117"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                          <div
                            className="framer-nyp8ce oldhome-s117"
                            data-border="true"
                            data-framer-name="Picture \u2192 Nike Logotype"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="320"
                                height="320"
                                src="/framerusercontent.com/images/abDxbfKbrThaGjuI7sbCRRFrdU.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                            <div
                              className="framer-vfwg7s oldhome-s106"
                              data-framer-name="image 286"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="900"
                                  height="900"
                                  sizes="(min-width: 1440px) 80px, (min-width: 810px) and (max-width: 1439.98px) 80px, (max-width: 809.98px) 41.15px"
                                  srcSet="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 512w,/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png 900w"
                                  src="/framerusercontent.com/images/zEkQFjvcKvo4WLc3iGLnm0DLgI.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s118"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div
                          className="framer-6tahiw oldhome-s107"
                          data-framer-name="IPhone 17 Pro deep blue front"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              loading="lazy"
                              width="499"
                              height="1024"
                              sizes="(min-width: 1440px) 296px, (min-width: 810px) and (max-width: 1439.98px) 296px, (max-width: 809.98px) 239px"
                              srcSet="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png 499w"
                              src="/framerusercontent.com/images/AnUWD50QN8e0lAmzwtSCFIt4oew.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                        <div
                          className="framer-2uhrid oldhome-s108"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-d5w481"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-7f0t3m oldhome-s109"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 48 48" className="oldhome-s5">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1fluswa oldhome-s119 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text oldhome-s120">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">a</span>
                              <span className="oldhome-s35">y</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">r</span>
                            </span>{' '}
                            <span className="oldhome-s34" />
                          </p>
                          <p dir="auto" className="framer-text oldhome-s120">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">f</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">d</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">&#129316;</span>
                            </span>
                          </p>
                        </div>
                        <div className="framer-yek321" data-framer-name="Macd">
                          <div
                            className="framer-1vicc9g oldhome-s121"
                            data-framer-name="Rectangle 474"
                          />
                          <div
                            className="framer-2259xt"
                            data-framer-name="Frame 1437256476"
                          >
                            <div
                              className="framer-z27sip oldhome-s90 reveal"
                              data-framer-name="\u20AC24 Sent to macd"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s122">
                                &euro;24 Sent to macd
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-zfq5qd"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              className="framer-1tu420o oldhome-s123"
                              data-framer-name="Avatar"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="400"
                                  height="400"
                                  src="/framerusercontent.com/images/eg0vsCZn8Y2W4Fkzfey5deKikeE.png"
                                  alt=""
                                  className="oldhome-s47"
                                />
                              </div>
                            </div>
                            <div
                              className="framer-1n5cbj8"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-5ufwym oldhome-s124"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-14inku7 oldhome-s3"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1k01kr6"
                          data-framer-name="Amazon"
                        >
                          <div
                            className="framer-19hucm7 oldhome-s125"
                            data-framer-name="Rectangle 474"
                          >
                            <div
                              className="framer-1xkyxf2 oldhome-s106"
                              data-framer-name="Frame 1437256476"
                            >
                              <div
                                className="framer-nzae5l oldhome-s90 reveal"
                                data-framer-name="98,269 \xA3"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text oldhome-s122">
                                  $969 paid to Amazon
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="framer-1chzofe oldhome-s104"
                            data-framer-name="Avatar Tag"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Frame 1437256546"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1nu30nn oldhome-s3"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 40 40" className="oldhome-s5">
                                  <use href="#svg-726352421_1977" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1key5g0"
                              data-framer-name="Tag"
                            >
                              <div
                                className="framer-1xkf4qi oldhome-s126"
                                data-border="true"
                                data-framer-name="Ellipse 133"
                              />
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="Mask Group"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-ddh42s oldhome-s3"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg-484590915_1528" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-17tmkid oldhome-s127"
                          data-framer-name="Arrow"
                        >
                          <div
                            className="framer-do9mfq"
                            data-framer-name="Arrow"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="Group"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-5f7nu3 oldhome-s109"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 48 48" className="oldhome-s5">
                                  <use href="#svg86067174_1236" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ovrbrx oldhome-s115 reveal"
                          data-framer-name="pay for food \uD83E\uDD24"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text oldhome-s128">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">B</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">g</span>
                              <span className="oldhome-s35">h</span>
                              <span className="oldhome-s35">t</span>
                            </span>
                          </p>
                          <p className="framer-text oldhome-s128">
                            <span className="oldhome-s34" />{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">y</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">u</span>
                              <span className="oldhome-s35">r</span>
                            </span>
                          </p>
                          <p className="framer-text oldhome-s128">
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">i</span>
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">h</span>
                              <span className="oldhome-s35">o</span>
                              <span className="oldhome-s35">n</span>
                              <span className="oldhome-s35">e</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">1</span>
                              <span className="oldhome-s35">7</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">p</span>
                              <span className="oldhome-s35">r</span>
                              <span className="oldhome-s35">o</span>
                            </span>{' '}
                            <span className="oldhome-s34">
                              <span className="oldhome-s35">&#127881;</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                <div className="framer-19u7y3e-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1t9qie5 oldhome-s77"
                    data-framer-name="Metal_Desktop"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa oldhome-s78"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt oldhome-s79 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s80">
                              Metal Card
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac"
                            data-styles-preset="cN9teShfm"
                          >
                            Metal Means Luxury
                          </h3>
                        </div>
                        <div
                          className="framer-gxrum8"
                          data-framer-appear-id="gxrum8"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1agig2a"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-pq3waf oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ek9hc0 oldhome-s130 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Scallop Airport Companion
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-ne3n1f"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1pndt1n oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-bf9qb9 oldhome-s130"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                24 X 7 365 Days Personal Assistant
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jwr1ce"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-wvhtdo oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ycqnq6 oldhome-s130 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text oldhome-s131"
                              >
                                Travel &amp; Purchase Protection
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-kd11h4"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-983u3l oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1gb8gq oldhome-s130 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Luxury Hotel Collection
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div className="framer-1eq0uko-container oldhome-s132">
                          <div
                            className="framer-PnI6b framer-j5vylj framer-v-j5vylj"
                            data-framer-name="Default"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-gewgyh oldhome-s23"
                              data-framer-name="Front"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="1024"
                                  height="1536"
                                  sizes="(min-width: 1440px) 276px, (min-width: 810px) and (max-width: 1439.98px) 276px, (max-width: 809.98px) 276px"
                                  srcSet="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 682w,/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 1024w"
                                  src="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png"
                                  alt=""
                                  draggable={false}
                                  className="oldhome-s28"
                                />
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="icone"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-n9uqc6 oldhome-s133"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 196 196"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg829552244_2744" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-101vuox oldhome-s134"
                              data-framer-name="Back"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="354"
                                  height="530"
                                  sizes="(min-width: 1440px) 270px, (min-width: 810px) and (max-width: 1439.98px) 270px, (max-width: 809.98px) 270px"
                                  srcSet="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png 354w"
                                  src="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png"
                                  alt=""
                                  draggable={false}
                                  className="oldhome-s28"
                                />
                              </div>
                              <div
                                className="framer-1t8ekp8 oldhome-s135"
                                data-framer-name="Shadow"
                              />
                            </div>
                            <div
                              className="framer-1oc9pod-container oldhome-s23"
                              data-framer-name="Metal Card"
                              name="Metal Card"
                            >
                              {/*$*/}
                              <div className="oldhome-s136">
                                <div
                                  className="framer-epdmfj oldhome-s137"
                                  data-framer-name="Metal card"
                                  draggable={false}
                                >
                                  <div
                                    className="framer-ds4i41"
                                    data-framer-name="Black Card"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="860"
                                        height="1360"
                                        sizes="(min-width: 1440px) 216px, (min-width: 810px) and (max-width: 1439.98px) 216px, (max-width: 809.98px) 216px"
                                        srcSet="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 647w,/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 860w"
                                        src="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1jg6j5s oldhome-s138 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s139">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">T</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">v</span>
                            <span className="oldhome-s35">e</span>
                            <span className="oldhome-s35">l</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">n</span>
                            <span className="oldhome-s35">d</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">p</span>
                            <span className="oldhome-s35">u</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">h</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">s</span>
                            <span className="oldhome-s35">e</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">p</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">o</span>
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">e</span>
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">i</span>
                            <span className="oldhome-s35">o</span>
                            <span className="oldhome-s35">n</span>
                            <span className="oldhome-s35">.</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-q734dq oldhome-s140 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s139">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">C</span>
                            <span className="oldhome-s35">l</span>
                            <span className="oldhome-s35">i</span>
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">k</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">h</span>
                            <span className="oldhome-s35">e</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">d</span>
                          </span>{' '}
                          <span className="oldhome-s34" />
                        </p>
                        <p className="framer-text oldhome-s139">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">o</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">s</span>
                            <span className="oldhome-s35">e</span>
                            <span className="oldhome-s35">e</span>
                          </span>{' '}
                          <span className="oldhome-s34" />
                        </p>
                        <p className="framer-text oldhome-s139">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">h</span>
                            <span className="oldhome-s35">e</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">m</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">g</span>
                            <span className="oldhome-s35">i</span>
                            <span className="oldhome-s35">c</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-8nq8x4 oldhome-s141"
                        data-framer-name="Arrow"
                      >
                        <div
                          className="framer-1bjnj33"
                          data-framer-name="Arrow"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Group"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-xd7u9c oldhome-s94"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 40 43" className="oldhome-s5">
                                <use href="#svg-1649909847_1240" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="framer-qm8711" data-framer-name="USDT">
                        <div
                          className="framer-cmy3q8 oldhome-s89"
                          data-framer-name="Rectangle 474"
                        >
                          <div
                            className="framer-kculqn oldhome-s142"
                            data-framer-name="image 285"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 40px, (min-width: 810px) and (max-width: 1439.98px) 35.07px"
                                srcSet="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 512w,/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 1024w"
                                src="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png"
                                alt=""
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ocouue"
                          data-framer-name="Frame 1437256476"
                        >
                          <div
                            className="framer-1rd3sib oldhome-s90 reveal"
                            data-framer-name="10$ onetime purchase"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s91">
                              EXCLUSIVE SUPPORT
                            </p>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                <div className="framer-19u7y3e-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-nu57d0 oldhome-s95"
                    data-framer-name="Metal_Tablet"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-189xiwa oldhome-s78"
                          data-border="true"
                          data-framer-name="Frame 40889"
                        >
                          <div
                            className="framer-1fvwimt oldhome-s79 reveal"
                            data-framer-name="Label"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s80">
                              Metal Card
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-nhkkac oldhome-s66"
                            data-styles-preset="cN9teShfm"
                          >
                            Metal Means Luxury
                          </h3>
                        </div>
                        <div
                          className="framer-gxrum8"
                          data-framer-appear-id="gxrum8"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1agig2a"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-pq3waf oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ek9hc0 oldhome-s130 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Scallop Airport Companion
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-ne3n1f"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1pndt1n oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-bf9qb9 oldhome-s130"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                24 X 7 365 Days Personal Assistant
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jwr1ce"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-wvhtdo oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ycqnq6 oldhome-s130 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Travel &amp; Purchase Protect
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-kd11h4"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-983u3l oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1gb8gq oldhome-s130 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Luxury Hotel Collection
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div className="framer-16kcjux-container oldhome-s132">
                          <div
                            className="framer-PnI6b framer-j5vylj framer-v-j5vylj"
                            data-framer-name="Default"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-gewgyh oldhome-s23"
                              data-framer-name="Front"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="1024"
                                  height="1536"
                                  sizes="(min-width: 1440px) 276px, (min-width: 810px) and (max-width: 1439.98px) 276px, (max-width: 809.98px) 276px"
                                  srcSet="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 682w,/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 1024w"
                                  src="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png"
                                  alt=""
                                  draggable={false}
                                  className="oldhome-s28"
                                />
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="icone"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-n9uqc6 oldhome-s133"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 196 196"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg829552244_2744" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-101vuox oldhome-s134"
                              data-framer-name="Back"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="354"
                                  height="530"
                                  sizes="(min-width: 1440px) 270px, (min-width: 810px) and (max-width: 1439.98px) 270px, (max-width: 809.98px) 270px"
                                  srcSet="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png 354w"
                                  src="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png"
                                  alt=""
                                  draggable={false}
                                  className="oldhome-s28"
                                />
                              </div>
                              <div
                                className="framer-1t8ekp8 oldhome-s135"
                                data-framer-name="Shadow"
                              />
                            </div>
                            <div
                              className="framer-1oc9pod-container oldhome-s23"
                              data-framer-name="Metal Card"
                              name="Metal Card"
                            >
                              {/*$*/}
                              <div className="oldhome-s136">
                                <div
                                  className="framer-epdmfj oldhome-s137"
                                  data-framer-name="Metal card"
                                  draggable={false}
                                >
                                  <div
                                    className="framer-ds4i41"
                                    data-framer-name="Black Card"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="860"
                                        height="1360"
                                        sizes="(min-width: 1440px) 216px, (min-width: 810px) and (max-width: 1439.98px) 216px, (max-width: 809.98px) 216px"
                                        srcSet="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 647w,/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 860w"
                                        src="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1jg6j5s oldhome-s138 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s116">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">T</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">v</span>
                            <span className="oldhome-s35">e</span>
                            <span className="oldhome-s35">l</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">&amp;</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">P</span>
                            <span className="oldhome-s35">u</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">h</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">s</span>
                            <span className="oldhome-s35">e</span>
                          </span>
                        </p>
                        <p className="framer-text oldhome-s116">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">p</span>
                            <span className="oldhome-s35">r</span>
                            <span className="oldhome-s35">o</span>
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">e</span>
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">i</span>
                            <span className="oldhome-s35">o</span>
                            <span className="oldhome-s35">n</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-q734dq oldhome-s143 reveal"
                        data-framer-name="onetime use card for ur aunty\u2019s trip"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s116">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">C</span>
                            <span className="oldhome-s35">l</span>
                            <span className="oldhome-s35">i</span>
                            <span className="oldhome-s35">c</span>
                            <span className="oldhome-s35">k</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">o</span>
                          </span>{' '}
                          <span className="oldhome-s34" />
                        </p>
                        <p className="framer-text oldhome-s116">
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">s</span>
                            <span className="oldhome-s35">e</span>
                            <span className="oldhome-s35">e</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">t</span>
                            <span className="oldhome-s35">h</span>
                            <span className="oldhome-s35">e</span>
                          </span>{' '}
                          <span className="oldhome-s34">
                            <span className="oldhome-s35">m</span>
                            <span className="oldhome-s35">a</span>
                            <span className="oldhome-s35">g</span>
                            <span className="oldhome-s35">i</span>
                            <span className="oldhome-s35">c</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-8nq8x4 oldhome-s141"
                        data-framer-name="Arrow"
                      >
                        <div
                          className="framer-1bjnj33"
                          data-framer-name="Arrow"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Group"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-xd7u9c oldhome-s94"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 40 43" className="oldhome-s5">
                                <use href="#svg-1649909847_1240" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="framer-qm8711" data-framer-name="USDT">
                        <div
                          className="framer-cmy3q8 oldhome-s144"
                          data-framer-name="Rectangle 474"
                        >
                          <div
                            className="framer-kculqn oldhome-s145"
                            data-framer-name="image 285"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 40px, (min-width: 810px) and (max-width: 1439.98px) 35.07px"
                                srcSet="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 512w,/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png 1024w"
                                src="/framerusercontent.com/images/hkK3swNOwcnncttT6eRT2lOUNM.png"
                                alt=""
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-ocouue"
                          data-framer-name="Frame 1437256476"
                        >
                          <div
                            className="framer-1rd3sib oldhome-s90 reveal"
                            data-framer-name="10$ onetime purchase"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s146">
                              EXCLUSIVE SUPPORT
                            </p>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                <div className="framer-19u7y3e-container">
                  <div
                    className="framer-hfwLo framer-7KstD framer-SZeNn framer-Tt9kv framer-11n7dea framer-v-1y85s22 oldhome-s99"
                    data-framer-name="Metal_Phone"
                  >
                    <div className="framer-1fir0up" data-framer-name="Content">
                      <div
                        className="framer-91fjdy"
                        data-framer-name="Heading + Badge"
                      >
                        <div
                          className="framer-y07mob oldhome-s81 reveal"
                          data-framer-name="Automate Meeting Scheduling"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h3
                            className="framer-text framer-styles-preset-10so73z oldhome-s66"
                            data-styles-preset="LdcDCdIqD"
                          >
                            Metal Means Luxury
                          </h3>
                        </div>
                        <div
                          className="framer-gxrum8"
                          data-framer-appear-id="gxrum8"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-1agig2a"
                            data-framer-name="Frame 11"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-pq3waf oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ek9hc0 oldhome-s130 reveal"
                              data-framer-name="EUR / GBP IBAN accounts"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Scallop Airport Companion
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-ne3n1f"
                            data-framer-name="Frame 12"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-1pndt1n oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-bf9qb9 oldhome-s130"
                              data-framer-name="Swap crypto <-> fiat seamlessly"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                24 X 7 365 Days Personal Assistant
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1jwr1ce"
                            data-framer-name="Frame 14"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-wvhtdo oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-ycqnq6 oldhome-s130 reveal"
                              data-framer-name="EAL6+ security & 24/7 support"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Travel &amp; Purchase Protect
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-kd11h4"
                            data-framer-name="Frame 15"
                          >
                            <div
                              data-framer-component-type="SVG"
                              data-framer-name="SVG"
                              parentsize="0"
                              _constraints="[object Object]"
                              rotation="0"
                              shadows=""
                              className="framer-983u3l oldhome-s129"
                              aria-hidden="true"
                            >
                              <div className="svgContainer oldhome-s4">
                                <svg viewBox="0 0 18 18" className="oldhome-s5">
                                  <use href="#svg-134609349_447" />
                                </svg>
                              </div>
                            </div>
                            <div
                              className="framer-1gb8gq oldhome-s130 reveal"
                              data-framer-name="Instant KYC onboarding"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s131">
                                Luxury Hotel Collection
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <figure
                      className="framer-1074cak oldhome-s83"
                      data-framer-name="Image"
                    >
                      <div
                        className="framer-3s9qp8 oldhome-s84"
                        data-framer-name="Web_Device_SimplifiedScreen_KlarnaDebitFlexCard_PlanAPurchase_Herring_1x1_en-US"
                      >
                        <div className="framer-16kcjux-container oldhome-s132">
                          <div
                            className="framer-PnI6b framer-j5vylj framer-v-j5vylj"
                            data-framer-name="Default"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-gewgyh oldhome-s23"
                              data-framer-name="Front"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="1024"
                                  height="1536"
                                  sizes="(min-width: 1440px) 276px, (min-width: 810px) and (max-width: 1439.98px) 276px, (max-width: 809.98px) 276px"
                                  srcSet="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 682w,/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png 1024w"
                                  src="/framerusercontent.com/images/Sp1hfgUahyG4FzGFHI3mJwfHoDg.png"
                                  alt=""
                                  draggable={false}
                                  className="oldhome-s28"
                                />
                              </div>
                              <div
                                data-framer-component-type="SVG"
                                data-framer-name="icone"
                                parentsize="0"
                                _constraints="[object Object]"
                                rotation="0"
                                shadows=""
                                className="framer-n9uqc6 oldhome-s133"
                                aria-hidden="true"
                              >
                                <div className="svgContainer oldhome-s4">
                                  <svg
                                    viewBox="0 0 196 196"
                                    className="oldhome-s5"
                                  >
                                    <use href="#svg829552244_2744" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="framer-101vuox oldhome-s134"
                              data-framer-name="Back"
                              draggable={false}
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="354"
                                  height="530"
                                  sizes="(min-width: 1440px) 270px, (min-width: 810px) and (max-width: 1439.98px) 270px, (max-width: 809.98px) 270px"
                                  srcSet="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png 354w"
                                  src="/framerusercontent.com/images/Ur85VDpW7evQHVIAuypuWUYt0.png"
                                  alt=""
                                  draggable={false}
                                  className="oldhome-s28"
                                />
                              </div>
                              <div
                                className="framer-1t8ekp8 oldhome-s135"
                                data-framer-name="Shadow"
                              />
                            </div>
                            <div
                              className="framer-1oc9pod-container oldhome-s23"
                              data-framer-name="Metal Card"
                              name="Metal Card"
                            >
                              {/*$*/}
                              <div className="oldhome-s136">
                                <div
                                  className="framer-epdmfj oldhome-s137"
                                  data-framer-name="Metal card"
                                  draggable={false}
                                >
                                  <div
                                    className="framer-ds4i41"
                                    data-framer-name="Black Card"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="860"
                                        height="1360"
                                        sizes="(min-width: 1440px) 216px, (min-width: 810px) and (max-width: 1439.98px) 216px, (max-width: 809.98px) 216px"
                                        srcSet="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 647w,/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png 860w"
                                        src="/framerusercontent.com/images/S9GKpMin59QPzrZAhw4lOEkLXY.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-u01on2" data-framer-name="Security">
              <div className="framer-1muv1ob" data-framer-name="Content">
                <div className="framer-ye66kk" data-framer-name="Text">
                  <div className="framer-1aykfcr">
                    <div
                      className="framer-nm1l85"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-15v1vrp oldhome-s23 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s73">
                          Multi-currency Wallets
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1r1r0ia">
                      <div
                        className="framer-1bex3g4 oldhome-s147 reveal"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h2
                          className="framer-text framer-styles-preset-120m1vw oldhome-s19"
                          data-styles-preset="Sp_YUSQNX"
                          dir="auto"
                        >
                          Your Vault to safely store Across 52 fiat Currencies.
                        </h2>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                      <div
                        className="framer-1bex3g4 oldhome-s132 reveal"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 dir="auto" className="framer-text oldhome-s148">
                          Your Vault to safely store Across 52 fiat Currencies.
                        </h1>
                      </div>
                    </div>
                    <div
                      className="framer-l2es5w oldhome-s149 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 oldhome-s19"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        Multi currency Accounts. Fiat + Stablecoins + Digital
                        Assets.
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-tf6q7w oldhome-s107 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text oldhome-s150">
                      Enjoy Scallop services in 120+ countries
                    </p>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-115nl5b-container"
                      data-framer-name="Intro Animation "
                      name="Intro Animation "
                    >
                      <div
                        name="Intro Animation "
                        className="framer-JZvPS framer-1mo4elg framer-v-u1t6ny"
                        data-framer-name="Circle"
                        data-highlight="true"
                      >
                        <div
                          className="framer-97vvr2 oldhome-s151"
                          data-framer-name="Arm 8"
                        >
                          <div
                            className="framer-1h70u9z oldhome-s152"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="800"
                                height="800"
                                sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 83px"
                                srcSet="/framerusercontent.com/images/ka1hYjSqLAdbEd72D4ZEzJSkvk.jpeg 512w,/framerusercontent.com/images/ka1hYjSqLAdbEd72D4ZEzJSkvk.jpeg 800w"
                                src="/framerusercontent.com/images/ka1hYjSqLAdbEd72D4ZEzJSkvk.jpeg"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                            <div
                              className="framer-1nzwwtq oldhome-s153"
                              data-framer-name="Ellipse 14986"
                            >
                              <div
                                data-framer-background-image-wrapper="true"
                                className="oldhome-s27"
                              >
                                <img
                                  decoding="async"
                                  loading="lazy"
                                  width="383"
                                  height="192"
                                  src="/framerusercontent.com/images/9BrBcbl7PWAtlaDOgnVGf26Ljk.png"
                                  alt=""
                                  className="oldhome-s28"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-16mxd2 oldhome-s154"
                          data-framer-name="Arm 7"
                        >
                          <div
                            className="framer-6xyw6n oldhome-s155"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="200"
                                height="200"
                                src="/framerusercontent.com/images/bXejzZWljInlxK2DbhoV2vDNY.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-p71hv9 oldhome-s156"
                          data-framer-name="Arm 6"
                        >
                          <div
                            className="framer-132oasx oldhome-s157"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="200"
                                height="200"
                                src="/framerusercontent.com/images/qBBo7GjpnVG8U5nKzIk6hvp1TY.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-egxbhz oldhome-s158"
                          data-framer-name="Arm 5"
                        >
                          <div
                            className="framer-1ofgj2 oldhome-s159"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="200"
                                height="200"
                                src="/framerusercontent.com/images/4hbXafIb2iFXvHjrRbHq3LqMQ.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-4o8wgd oldhome-s160"
                          data-framer-name="Arm 4"
                        >
                          <div
                            className="framer-1ujjrn5 oldhome-s161"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="200"
                                height="200"
                                src="/framerusercontent.com/images/lqPvOT9KmCNiif6v7rDQXevkulM.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-92y2vq oldhome-s162"
                          data-framer-name="Arm 3"
                        >
                          <div
                            className="framer-1fz81na oldhome-s163"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="2880"
                                height="1728"
                                sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 83px"
                                srcSet="/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 512w,/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 1024w,/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 2048w,/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png 2880w"
                                src="/framerusercontent.com/images/TK1Ki5xxr4gSqmMG7hrDb61F8.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-155slis oldhome-s164"
                          data-framer-name="Arm 2"
                        >
                          <div
                            className="framer-ezgc5b oldhome-s165"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="2880"
                                height="1516"
                                sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 83px"
                                srcSet="/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 512w,/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 1024w,/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 2048w,/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png 2880w"
                                src="/framerusercontent.com/images/eauB41K1paQwfbmIrLHttlL5nUM.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1eriryg oldhome-s166"
                          data-framer-name="Arm 1"
                        >
                          <div
                            className="framer-1wn1iub oldhome-s167"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="200"
                                height="200"
                                src="/framerusercontent.com/images/cnd1lbmXaiRVFtcK6zFfVrmlphI.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1syckvf oldhome-s74"
                          data-framer-name="Arm 0"
                        >
                          <div
                            className="framer-4esxjo oldhome-s168"
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="200"
                                height="200"
                                src="/framerusercontent.com/images/JZOMIWVU0za0ONdJdxgqz0LBmE.png"
                                alt=""
                                draggable={false}
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <header className="framer-1gdfkck" data-framer-name="Container">
              <div className="framer-yy4p3b" data-framer-name="Text container">
                <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                  <div className="framer-jzmht2-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s169 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          We are building the world&rsquo;s first borderless
                          finance network.
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                  <div className="framer-jzmht2-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          We are building the world&rsquo;s first borderless
                          finance network.
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div className="framer-jzmht2-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s172 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          We are building the world&rsquo;s first borderless
                          finance network.
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                  <div className="framer-tkiefz-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s169 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          With tools to hold, spend, send, and grow your money,
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                  <div className="framer-tkiefz-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          With tools to hold, spend, send, and grow your money,
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div className="framer-tkiefz-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s172 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          With tools to hold, spend, send, and grow your money,
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                  <div className="framer-ytel7i-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s169 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          With a team of dedicated experts and a commitment{' '}
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                  <div className="framer-ytel7i-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          With a team of dedicated experts and a commitment{' '}
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div className="framer-ytel7i-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s172 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          With a team of dedicated experts and a commitment{' '}
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                  <div className="framer-1h69k82-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s169 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          with ease, transparency, and complete financial
                          freedom.
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                  <div className="framer-1h69k82-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s171 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          with ease, transparency, and complete financial
                          freedom.
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div className="framer-1h69k82-container">
                    {/*$*/}
                    <div
                      className="framer-GfRCd framer-2q3ezi framer-v-2q3ezi"
                      data-framer-name="Variant 1"
                    >
                      <div
                        className="framer-1vlmqwd oldhome-s172 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 className="framer-text oldhome-s170">
                          with ease, transparency, and complete financial
                          freedom.
                        </h1>
                      </div>
                    </div>
                    {/*/$*/}
                  </div>
                </div>
              </div>
              <div className="framer-1spdwg5" data-framer-name="Trigger">
                <div className="framer-1gkq72y" data-framer-name="1" id="1" />
                <div className="framer-1jj9qo6" data-framer-name="2" id="2" />
                <div className="framer-1fyl1jh" data-framer-name="3" id="3" />
                <div className="framer-11ad1gy" data-framer-name="4" id="4" />
                <div className="framer-i8zwgc" data-framer-name="5" id="5" />
                <div className="framer-1wu5ybz" data-framer-name="6" id="6" />
                <div className="framer-1anz8xw" data-framer-name="7" id="7" />
                <div className="framer-1th6hzs" data-framer-name="8" id="8" />
                <div className="framer-251cnq" data-framer-name="9" id="9" />
                <div className="framer-frxaxo" data-framer-name="10" id="10" />
                <div className="framer-1ot5aoj" data-framer-name="11" id="11" />
                <div className="framer-9cqwn3" data-framer-name="12" id="12" />
                <div className="framer-2suvzw" data-framer-name="13" id="13" />
                <div className="framer-ppryxg" data-framer-name="14" id="14" />
                <div className="framer-1vke83i" data-framer-name="15" id="15" />
              </div>
            </header>
            <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
              <div className="framer-jp8ooz-container" id="cards">
                <div
                  className="framer-ozTYu framer-tx7Wz framer-Tt9kv framer-4zg99p framer-v-4zg99p oldhome-s173"
                  data-framer-name="Account_Desktop"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div className="framer-k5mfe7" data-framer-name="Text">
                    <div
                      className="framer-3vwn4s oldhome-s174"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-3725gh oldhome-s175 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text oldhome-s176">
                          Accounts
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1pbmtb3 oldhome-s177 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2
                        className="framer-text framer-styles-preset-120m1vw oldhome-s178"
                        data-styles-preset="Sp_YUSQNX"
                        dir="auto"
                      >
                        ONE ACCOUNT INFINITE USE CASES
                      </h2>
                    </div>
                    <div
                      className="framer-plgyeb oldhome-s82 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        One global account for holding, swapping, and spending
                        fiat, stablecoins, and digital assets.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-t978tb framer-1jb0y36 oldhome-s179"
                      data-border="true"
                      data-framer-name="Button"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-2wog1q oldhome-s180 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s15">
                          Get your Account
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div
                    className="framer-ribg2m"
                    data-framer-name="Virtual Cards"
                  >
                    <div
                      className="framer-5puxpo"
                      data-framer-name="Iphone base"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="oldhome-s27"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="2254"
                          height="2400"
                          sizes="(min-width: 1440px) 952.7846px, (min-width: 810px) and (max-width: 1439.98px) 952.7846px, (max-width: 809.98px) 758px"
                          srcSet="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 961w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 1923w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 2254w"
                          src="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png"
                          alt=""
                          className="oldhome-s38"
                        />
                      </div>
                    </div>
                    <div className="framer-hhypyq">
                      <div className="framer-20m42c-container">
                        {/*$*/}
                        <section className="oldhome-s181">
                          <div className="oldhome-s182">
                            <ul className="oldhome-s183">
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <fieldset
                            aria-label="Slideshow pagination controls"
                            className="framer--slideshow-controls oldhome-s186"
                          >
                            <div className="oldhome-s187">
                              <button
                                type="button"
                                aria-label="Previous"
                                tabIndex={0}
                                className="oldhome-s188"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg"
                                  alt="Back Arrow"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Next"
                                tabIndex={0}
                                className="oldhome-s188"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/11KSGbIZoRSg4pjdnUoif6MKHI.svg"
                                  alt="Next Arrow"
                                />
                              </button>
                            </div>
                          </fieldset>
                        </section>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
              <div className="framer-jp8ooz-container" id="cards">
                <div
                  className="framer-ozTYu framer-tx7Wz framer-Tt9kv framer-4zg99p framer-v-z7nbr1 oldhome-s173"
                  data-framer-name="Account tablet"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div className="framer-k5mfe7" data-framer-name="Text">
                    <div
                      className="framer-3vwn4s oldhome-s174"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-3725gh oldhome-s175 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text oldhome-s176">
                          Accounts
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1pbmtb3 oldhome-s177 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2
                        className="framer-text framer-styles-preset-120m1vw oldhome-s178"
                        data-styles-preset="Sp_YUSQNX"
                        dir="auto"
                      >
                        ONE ACCOUNT INFINITE USE CASES
                      </h2>
                    </div>
                    <div
                      className="framer-plgyeb oldhome-s82 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        One global account for holding, swapping, and spending
                        fiat, stablecoins, and digital assets.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-t978tb framer-1jb0y36 oldhome-s179"
                      data-border="true"
                      data-framer-name="Button"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-2wog1q oldhome-s180 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s15">
                          Get your Account
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div
                    className="framer-ribg2m"
                    data-framer-name="Virtual Cards"
                  >
                    <div
                      className="framer-5puxpo"
                      data-framer-name="Iphone base"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="oldhome-s27"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="2254"
                          height="2400"
                          sizes="(min-width: 1440px) 952.7846px, (min-width: 810px) and (max-width: 1439.98px) 952.7846px, (max-width: 809.98px) 758px"
                          srcSet="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 961w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 1923w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 2254w"
                          src="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png"
                          alt=""
                          className="oldhome-s38"
                        />
                      </div>
                    </div>
                    <div className="framer-hhypyq">
                      <div className="framer-20m42c-container">
                        {/*$*/}
                        <section className="oldhome-s181">
                          <div className="oldhome-s182">
                            <ul className="oldhome-s183">
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <fieldset
                            aria-label="Slideshow pagination controls"
                            className="framer--slideshow-controls oldhome-s186"
                          >
                            <div className="oldhome-s187">
                              <button
                                type="button"
                                aria-label="Previous"
                                tabIndex={0}
                                className="oldhome-s188"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg"
                                  alt="Back Arrow"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Next"
                                tabIndex={0}
                                className="oldhome-s188"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/11KSGbIZoRSg4pjdnUoif6MKHI.svg"
                                  alt="Next Arrow"
                                />
                              </button>
                            </div>
                          </fieldset>
                        </section>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
              <div className="framer-jp8ooz-container" id="cards">
                <div
                  className="framer-ozTYu framer-tx7Wz framer-Tt9kv framer-4zg99p framer-v-14p0wiq oldhome-s173"
                  data-framer-name="Accounts_Phone"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div className="framer-k5mfe7" data-framer-name="Text">
                    <div
                      className="framer-3vwn4s oldhome-s174"
                      data-border="true"
                      data-framer-name="Frame 40889"
                    >
                      <div
                        className="framer-3725gh oldhome-s175 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text oldhome-s176">
                          Accounts
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1pbmtb3 oldhome-s177 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text oldhome-s189">
                        ONE ACCOUNT INFINITE USE CASES
                      </h2>
                    </div>
                    <div
                      className="framer-plgyeb oldhome-s82 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                        data-styles-preset="TONoa3iGK"
                        dir="auto"
                      >
                        One global account for holding, swapping, and spending
                        fiat, stablecoins, and digital assets.
                      </p>
                    </div>
                    {/*$*/}
                    <a
                      className="framer-t978tb framer-1jb0y36 oldhome-s179"
                      data-border="true"
                      data-framer-name="Button"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        className="framer-2wog1q oldhome-s180 reveal"
                        data-framer-name="Label"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text oldhome-s15">
                          Get your Account
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div
                    className="framer-ribg2m"
                    data-framer-name="Virtual Cards"
                  >
                    <div
                      className="framer-5puxpo"
                      data-framer-name="Iphone base"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="oldhome-s27"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="2254"
                          height="2400"
                          sizes="(min-width: 1440px) 952.7846px, (min-width: 810px) and (max-width: 1439.98px) 952.7846px, (max-width: 809.98px) 758px"
                          srcSet="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 961w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 1923w,/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png 2254w"
                          src="/framerusercontent.com/images/uk6Lkl4FZwvZS90VgrUmvGt6SWI.png"
                          alt=""
                          className="oldhome-s38"
                        />
                      </div>
                    </div>
                    <div className="framer-hhypyq">
                      <div className="framer-20m42c-container">
                        {/*$*/}
                        <section className="oldhome-s181">
                          <div className="oldhome-s182">
                            <ul className="oldhome-s183">
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="false" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-jey85k oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 512w,/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png 759w"
                                      src="/framerusercontent.com/images/NdJlrwezFY0HH6Wdja7F8rVKlM.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1l9c9ts oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251.5px, (min-width: 810px) and (max-width: 1439.98px) 251.5px, (max-width: 809.98px) 251.5px"
                                      srcSet="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 512w,/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png 759w"
                                      src="/framerusercontent.com/images/KGLIiDdyVuzDEuEz2FIPmzlR56A.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-14bmszs oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                      srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                      src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                  <div
                                    className="framer-dj8coi"
                                    data-framer-name="Virtual Card new"
                                  >
                                    <div
                                      data-framer-background-image-wrapper="true"
                                      className="oldhome-s27"
                                    >
                                      <img
                                        decoding="async"
                                        width="759"
                                        height="474"
                                        sizes="(min-width: 1440px) 251px, (min-width: 810px) and (max-width: 1439.98px) 251px, (max-width: 809.98px) 251px"
                                        srcSet="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 512w,/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png 759w"
                                        src="/framerusercontent.com/images/jy4OveZOubYHF7lLPjhwDWKmDsg.png"
                                        alt=""
                                        className="oldhome-s28"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-1rurmn9 oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 512w,/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png 759w"
                                      src="/framerusercontent.com/images/5UQ1Hf5bVLwCwZJoexzMFaeXd28.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                              <li aria-hidden="true" className="oldhome-s184">
                                <div
                                  className="framer-19oda3l oldhome-s185"
                                  data-framer-name="Virtual Card"
                                >
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="oldhome-s27"
                                  >
                                    <img
                                      decoding="async"
                                      width="759"
                                      height="474"
                                      sizes="(min-width: 1440px) 250px, (min-width: 810px) and (max-width: 1439.98px) 250px, (max-width: 809.98px) 250px"
                                      srcSet="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 512w,/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png 759w"
                                      src="/framerusercontent.com/images/3FTjlOujDDRivGNP0zLLPRYgnyg.png"
                                      alt=""
                                      className="oldhome-s38"
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <fieldset
                            aria-label="Slideshow pagination controls"
                            className="framer--slideshow-controls oldhome-s186"
                          >
                            <div className="oldhome-s187">
                              <button
                                type="button"
                                aria-label="Previous"
                                tabIndex={0}
                                className="oldhome-s188"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg"
                                  alt="Back Arrow"
                                />
                              </button>
                              <button
                                type="button"
                                aria-label="Next"
                                tabIndex={0}
                                className="oldhome-s188"
                              >
                                <img
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  src="/framerusercontent.com/images/11KSGbIZoRSg4pjdnUoif6MKHI.svg"
                                  alt="Next Arrow"
                                />
                              </button>
                            </div>
                          </fieldset>
                        </section>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="framer-4zduay"
              data-framer-name="Account type and plan"
              id="account-plans"
            >
              <section
                className="framer-18mjg5o"
                data-framer-name="Features"
                id="use-cases"
              >
                <div className="framer-10kshnl" data-framer-name="Container">
                  <header className="framer-1tvkudn" data-framer-name="Header">
                    <div className="framer-o8il4r">
                      <div className="ssr-variant hidden-1r1r0ia">
                        <div
                          className="framer-1edptmd reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h2
                            className="framer-text framer-styles-preset-120m1vw"
                            data-styles-preset="Sp_YUSQNX"
                            dir="auto"
                          >
                            Regulated accounts for
                            <br className="framer-text" />
                            global money
                          </h2>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-1edptmd reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h2 dir="auto" className="framer-text oldhome-s190">
                            <span className="framer-text oldhome-s191">
                              Regulated accounts for
                            </span>
                            <span className="framer-text oldhome-s191">
                              <br className="framer-text" />
                            </span>
                            <span className="framer-text oldhome-s191">
                              global money
                            </span>
                          </h2>
                        </div>
                      </div>
                      <div
                        className="framer-uhrhnb oldhome-s23 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                          data-styles-preset="TONoa3iGK"
                          dir="auto"
                        >
                          One account. 52+ currencies. Fiat and digital assets
                          in a unified balance.
                        </p>
                        <p
                          className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                          data-styles-preset="TONoa3iGK"
                          dir="auto"
                        >
                          Built for personal and global usage.
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1qw5igv oldhome-s23 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p
                        className="framer-text framer-styles-preset-kwaq38 oldhome-s192"
                        data-styles-preset="srRimenjh"
                        dir="auto"
                      >
                        Choose your plan
                      </p>
                    </div>
                  </header>
                  <div className="framer-11nkom5">
                    <div className="framer-6n6dne" data-framer-name="plan">
                      <div
                        className="framer-30gek1"
                        data-border="true"
                        data-framer-name="Frame 7"
                      >
                        <div className="ssr-variant">
                          <div
                            className="framer-cmshgq"
                            data-framer-name="image 1474"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 120px, (min-width: 810px) and (max-width: 1439.98px) 104px, (max-width: 809.98px) 104px"
                                srcSet="/framerusercontent.com/images/wuEylwJyB6BEcd4ndpPJhO2yDIg.png 512w,/framerusercontent.com/images/wuEylwJyB6BEcd4ndpPJhO2yDIg.png 1024w"
                                src="/framerusercontent.com/images/wuEylwJyB6BEcd4ndpPJhO2yDIg.png"
                                alt=""
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1h97qhq"
                          data-framer-name="Frame 18"
                        >
                          <div
                            className="framer-1ieov5z"
                            data-framer-name="Frame 8"
                          >
                            <div
                              className="framer-t6c58q oldhome-s23 reveal"
                              data-framer-name="Basic Account"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                className="framer-text framer-styles-preset-10so73z oldhome-s66"
                                data-styles-preset="LdcDCdIqD"
                                dir="auto"
                              >
                                Voyager
                              </h3>
                            </div>
                            <div
                              className="framer-1p772n4 oldhome-s23 reveal"
                              data-framer-name="A secure, multi-currency account to get started with regulated crypto and fiat services."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text oldhome-s193"
                              >
                                For personal money management
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-19akohi"
                            data-framer-name="Frame 17"
                          >
                            <div
                              className="framer-r0n3ag"
                              data-framer-name="Frame 11"
                            >
                              <div
                                className="framer-1rk694r"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-5sfnfa oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1of1vtu oldhome-s194 reveal"
                                data-framer-name="EUR / GBP IBAN accounts"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Manage up to 10 fiat currencies
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-12yjkqg"
                              data-framer-name="Frame 11"
                            >
                              <div
                                className="framer-1b0tc74"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-bmjqrb oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1kjmeba oldhome-s194 reveal"
                                data-framer-name="EUR / GBP IBAN accounts"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Send and receive between your own accounts
                                  only
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-dlcsya"
                              data-framer-name="Frame 12"
                            >
                              <div
                                className="framer-inm6r5"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-6kx15m oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1teu1s6 oldhome-s194"
                                data-framer-name="Swap crypto <-> fiat seamlessly"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Instant fiat and crypto swaps
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1ln0loz"
                              data-framer-name="Frame 12"
                            >
                              <div
                                className="framer-4sw2hw"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-atlqsx oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-y8zr9p oldhome-s194"
                                data-framer-name="Swap crypto <-> fiat seamlessly"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Withdraw via 10 major fiat corridors
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-n9ay95"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-14i591j"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1eb2vvz oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-dapp0d oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  No subscription fee
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1j18san"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-qdqhgz"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-npli25 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-vjojfc">
                                <div
                                  className="framer-pj5962 oldhome-s194 reveal"
                                  data-framer-name="Instant KYC onboarding"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text oldhome-s195"
                                  >
                                    Pricing
                                  </p>
                                </div>
                                <div className="framer-1ivka5">
                                  <div className="framer-1gk1i5d">
                                    <div
                                      className="framer-xf3p5l"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-1f5pmqc oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Swap fee: 1.5%
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-361xy2"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-55z8gl oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Virtual cards: $2 per card
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-zgweg4 hidden-72rtr7 hidden-1r1r0ia"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-w29v6l oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Yield: Not available
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-1ema7eu hidden-cfxrig"
                                    data-border="true"
                                    data-framer-name="Frame 17"
                                  >
                                    <div
                                      className="framer-1mmvafd oldhome-s194 reveal"
                                      data-framer-name="EUR / GBP IBAN accounts"
                                      data-framer-component-type="RichTextContainer"
                                    >
                                      <p
                                        dir="auto"
                                        className="framer-text oldhome-s196"
                                      >
                                        Yield: Not available
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-pemyse"
                        data-border="true"
                        data-framer-name="Frame 7"
                      >
                        <div className="ssr-variant">
                          <div
                            className="framer-fumqf7"
                            data-framer-name="image 1475"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 120px, (min-width: 810px) and (max-width: 1439.98px) 104px, (max-width: 809.98px) 104px"
                                srcSet="/framerusercontent.com/images/wD4LnN3sVaO1H7XpjKks3duoFxw.png 512w,/framerusercontent.com/images/wD4LnN3sVaO1H7XpjKks3duoFxw.png 1024w"
                                src="/framerusercontent.com/images/wD4LnN3sVaO1H7XpjKks3duoFxw.png"
                                alt=""
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1z0d72h"
                          data-framer-name="Frame 18"
                        >
                          <div
                            className="framer-1hfxn6"
                            data-framer-name="Frame 8"
                          >
                            <div
                              className="framer-1fbcx9x oldhome-s23 reveal"
                              data-framer-name="Basic Account"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                className="framer-text framer-styles-preset-10so73z oldhome-s66"
                                data-styles-preset="LdcDCdIqD"
                                dir="auto"
                              >
                                Mariner
                              </h3>
                            </div>
                            <div
                              className="framer-avaknu oldhome-s23 reveal"
                              data-framer-name="A secure, multi-currency account to get started with regulated crypto and fiat services."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text oldhome-s193"
                              >
                                For global payments and everyday usage
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-tgv24r"
                            data-framer-name="Frame 17"
                          >
                            <div
                              className="framer-grdcb8"
                              data-framer-name="Frame 11"
                            >
                              <div
                                className="framer-uspjka"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-17xea5 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1btis77 oldhome-s194 reveal"
                                data-framer-name="EUR / GBP IBAN accounts"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Send and receive money worldwide{' '}
                                </p>
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  (1st and 3rd party*)
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1dcm1dv"
                              data-framer-name="Frame 12"
                            >
                              <div
                                className="framer-18dft6x"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-10rxedn oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-4in35a oldhome-s194"
                                data-framer-name="Swap crypto <-> fiat seamlessly"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Access multi-currency accounts with 52+
                                  currencies (including USD, EUR, GBP, AED)
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-yc0vwn"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-1gnqhj3"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-15n2lru oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1us6269 oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Higher limits and faster processing
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1qntca7"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-a3f1y5"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-2ywyf4 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-noczg oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Order multiple debit cards with no limits
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1x2vxtg"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-12iqv2o"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-e1zb5p oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-ssqwxx oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Subscription waived with $10,000 balance
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1make5d"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-cuvnv2"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1u4xyk4 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-acnlu5">
                                <div
                                  className="framer-16sk1fz oldhome-s194 reveal"
                                  data-framer-name="Instant KYC onboarding"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text oldhome-s195"
                                  >
                                    Pricing
                                  </p>
                                </div>
                                <div className="framer-43j9h2">
                                  <div className="framer-1r12113">
                                    <div
                                      className="framer-vkckg1"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-myicxx oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          $14.99 per month
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-1te8126"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-19kxhhh oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Swap fee: 0.75%
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-dxnjxa hidden-72rtr7 hidden-1r1r0ia"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-1qhv4 oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Virtual cards: First free, then $1
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-6tks82 hidden-72rtr7 hidden-1r1r0ia"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-orlrg7 oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Yield: 0.5% APR
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="framer-ohlxxk hidden-cfxrig">
                                    <div
                                      className="framer-1qpadst"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-u8nf7x oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Virtual cards: First free, then $1
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-1rif830"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-1v2sy0w oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Yield: Coming soon
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-1bu4odk"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-myrl9s oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          *No 3rd party receive for EUR &amp;
                                          GBP
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-bf6e2k"
                        data-border="true"
                        data-framer-name="Frame 7"
                      >
                        <div className="ssr-variant">
                          <div
                            className="framer-y7x64u"
                            data-framer-name="image 1476"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="1024"
                                height="1024"
                                sizes="(min-width: 1440px) 120px, (min-width: 810px) and (max-width: 1439.98px) 104px, (max-width: 809.98px) 104px"
                                srcSet="/framerusercontent.com/images/YekSNCRWwyfH5kMUWqeJSfOZWk.png 512w,/framerusercontent.com/images/YekSNCRWwyfH5kMUWqeJSfOZWk.png 1024w"
                                src="/framerusercontent.com/images/YekSNCRWwyfH5kMUWqeJSfOZWk.png"
                                alt=""
                                className="oldhome-s28"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-rh8ngw"
                          data-framer-name="Frame 18"
                        >
                          <div
                            className="framer-33vsj4"
                            data-framer-name="Frame 8"
                          >
                            <div
                              className="framer-6xsjfk oldhome-s23 reveal"
                              data-framer-name="Basic Account"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h3
                                className="framer-text framer-styles-preset-10so73z oldhome-s66"
                                data-styles-preset="LdcDCdIqD"
                                dir="auto"
                              >
                                Admiral
                              </h3>
                            </div>
                            <div
                              className="framer-10lugxm oldhome-s23 reveal"
                              data-framer-name="A secure, multi-currency account to get started with regulated crypto and fiat services."
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text oldhome-s193"
                              >
                                For businesses and high-volume operations
                              </p>
                            </div>
                          </div>
                          <div
                            className="framer-1plye0"
                            data-framer-name="Frame 17"
                          >
                            <div
                              className="framer-h2wg2n"
                              data-framer-name="Frame 11"
                            >
                              <div
                                className="framer-12w1a5c"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1wt2f31 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1lz1kbg oldhome-s194 reveal"
                                data-framer-name="EUR / GBP IBAN accounts"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Full access to all currencies and corridors
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-h4a31g"
                              data-framer-name="Frame 12"
                            >
                              <div
                                className="framer-16zmda6"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-f1k1xy oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1htk58a oldhome-s194"
                                data-framer-name="Swap crypto <-> fiat seamlessly"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Priority payout routes and best execution
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-rt2pwe"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-vpioro"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1xu4yl3 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1yiun9i oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Unlimited virtual cards at no cost
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1plikz9"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-13vjlz7"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-15760xq oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-1t3p3ov oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Lowest fees across the platform
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-y3ovao"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-cp0s18"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-qa2vm1 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-131wskd oldhome-s194 reveal"
                                data-framer-name="Instant KYC onboarding"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text oldhome-s195"
                                >
                                  Subscription waived with $50,000 balance
                                </p>
                              </div>
                            </div>
                            <div
                              className="framer-1mvpcex"
                              data-framer-name="Frame 15"
                            >
                              <div
                                className="framer-1tpqwwk"
                                data-framer-name="Icon"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Vector"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1b2epe2 oldhome-s3"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer oldhome-s4">
                                    <svg
                                      viewBox="0 0 17 17"
                                      className="oldhome-s5"
                                    >
                                      <use href="#svg-215374271_2109" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-1dcdk45">
                                <div
                                  className="framer-1yftqs0 oldhome-s194 reveal"
                                  data-framer-name="Instant KYC onboarding"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text oldhome-s195"
                                  >
                                    Pricing
                                  </p>
                                </div>
                                <div className="framer-f6nyqh">
                                  <div className="framer-1t0aky3">
                                    <div
                                      className="framer-twcsp9"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-ede2uz oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          $49.99 per month
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-19q2w7c"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-1y27lj2 oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Swap fee: 0.4%
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="framer-1ie8my1">
                                    <div
                                      className="framer-1h15wzw"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-1yw2nx4 oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Virtual cards: Free
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="framer-shngxn"
                                      data-border="true"
                                      data-framer-name="Frame 17"
                                    >
                                      <div
                                        className="framer-lrm7q6 oldhome-s194 reveal"
                                        data-framer-name="EUR / GBP IBAN accounts"
                                        data-framer-component-type="RichTextContainer"
                                      >
                                        <p
                                          dir="auto"
                                          className="framer-text oldhome-s196"
                                        >
                                          Yield: Coming soon
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-7zj528"
                          data-border="true"
                          data-framer-name="Frame 17"
                        >
                          <div
                            className="framer-174xmkq oldhome-s194 reveal"
                            data-framer-name="EUR / GBP IBAN accounts"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s197">
                              Business
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-sv0xtk" data-framer-name="plan">
                      <div className="ssr-variant">
                        <div className="framer-1uz6702-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 oldhome-s8"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm oldhome-s9 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p dir="auto" className="framer-text oldhome-s10">
                                Explore Global Account
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze oldhome-s11 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text oldhome-s12">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="framer-bvhcwr" data-framer-name="Security">
              <div
                data-framer-background-image-wrapper="true"
                className="oldhome-s27"
              >
                <img
                  decoding="async"
                  loading="lazy"
                  width="6000"
                  height="4000"
                  sizes="(min-width: 1440px) 100vw, (min-width: 810px) and (max-width: 1439.98px) 100vw, (max-width: 809.98px) 100vw"
                  srcSet="/framerusercontent.com/images/VBC4EsGLXsHX98k7w71iuE4.jpeg 512w,/framerusercontent.com/images/VBC4EsGLXsHX98k7w71iuE4.jpeg 1024w,/framerusercontent.com/images/VBC4EsGLXsHX98k7w71iuE4.jpeg 2048w,/framerusercontent.com/images/VBC4EsGLXsHX98k7w71iuE4.jpeg 4096w,/framerusercontent.com/images/VBC4EsGLXsHX98k7w71iuE4.jpeg 6000w"
                  src="/framerusercontent.com/images/VBC4EsGLXsHX98k7w71iuE4.jpeg"
                  alt=""
                  className="oldhome-s28"
                />
              </div>
              <div className="framer-1lzzd59" data-framer-name="Text">
                <div
                  className="framer-cmlkbj"
                  data-border="true"
                  data-framer-name="Frame 40889"
                >
                  <div
                    className="framer-eijutg oldhome-s23 reveal"
                    data-framer-name="Label"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text oldhome-s198">Security</p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia">
                  <div
                    className="framer-qy3u4n reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw oldhome-s199"
                      data-styles-preset="Sp_YUSQNX"
                    >
                      Next-Gen Security for Your Digital Finance
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div
                    className="framer-qy3u4n reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2 dir="auto" className="framer-text oldhome-s200">
                      Next-Gen Security for Your Digital Finance
                    </h2>
                  </div>
                </div>
                <div
                  className="framer-5nr0x reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 oldhome-s201"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Trusted by users worldwide. Regulated in 120+ countries.
                    Compliant and KYC-ready, with regulatory coverage in the
                    USA, EU, UK, Canada, UAE, and Sri Lanka.
                  </p>
                </div>
                <div
                  className="framer-7czmx0"
                  data-framer-name="Frame 1707479881"
                >
                  <div className="framer-ihc0p9" data-framer-name="image 284">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="oldhome-s27"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="400"
                        height="136"
                        src="/framerusercontent.com/images/UhBUwcvFVKjpOs5uz7jQMlZ0M.png"
                        alt=""
                        className="oldhome-s38"
                      />
                    </div>
                  </div>
                  <div className="framer-1rw22l6" data-framer-name="image 299">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="oldhome-s27"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="750"
                        height="744"
                        sizes="(min-width: 1440px) 36.23px, (min-width: 810px) and (max-width: 1439.98px) 36.23px, (max-width: 809.98px) 36.23px"
                        srcSet="/framerusercontent.com/images/gp0TjCd9gqFbsK79F3Pt4g3GCJw.png 512w,/framerusercontent.com/images/gp0TjCd9gqFbsK79F3Pt4g3GCJw.png 750w"
                        src="/framerusercontent.com/images/gp0TjCd9gqFbsK79F3Pt4g3GCJw.png"
                        alt=""
                        className="oldhome-s28"
                      />
                    </div>
                  </div>
                  <div className="framer-sgof26" data-framer-name="image 287">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="oldhome-s27"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="1200"
                        height="706"
                        sizes="(min-width: 1440px) 47.75px, (min-width: 810px) and (max-width: 1439.98px) 47.75px, (max-width: 809.98px) 47.75px"
                        srcSet="/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png 512w,/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png 1024w,/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png 1200w"
                        src="/framerusercontent.com/images/ceJ7IUrDQn38H8MrF2yUeVEXCAo.png"
                        alt=""
                        className="oldhome-s28"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-19me7yo" data-framer-name="Container">
                <div className="framer-jrea26" data-framer-name="Container">
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      className="framer-1k4f8oz oldhome-s194 reveal"
                      data-framer-name="Virtual Cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h3
                        className="framer-text framer-styles-preset-nhkkac oldhome-s199"
                        data-styles-preset="cN9teShfm"
                      >
                        Biometric &amp; Hardware <br className="framer-text" />
                        Security
                      </h3>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-1k4f8oz oldhome-s194 reveal"
                      data-framer-name="Virtual Cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h4 dir="auto" className="framer-text oldhome-s202">
                        Biometric &amp; Hardware{' '}
                        <span className="framer-text oldhome-s76">
                          <br className="framer-text" />
                        </span>
                        Security
                      </h4>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      className="framer-113530q oldhome-s194 reveal"
                      data-framer-name="Single-use / multi-use / unlimited virtual cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s203">
                        Log in effortlessly with Face ID or fingerprint for
                        instant access and protection. Your account stays
                        ultra-secure at all times.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-113530q oldhome-s194 reveal"
                      data-framer-name="Single-use / multi-use / unlimited virtual cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s204">
                        Log in effortlessly with Face ID or fingerprint for
                        instant access and protection. Your account stays
                        ultra-secure at all times.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-mpy7t6"
                  data-framer-name="SecurityComponents"
                >
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      className="framer-nz5pba oldhome-s194 reveal"
                      data-framer-name="Virtual Cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h3
                        className="framer-text framer-styles-preset-nhkkac oldhome-s199"
                        data-styles-preset="cN9teShfm"
                        dir="auto"
                      >
                        E Money Network
                      </h3>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-nz5pba oldhome-s194 reveal"
                      data-framer-name="Virtual Cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h3 dir="auto" className="framer-text oldhome-s202">
                        E Money Network
                      </h3>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia">
                    <div
                      className="framer-q89m5l oldhome-s194 reveal"
                      data-framer-name="Single-use / multi-use / unlimited virtual cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s203">
                        A strategic partner of Scallop, E Money Network is a
                        public permissioned Layer 1 chain designed to bring
                        compliance and security to digital finance. Built for
                        BankFi, PayFi, and RWAs, it features on chain KYC and
                        native eEUR minting.
                      </p>
                      <p dir="auto" className="framer-text oldhome-s203">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-1xun9x3"
                          data-styles-preset="AVnlSva1W"
                          href="https://emoney.io/"
                          target="_blank"
                          rel="noopener"
                        >
                          Read more
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-q89m5l oldhome-s194 reveal"
                      data-framer-name="Single-use / multi-use / unlimited virtual cards"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text oldhome-s204">
                        A strategic partner of Scallop, E Money Network is a
                        public permissioned Layer 1 chain designed to bring
                        compliance and security to digital finance. Built for
                        BankFi, PayFi, and RWAs, it features on chain KYC and
                        native eEUR minting.
                      </p>
                      <p dir="auto" className="framer-text oldhome-s204">
                        {/*$*/}
                        <a
                          className="framer-text framer-styles-preset-1xun9x3"
                          data-styles-preset="AVnlSva1W"
                          href="https://emoney.io/"
                          target="_blank"
                          rel="noopener"
                        >
                          Read more
                        </a>
                        {/*/$*/}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-narcf9" />
            </div>
            <div className="framer-bp48fb" data-framer-name="FAQ" id="faqs">
              <div className="framer-1i4az19" data-framer-name="Text">
                <div
                  className="framer-bh77yb"
                  data-border="true"
                  data-framer-name="Frame 40889"
                >
                  <div
                    className="framer-1bw8up5 oldhome-s23 reveal"
                    data-framer-name="Label"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text oldhome-s205">QnA</p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1r1r0ia">
                  <div
                    className="framer-1kpkboa reveal"
                    data-framer-name="Title"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Frequently Asked Questions
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                  <div
                    className="framer-1kpkboa reveal"
                    data-framer-name="Title"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2 className="framer-text oldhome-s206">
                      FrequentLY
                      <br className="framer-text" />
                      Asked Questions
                    </h2>
                  </div>
                </div>
                <div
                  className="framer-c5yjge reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                    data-styles-preset="TONoa3iGK"
                    dir="auto"
                  >
                    Never be in doubt. Ask any questions you may have.
                  </p>
                </div>
              </div>
              <div className="ssr-variant">
                <div className="framer-x3q8cy-container">
                  <div
                    className="framer-YkoZz framer-6lrbie framer-v-6lrbie oldhome-s69"
                    data-framer-name="FAQs"
                  >
                    <div className="framer-3tjcxc-container">
                      <div
                        className="framer-3HYEH framer-2bq5i1 framer-v-5oim9t oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-13rhdmz"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-cx3vwk oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              How long does it take to open an account?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-bi4uf5"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-1fxario-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-1dyrfwr oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-1wefibd oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s212">
                              Most Scallop accounts can be opened in just a few
                              minutes using our fast, AI-powered verification.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-129fdeq-container">
                      <div
                        className="framer-6n5jq framer-1yqm54p framer-v-rvxee2 oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-w8fkjg"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-tf7hdx oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              Is there a virtual card option?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-1nb39y9"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-1bc2grd-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-zu6ub8 oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-f967u1 oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s213">
                              Definitely. Scallop offers virtual cards for
                              online shopping, single-use purchases, and
                              subscription management.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-8l17ia-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              Can I send money internationally?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s213">
                              Absolutely. Scallop lets you send money worldwide,
                              either via local networks or the SWIFT system,
                              depending on your needs.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1isx56l-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              Can I have accounts in different currencies?
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s213">
                              Yes! Your KYC-approved account gives you access to
                              a wide range of currencies, all under one profile,
                              making it easy to manage global finances.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-2mppbq-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              Does the Scallop card work with Apple Pay and
                              Google Pay?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s213">
                              Yes! Both virtual and physical cards can be added
                              to Apple Pay and Google Pay for tap-and-go
                              convenience.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1ibrmso-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              What currencies can I exchange with Scallop?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s213">
                              A Scallop account lets you instantly swap between
                              popular fiat currencies, stablecoins, and digital
                              assets. Learn more in our FAQ section.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1llnln2-container">
                      <div
                        className="framer-muJe1 framer-d644po framer-v-13csnqp oldhome-s207"
                        data-border="true"
                        data-framer-name="Closed"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div
                          className="framer-bqqcvu"
                          data-framer-name="Title"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-156tt9j oldhome-s208 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h4 className="framer-text oldhome-s209">
                              Is my money protected in Scallop accounts?{' '}
                            </h4>
                          </div>
                          <div
                            className="framer-t4v3jt"
                            data-framer-name="Spacer"
                          />
                          <div className="framer-gi6sn9-container oldhome-s23">
                            {/*$*/}
                            <div className="oldhome-s184" />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-58kdf oldhome-s210"
                          data-framer-name="Content"
                        >
                          <div
                            className="framer-sxj0tf oldhome-s211 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s213">
                              Absolutely. Funds are safeguarded under strict
                              e-money regulations and kept separate from
                              Scallop&rsquo;s company funds.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-bgrlmj" data-framer-name="Partners">
              <div className="framer-1ihse69" data-framer-name="Partners">
                <div
                  className="framer-1ndfciz oldhome-s23 reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p className="framer-text oldhome-s214">
                    Our trusted partners
                  </p>
                </div>
                <div className="framer-by8cgh-container">
                  {/*$*/}
                  <section className="oldhome-s215">
                    <ul className="oldhome-s216">
                      <li>
                        <div
                          className="framer-16fqhdp oldhome-s217"
                          data-framer-name="image 270"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="492"
                              height="160"
                              src="/framerusercontent.com/images/ivSPK23J9RR1a4Hco5h0JeDko.png"
                              alt=""
                              className="oldhome-s38"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-s0p148 oldhome-s217"
                          data-framer-name="image 273"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="480"
                              height="160"
                              src="/framerusercontent.com/images/moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                              alt=""
                              className="oldhome-s38"
                            />
                          </div>
                          <div
                            className="framer-1899q9m"
                            data-framer-name="Item \u2192 image 273 \u2192 moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="oldhome-s27"
                            >
                              <img
                                decoding="async"
                                width="480"
                                height="160"
                                src="/framerusercontent.com/images/VsSBYBESvevipPgqh18FJ54Fezw.png"
                                alt=""
                                className="oldhome-s38"
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1k9j3o0 oldhome-s217"
                          data-framer-name="image 293"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="548"
                              height="168"
                              sizes="(min-width: 1440px) 137px, (min-width: 810px) and (max-width: 1439.98px) 137px, (max-width: 809.98px) 137px"
                              srcSet="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 512w,/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 548w"
                              src="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png"
                              alt=""
                              className="oldhome-s38"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-kj6rdu oldhome-s217"
                          data-framer-name="SWIFT logo.svg"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="1280"
                              sizes="(min-width: 1440px) 139px, (min-width: 810px) and (max-width: 1439.98px) 139px, (max-width: 809.98px) 139px"
                              srcSet="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 512w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1024w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1280w"
                              src="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </section>
                  {/*/$*/}
                </div>
              </div>
            </div>
            <div className="framer-1il6vym" data-framer-name="CTA">
              <div
                className="framer-110guhe"
                data-border="true"
                data-framer-name="Frame 1437256478"
              >
                <div className="framer-85vgzo" data-framer-name="CTA">
                  <div className="framer-sf50ar" data-framer-name="Text">
                    <div className="framer-1opxq3r">
                      <div className="ssr-variant hidden-1r1r0ia">
                        <div
                          className="framer-25z0q4 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h2
                            className="framer-text framer-styles-preset-120m1vw"
                            data-styles-preset="Sp_YUSQNX"
                            dir="auto"
                          >
                            GET YOUR SCALLOP ACCOUNT IN MINUTES
                          </h2>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                        <div
                          className="framer-25z0q4 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <h2 dir="auto" className="framer-text oldhome-s218">
                            GET YOUR SCALLOP ACCOUNT IN MINUTES
                          </h2>
                        </div>
                      </div>
                      <div
                        className="framer-com453 reveal"
                        data-framer-name="Descriptions"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-1rfjbe1 oldhome-s66"
                          data-styles-preset="TONoa3iGK"
                          dir="auto"
                        >
                          Join a growing network of partners and customers
                          already thriving with Scallop.
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-c4i9b6-container">
                        {/*$*/}
                        <a
                          className="framer-9PalM framer-6q7a9y framer-v-6q7a9y framer-12rwjxo oldhome-s219"
                          data-border="true"
                          data-framer-name="Primary / Large"
                          data-highlight="true"
                          href="https://www.scallopx.com/waitlist/"
                          target="_blank"
                          rel="noopener"
                          tabIndex={0}
                        >
                          <div
                            className="framer-1bw53x4 oldhome-s14 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text oldhome-s15">
                              Open an Account
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                    <div
                      className="framer-r0f7h5"
                      data-framer-name="Mask group"
                    >
                      <div
                        className="framer-rwn4dj"
                        data-framer-name="Account tokens_2 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="oldhome-s27"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="3585"
                            height="1348"
                            sizes="(min-width: 1440px) 1002px, (min-width: 810px) and (max-width: 1439.98px) max(100vw - 160px, 1px), (max-width: 809.98px) 409px"
                            srcSet="/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 512w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 1024w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 2048w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 3585w"
                            src="/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png"
                            alt=""
                            className="oldhome-s47"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                    <div
                      className="framer-r0f7h5"
                      data-framer-name="Mask group"
                    >
                      <div
                        className="framer-rwn4dj"
                        data-framer-name="Account tokens_2 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="oldhome-s27"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="3585"
                            height="1348"
                            sizes="(min-width: 1440px) 1002px, (min-width: 810px) and (max-width: 1439.98px) max(100vw - 160px, 1px), (max-width: 809.98px) 409px"
                            srcSet="/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 512w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 1024w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 2048w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 3585w"
                            src="/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png"
                            alt=""
                            className="oldhome-s47"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                    <div
                      className="framer-r0f7h5"
                      data-framer-name="Mask group"
                    >
                      <div
                        className="framer-rwn4dj"
                        data-framer-name="Account tokens_2 1"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="oldhome-s27"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="3585"
                            height="1348"
                            sizes="(min-width: 1440px) 1002px, (min-width: 810px) and (max-width: 1439.98px) max(100vw - 160px, 1px), (max-width: 809.98px) 409px"
                            srcSet="/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 512w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 1024w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 2048w,/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png 3585w"
                            src="/framerusercontent.com/images/wpomaODRuwLlUFmNegBzu7JCK5c.png"
                            alt=""
                            className="oldhome-s47"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1bi79jq">
              <div className="ssr-variant hidden-cfxrig hidden-1r1r0ia">
                <div className="framer-1ag18il-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-1rilglu oldhome-s220"
                    data-framer-name="Desktop"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 699 196" className="oldhome-s5">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k oldhome-s221 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s222">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko oldhome-s3"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 20 20" className="oldhome-s5">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb oldhome-s226 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s227">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu oldhome-s228"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab oldhome-s229"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1r1r0ia hidden-72rtr7">
                <div className="framer-1ag18il-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-183e6ee oldhome-s220"
                    data-framer-name="Tablet"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 699 196" className="oldhome-s5">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k oldhome-s221 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s222">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko oldhome-s3"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 20 20" className="oldhome-s5">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb oldhome-s226 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s227">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu oldhome-s228"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab oldhome-s229"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-cfxrig hidden-72rtr7">
                <div className="framer-1ag18il-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-ltf6f8 oldhome-s220"
                    data-framer-name="Mobile"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 oldhome-s3"
                          aria-hidden="true"
                        >
                          <div className="svgContainer oldhome-s4">
                            <svg viewBox="0 0 699 196" className="oldhome-s5">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k oldhome-s221 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s222">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="oldhome-s27"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="oldhome-s28"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks oldhome-s223 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s224">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb oldhome-s223 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text oldhome-s225">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko oldhome-s3"
                            aria-hidden="true"
                          >
                            <div className="svgContainer oldhome-s4">
                              <svg viewBox="0 0 20 20" className="oldhome-s5">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb oldhome-s226 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text oldhome-s227">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu oldhome-s228"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab oldhome-s229"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-1xh35y0-container">
            {/*$*/}
            {/*/$*/}
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default OldHome;
